export const values = {
    aumico_reports_side_bar_feedback: 'Feedback',
    aumico_admin_navigation_feedback: 'Feedback',
    aumico_alert_duplicate_prior_year_title:
        '<strong>Prior Year Data Missing for Duplicate Accounts Important:</strong>',
    aumico_alert_duplicate_prior_year_main_warning:
        'We have detected that your file contains accounts that were duplicated in the prior year (same number/name) and cannot be uniquely mapped to a prior year value.',
    aumico_alert_duplicate_prior_year_action_integrity:
        'To ensure these accounts receive the correct prior year value and maintain data integrity, we require an <strong>explicit match</strong> for this value.',
    aumico_alert_duplicate_prior_year_action_required:
        '<strong>Required Action:</strong> Please include a separate column in your upload file that contains the correct prior year values for these specific accounts. This is the only way we can ensure accurate mapping. Please correct this and start the upload again.',
    aumico_alert_fixed_balance_sheet:
        'Fixed using column <strong>{{priorYearUnmatchableAccountsDetectedBalanceFixedColNo}}</strong> for <strong>balance sheet</strong>.',
    aumico_alert_fixed_income_statement:
        'Fixed using column <strong>{{priorYearUnmatchableAccountsDetectedIncomeFixedColNo}}</strong> for <strong>income statement</strong>.',
    aumico_templates_account_mapping_child_form_summarize_error_mapped_account:
        'Cannot summarize accounts because at least one account with the same account number is already mapped. Please remove this mapping and try again.',
    aumico_release_slide_1_html: `
        <h2>Abacus and Business Central Integration</h2>
        <p>With the native integrations for Abacus and Microsoft Dynamics 365 Business Central, you import the accounting journal of your clients directly into aumico. No manual CSV export, no Excel detour. You set up the connection once, after that it stays active.</p>
        <ul>
            <li><strong>One-time setup</strong> — Set up the connection per client once, after that the import runs automatically</li>
            <li><strong>Automatic data import</strong> — Accounting journal, account balances, balance sheet and income statement are built directly in aumico</li>
            <li><strong>No manual steps</strong> — No manual export from Abacus or Business Central, no preparation in Excel</li>
        </ul>
    `,

    aumico_release_slide_2_html: `
        <h2>Multi-Year Comparison</h2>
        <p>In the new Analytics tab in the company profile, you compare a client's figures across any number of years. aumico applies the most recent report structure to all historical years. The series stay consistent, even if the balance sheet or income statement changed in between.</p>
        <ul>
            <li><strong>Any number of years</strong> — You define the period, three, five or more years</li>
            <li><strong>Harmonized structure</strong> — The most recent structure serves as the master, older structures are mapped onto it automatically</li>
            <li><strong>No extra effort</strong> — Based on the data already in aumico. No re-entry, no Excel</li>
        </ul>
    `,

    aumico_release_slide_3_html: `
        <h2>Reclassifications directly in Account Mapping</h2>
        <p>You now enter reclassifications directly in the account mapping, in the Reclassification / Rename tab. Click the amount, pick the target account, set the amount. aumico books the counter entry automatically. Commercial reclassifications are clearly separated from tax-related hidden reserves.</p>
        <ul>
            <li><strong>Always balanced</strong> — Every reclassification has a source and a target account, unbalanced entries are impossible</li>
            <li><strong>Current year and previous year</strong> — Both periods in the same table view, same logic</li>
            <li><strong>Create the target account on the fly</strong> — If the account is missing, you create it in the dialog without cancelling the reclassification</li>
            <li><strong>All reports recalculate immediately</strong> — Reclassified amounts automatically flow into the cash flow statement, notes, appropriation of profits, equity movement schedule and fixed assets schedule</li>
        </ul>
    `,

    aumico_release_slide_4_html: `
        <h2>All Report Elements in Interim Closings</h2>
        <p>Quarterly, monthly and custom reports now offer the same range of elements as the annual report. Balance sheet, income statement, notes and every other element are available. Same templates, regardless of report type.</p>
        <ul>
            <li><strong>Full range of elements</strong> — Notes and all other elements also in the interim closing</li>
            <li><strong>Same templates</strong> — The template you choose delivers exactly what it says in every report type</li>
        </ul>
    `,
    aumico_annual_report_print_options_show_grouped_and_masked: 'Apply Grouping & Masking',
    aumico_reports_annualreport_navigation_import_grouping_masking: 'Reclassify / Group Accounts',
    aumico_grouping_masking_assets: '(Assets)',
    aumico_grouping_masking_liabilities: '(Liabilities)',
    aumico_grouping_masking_splitted: 'Split',
    aumico_grouping_masking_edit_group_name: 'Edit Group Name',
    aumico_grouping_masking_define_bsa: 'Define as Balance Switch Account',
    aumico_grouping_masking_remove_bsa: 'Remove Balance Switch Account',
    aumico_grouping_masking_ungroup: 'Ungroup Accounts',
    aumico_grouping_masking_remove_from_group: 'Remove account from group',
    aumico_grouping_masking_remove_original_name: 'Original Name: {{value}}',
    aumico_grouping_masking_rename_modal_title: 'Mask Account Names',
    aumico_grouping_masking_rename_modal_text:
        'Enter a new display name for the selected accounts. This change is visual only and will not affect the account mapping.',
    aumico_grouping_masking_rename_modal_label_original: 'Original Account',
    aumico_grouping_masking_rename_modal_label_new: 'New Display Name',
    aumico_grouping_masking_rename_modal_label_placeholder: 'Enter new display name',
    aumico_grouping_masking_rename_modal_label_delete: 'Remove masking',
    aumico_grouping_masking_modal_apply: 'Apply',
    aumico_grouping_masking_modal_cancel: 'Cancel',
    aumico_grouping_masking_grouping_modal_title: 'Group Accounts',
    aumico_grouping_masking_grouping_modal_text: 'Name of Group',
    aumico_grouping_masking_grouping_modal_label_placeholder: 'Enter group name',
    aumico_grouping_masking_split_modal_title: 'Switch Accounts',
    aumico_grouping_masking_split_modal_title_start: 'STARTING POSITION',
    aumico_grouping_masking_split_modal_title_output: 'PREVIEW OUTPUT',
    aumico_grouping_masking_split_modal_title_counterpart: 'Where do you want to assign the account?',
    aumico_grouping_masking_split_modal_title_counterpart_placeholder: 'Choose financial line item',
    aumico_grouping_masking_modal_confirm: "Yes, I'm sure",
    aumico_grouping_masking_modal_dismiss: 'No, cancel',
    aumico_grouping_masking_bulk_action_group: 'Group',
    aumico_grouping_masking_bulk_action_rename: 'Rename',
    aumico_grouping_masking_bulk_action_delete: 'Delete',
    aumico_grouping_masking_bulk_action_accounts_selected: 'Accounts selected',
    aumico_grouping_masking_confirm_ungroup_text: 'Are you sure you want to ungroup the accounts from group {{value}}?',
    aumico_grouping_masking_confirm_unsplitt_text: 'Are you sure you want to unsplit the grouped account {{value}}?',

    // REV-20899: Reclassification feature
    aumico_grouping_masking_reclass_column_header_cy: 'Reclassification CY',
    aumico_grouping_masking_reclass_column_header_py: 'Reclassification PY',
    aumico_grouping_masking_reclass_py_lock_tooltip: 'Lock previous-year reclassifications',
    aumico_grouping_masking_reclass_py_unlock_tooltip: 'Unlock previous-year reclassifications',
    aumico_grouping_masking_reclass_py_lock_state_locked: 'Locked',
    aumico_grouping_masking_reclass_py_lock_state_editable: 'Editable',
    aumico_grouping_masking_reclass_modal_title: 'Reclassification',
    aumico_grouping_masking_reclass_modal_subtitle_source: 'Source account',
    aumico_grouping_masking_reclass_modal_subtitle_balance: 'Balance',
    aumico_grouping_masking_reclass_modal_period_cy: 'Current year',
    aumico_grouping_masking_reclass_modal_period_py: 'Previous year',
    aumico_grouping_masking_reclass_modal_incoming_section: 'Incoming reclassifications',
    aumico_grouping_masking_reclass_modal_outgoing_section: 'Outgoing reclassifications',
    aumico_grouping_masking_reclass_modal_amount_label: 'Amount',
    aumico_grouping_masking_reclass_modal_amount_placeholder: '0.00',
    aumico_grouping_masking_reclass_modal_target_label: 'Target account',
    aumico_grouping_masking_reclass_modal_target_placeholder: 'Select account...',
    aumico_grouping_masking_reclass_account_badge_tooltip: 'Reclassification account',
    aumico_grouping_masking_reclass_generated_account_name_prefix: 'Reclassification from',
    aumico_grouping_masking_reclass_generated_account_name_to: 'to',
    aumico_grouping_masking_reclass_delete_account_confirm_text:
        'Reclassifications exist on this account. Do you really want to delete the account including all assigned reclassifications?',
    aumico_grouping_masking_reclass_delete_account_confirm_action: 'Delete Account & Reclassifications',
    aumico_grouping_masking_reclass_modal_description_label: 'Reason',
    aumico_grouping_masking_reclass_modal_description_optional: 'optional',
    aumico_grouping_masking_reclass_modal_description_placeholder: 'e.g. Reclassification per audit requirement',
    aumico_grouping_masking_reclass_modal_add_entry: 'Add reclassification',
    aumico_grouping_masking_reclass_modal_delete_entry: 'Delete',
    aumico_grouping_masking_reclass_modal_new_account_button: 'Create new account',
    aumico_grouping_masking_reclass_validation_amount_required:
        'Please enter an amount other than 0. Negative amounts are allowed.',
    aumico_grouping_masking_reclass_validation_target_required: 'Please select a target account.',
    aumico_grouping_masking_reclass_validation_exceeds_balance:
        '⚠ Total amount exceeds the account balance. The source account will show a negative balance.',
    aumico_grouping_masking_reclass_validation_cross_side:
        '⚠ Reclassification between assets and liabilities. Please verify whether this is a reclassification or a transfer entry.',
    aumico_grouping_masking_reclass_validation_duplicate_target: 'Multiple reclassifications to the same target account.',
    aumico_grouping_masking_reclass_new_account_modal_title: 'Create new account',
    aumico_grouping_masking_reclass_new_account_number_label: 'Account number',
    aumico_grouping_masking_reclass_new_account_number_placeholder: 'e.g. 1099',
    aumico_grouping_masking_reclass_new_account_name_label: 'Account name',
    aumico_grouping_masking_reclass_new_account_name_placeholder: 'e.g. Transfer account',
    aumico_grouping_masking_reclass_new_account_fli_label: 'Select FLI',
    aumico_grouping_masking_reclass_new_account_fli_placeholder: 'Select FLI...',
    aumico_grouping_masking_reclass_new_account_save: 'Create',
    aumico_grouping_masking_reclass_new_account_number_required: 'Please enter an account number.',
    aumico_grouping_masking_reclass_new_account_number_duplicate: 'An account with this number already exists.',
    aumico_grouping_masking_reclass_new_account_name_required: 'Please enter an account name.',
    aumico_grouping_masking_reclass_new_account_fli_required: 'Please select an FLI.',
    aumico_grouping_masking_reclass_new_target_choice_title: 'New reclassification target',
    aumico_grouping_masking_reclass_new_target_choice_prompt: 'What would you like to create?',
    aumico_grouping_masking_reclass_new_target_choice_account: 'Create account',
    aumico_grouping_masking_reclass_new_target_choice_group: 'Create group',
    aumico_grouping_masking_reclass_new_group_modal_title: 'Create new group',
    aumico_grouping_masking_reclass_new_group_name_label: 'Group name',
    aumico_grouping_masking_reclass_new_group_name_placeholder: 'e.g. Other liabilities',
    aumico_grouping_masking_reclass_new_group_fli_label: 'Select FLI',
    aumico_grouping_masking_reclass_new_group_fli_placeholder: 'Select FLI...',
    aumico_grouping_masking_reclass_new_group_save: 'Create',
    aumico_grouping_masking_reclass_new_group_name_required: 'Please enter a group name.',
    aumico_grouping_masking_reclass_new_group_fli_required: 'Please select an FLI.',
    aumico_grouping_masking_reclass_new_group_option_suffix: '(new group)',
    aumico_grouping_masking_reclass_new_group_name_exists:
        'This line item already has a group with that name. The reclassification will be added to that group.',
    aumico_grouping_masking_reclass_conflicts_banner:
        'There are {{count}} unresolved reclassification conflict(s). Click here to resolve.',
    aumico_grouping_masking_reclass_conflicts_show: 'Show conflicts',
    aumico_grouping_masking_reclass_conflicts_title: 'Conflicts',
    aumico_grouping_masking_reclass_conflicts_description:
        'The following accounts were deleted or modified but still have open reclassifications.',
    aumico_grouping_masking_reclass_conflicts_delete: 'Delete',
    aumico_grouping_masking_reclass_conflicts_reassign: 'Reassign',
    aumico_grouping_masking_reclass_preview_button: 'Reclassification Mirror',
    aumico_grouping_masking_reclass_preview_title: 'Reclassification Mirror',
    aumico_grouping_masking_reclass_preview_col_from: 'FROM ACCOUNT',
    aumico_grouping_masking_reclass_preview_col_to: 'TO ACCOUNT',
    aumico_grouping_masking_reclass_preview_col_cy: 'CY ({{currency}})',
    aumico_grouping_masking_reclass_preview_col_py: 'PY ({{currency}})',
    aumico_grouping_masking_reclass_preview_col_description: 'DESCRIPTION',
    aumico_grouping_masking_reclass_preview_section_bs: 'Balance Sheet',
    aumico_grouping_masking_reclass_preview_section_is: 'Income Statement',
    aumico_grouping_masking_reclass_preview_footer_note: 'All active reclassifications for this annual report',
    aumico_grouping_masking_reclass_preview_close: 'Close',
    aumico_grouping_masking_reclass_preview_export_pdf: 'Export PDF',
    aumico_grouping_masking_reclass_preview_empty: 'No reclassifications available.',
    aumico_grouping_masking_reclass_conflicts_back: 'Back to table',
    aumico_grouping_masking_reclass_conflicts_transactions: 'reclassification(s)',
    aumico_grouping_masking_reclass_conflicts_total: 'Total amount',
    aumico_grouping_masking_reclass_conflicts_cy: 'CY',
    aumico_grouping_masking_reclass_conflicts_py: 'PY',
    aumico_grouping_masking_reclass_conflicts_table_amount: 'Amount',
    aumico_grouping_masking_reclass_conflicts_table_source: 'Source',
    aumico_grouping_masking_reclass_conflicts_table_target: 'Target',
    aumico_grouping_masking_reclass_conflicts_confirm_delete:
        'All reclassifications for this account will be permanently deleted. This cannot be undone. Continue?',
    aumico_grouping_masking_reclass_tab_indicator_tooltip: '{{count}} unresolved reclassification conflict(s)',
    aumico_grouping_masking_disambiguation_modal_title: 'Select Account',
    aumico_grouping_masking_disambiguation_modal_description:
        'Account {{accountNumber}} "{{accountName}}" appears multiple times in the financial data. Please select the instance you want to apply reclassifications to.',
    aumico_grouping_masking_disambiguation_modal_fli_label: 'FLI',
    aumico_grouping_masking_disambiguation_modal_row_no: 'Row',
    aumico_grouping_masking_disambiguation_modal_closing_balance: 'Closing Balance',
    aumico_grouping_masking_disambiguation_modal_opening_balance: 'Opening Balance',
    aumico_grouping_masking_disambiguation_modal_select_button: 'Select',
    aumico_templates_summarized_accounts_unmapped_tooltip_undo: 'Click to unmerge summarized accounts',
    aumico_templates_summarized_accounts_unmapped_tooltip: 'Click to merge accounts to one summarized account',
    aumico_templates_summarized_accounts_undo_question:
        'Are you sure you want to undo the summarization of this account?',
    aumico_templates_summarized_accounts_undo_yes_button: 'Undo Summarization',
    aumico_templates_summarized_accounts_mapped_tooltip: 'Once unmapped you can modify the summarized accounts',
    aumico_templates_summarized_accounts_modal_title: 'Summarize Selected Accounts',
    aumico_templates_summarized_accounts_modal_title_save_button: 'Summarize Accounts',
    aumico_templates_summarized_accounts_modal_title_cancel_button: 'Keep Separate',
    aumico_templates_summarized_accounts_modal_table_raw_accounts: 'ACCOUNTS',
    aumico_templates_summarized_accounts_modal_table_sum_account: 'SUMMARIZED ACCOUNT',
    aumico_alert_new_shareholder_account_title: '<strong>New Shareholder Account Detected</strong>',
    aumico_alert_new_shareholder_account_main_warning:
        'We have detected a new shareholder account that was not present in the previous year. Please review the details below.',
    aumico_lib_annualreport_shareholder: 'Shareholder',
    aumico_alert_duplicate_prior_year_processed_without_fix:
        'Proceed without correction. I will manually review these accounts.',
    aumico_components_subscription_tiers_section_title: 'Explore our tiers and their benefits',
    aumico_components_subscription_tiers_current_package: 'Current Package',
    aumico_components_subscription_tiers_most_popular: 'Most Popular',
    aumico_components_subscription_tiers_switch_to: 'Switch to {{tierName}}',
    aumico_components_subscription_tiers_tier_light: 'aumico Light',
    aumico_components_subscription_tiers_tier_standard: 'aumico',
    aumico_components_subscription_tiers_tier_pro: 'aumico Pro',
    aumico_components_subscription_tiers_feature_report_generation: 'Report Generation',
    aumico_components_subscription_tiers_feature_mandate_task_management: 'Mandate & Task Management',
    aumico_components_subscription_tiers_feature_financial_closing_workflow: 'Financial Closing Workflow',
    aumico_components_subscription_tiers_feature_interim_statements: 'Interim Statements',
    aumico_components_subscription_tiers_feature_individual_reporting_templates: 'Individual Reporting Templates',
    aumico_components_subscription_tiers_feature_employee_training: 'Employee Training',
    aumico_components_subscription_tiers_feature_dedicated_customer_success_manager:
        'Dedicated Customer Success Manager',
    aumico_reports_registration_welcome_privacy_policy_error: 'You must agree to the privacy policy',
    aumico_components_subscription_tiers_help_title: "Can't decide best fit for you?",
    aumico_components_subscription_tiers_help_description: 'We can help you choose the right plan',
    aumico_components_subscription_tiers_contact_sales: 'Contact Sales',
    aumico_companies_delete_dialog_text_1: 'Confirm Deletion',
    aumico_companies_inactivate_button: 'Deactivate',
    aumico_companies_inactivate_dialog_ok: 'Yes, Deactivate',
    aumico_companies_inactivate_banner_text: "This mandate is inactive. It's not possible to add new projects.",
    aumico_companies_inactivate_dialog_cancel: 'No, Cancel',
    aumico_companies_inactivate_dialog_text_1: 'Confirm Deactivation',
    aumico_companies_inactivate_dialog_text_2:
        'Are you sure you want to deactivate this company? This action cannot be undone.',
    aumico_users_registration_sub_title:
        '<ul> <li> No credit card and no installation required <li> Free support during trial period <li> Non-binding - Your account will be automatically deactivated after 10 days </ul>',
    aumico_templates_switch_accounts_tooltip_1: 'Define Switch Account',
    aumico_templates_switch_accounts_tooltip_2: 'Classified as a switch account.',
    aumico_reports_companies_upload_file_upload_error_format: 'Please upload logo in .png format',
    aumico_admin_menu_item_activate_cpmm: 'Activate CPMM',
    aumico_admin_menu_item_deactivate_cpmm: 'Deactivate CPMM',
    aumico_errors_password_not_match: 'Passwords do not match',
    aumico_ui_not_applicable: 'N/A',
    aumico_ui_documents: 'Documents',
    aumico_ui_annotations: 'Annotations',
    aumico_ui_new_task: 'New Task',
    aumico_ui_export_docs_as_zip: 'Export Docs as ZIP',
    aumico_ui_export: 'Export',
    aumico_ui_view_all: 'View All',
    aumico_ui_view_less: 'View Less',
    aumico_ui_select: 'Select',
    aumico_pm_tasks_rename_task: 'Rename',
    aumico_pm_tasks_not_applicable: 'Not applicable',
    aumico_pm_tasks_mark_applicable: 'Mark as applicable',
    aumico_pm_tasks_delete: 'Delete',
    aumico_cpmm_task_create_success_title: 'Task Successfully Created',
    aumico_cpmm_task_create_success_description: 'The new task has been successfully created.',
    aumico_cpmm_task_create_failure_title: 'Error Creating Task',
    aumico_cpmm_task_create_failure_description: 'The task could not be created. Please try again.',
    aumico_cpmm_task_update_success_title: 'Task Successfully Updated',
    aumico_cpmm_task_update_success_description: 'The task has been successfully updated.',
    aumico_cpmm_task_update_failure_title: 'Error Updating Task',
    aumico_cpmm_task_update_failure_description: 'The task could not be updated. Please try again.',
    aumico_cpmm_task_delete_success_title: 'Task Successfully Deleted',
    aumico_cpmm_task_bulk_delete_success_title: 'Tasks Successfully Deleted',
    aumico_cpmm_task_delete_success_description: 'The task has been successfully deleted.',
    aumico_cpmm_task_bulk_delete_success_description: 'The tasks have been successfully deleted.',
    aumico_cpmm_task_delete_failure_title: 'Error Deleting Task',
    aumico_cpmm_task_bulk_delete_failure_title: 'Error Deleting Tasks',
    aumico_cpmm_task_delete_failure_description: 'The task could not be deleted.',
    aumico_cpmm_task_bulk_delete_failure_description: 'The tasks could not be deleted.',
    aumico_cpmm_annotation_create_success_title: 'Annotation created',
    aumico_cpmm_annotation_create_success_description: 'The annotation has been created successfully.',
    aumico_cpmm_annotation_create_failure_title: 'Annotation not created',
    aumico_cpmm_annotation_create_failure_description: 'The annotation could not be created.',
    aumico_cpmm_annotation_update_success_title: 'Annotation updated',
    aumico_cpmm_annotation_update_success_description: 'The annotation has been updated successfully.',
    aumico_cpmm_annotation_update_failure_title: 'Annotation not updated',
    aumico_cpmm_annotation_update_failure_description: 'The annotation could not be updated.',
    aumico_cpmm_annotation_delete_success_title: 'Annotation deleted',
    aumico_cpmm_annotation_delete_success_description: 'The annotation has been deleted successfully.',
    aumico_cpmm_annotation_delete_failure_title: 'Annotation not deleted',
    aumico_cpmm_annotation_delete_failure_description: 'The annotation could not be deleted.',
    aumico_reports_annualreport_import_structure_dialog_title: 'Taxonomy has changed',
    aumico_reports_annualreport_import_structure_dialog_text: 'Would you like to import the new taxonomy?',
    aumico_reports_annualreport_import_structure_dialog_action_button: 'Yes, change taxonomy',
    aumico_legacy_reclasses_autofill_warning_title: 'Important Note on Data Transfer',
    aumico_legacy_reclasses_autofill_warning_text:
        'The prior-year report contains reclassifications from our old system. These cannot be automatically transferred to the new “Reclassify & Group” screen. Please re-enter the prior-year reclassifications in this report as prior-year transactions. After that, the data will be automatically updated in subsequent years.',
    aumico_legacy_reclasses_autofill_warning_ok: 'OK',
    aumico_annual_report_mapping_help_text_select_fli: 'Select the financial line item',
    aumico_annual_report_mapping_transfer_profit_fli_change_help_text:
        'Here you can change the financial line items to which the profit is to be transferred.',
    aumico_annual_report_mapping_transfer_surplus_fli_change_help_text:
        'Here you can change the financial line items to which the surplus is to be transferred.',
    aumico_annual_report_mapping_uncovered_shortfall_assets_fli_help_text:
        'Here you can select the financial line item in which the uncovered shortfall should be shown on the assets side.',
    aumico_annual_report_mapping_uncovered_shortfall_liabilities_fli_help_text:
        'Here you can select the financial line item in which the uncovered shortfall should be shown on the liabilities side.',
    aumico_annual_report_mapping_settings_section: 'Settings',
    aumico_annual_report_execute_button: 'Execute',
    aumico_annual_report_cancel_button: 'Cancel',
    aumico_annual_report_mapping_reset_fli_button: 'Reset labels',
    aumico_annual_report_mapping_reset_fli_warning:
        'Press the "Reset labels" button if the groups and account groups are displayed in a different language than the rest of the report. By using this function, the groups and financial line items are reloaded in your current profile language.  Groups, FLIs and Sub-FLIs that you have added yourself must be entered again. \nThis is a temporary solution!',
    aumico_annual_report_mapping_reset_fli_dialog_content:
        'This action cannot be undone after saving. Please check the structure of the balance sheet and income statement carefully after using this function. You can reload the groups and account groups in your current profile language at any time.',
    aumico_admin_add_user_button: 'Add user',
    aumico_admin_change_password_current_password_error: 'Current password is wrong',
    aumico_admin_change_password_password_length_error: 'Passwords length must be 12 or more characters',
    aumico_admin_confirm_password: 'Confirm password',
    aumico_admin_current_password: 'Current password',
    aumico_admin_edit_localization: 'Edit localization',
    aumico_admin_login_errorMessage: 'User name or password is wrong!',
    aumico_admin_login_title: 'Login US',
    aumico_admin_manageUsers_role: 'Role',
    aumico_admin_manageUsers_userName: 'Username',
    aumico_admin_new_password: 'New password',
    aumico_admin_password: 'Password',
    aumico_admin_password_changed_successfully: 'Password changed successfully',
    aumico_admin_passwords_doesnot_match: '"Password" and "confirm password" are not the same',
    aumico_admin_templates_balance: 'Balance sheet',
    aumico_admin_templates_income: 'Income',
    aumico_admin_user_created_successfully: 'New user is created successfully',
    aumico_admin_weak_password_error:
        'The password must contain more than 12 characters, upper and small letters, symbols and numbers. Spaces are not allowed.',
    aumico_annual_report_file_preview: 'File preview',
    aumico_annual_report_general_information_autofill_btn_text: 'Fill in company data automatically',
    aumico_annual_report_general_information_balance_sheet_date: 'Balance sheet date',
    aumico_annual_report_general_information_balance_sheet_date_error:
        "Balance sheet date must be after previous years's balance sheet date",
    aumico_annual_report_general_information_basis_of_accounting: 'Accounting standard',
    aumico_annual_report_general_information_create_new_company_btn_text: 'Create new company',
    aumico_reports_annualreport_navigation_import_fx: 'Functional currency',
    aumico_annual_report_fx_rates_dropzone: 'Drop an Excel file here or click',
    aumico_annual_report_fx_rates_dropzone_format: 'Excel with the columns «Date» and «Actual Rate» · rate in {{display}} per 1 {{functional}}',
    aumico_annual_report_fx_table_step: 'Conversion table',
    aumico_annual_report_fx_table_tab_kontrolle: 'Checks',
    aumico_annual_report_fx_table_kontrolle_placeholder: 'The checks (assets = liabilities, balance sheet result = income statement result) will be added in a following step.',
    aumico_annual_report_fx_table_position: 'Position',
    aumico_annual_report_fx_table_kurstyp: 'Rate type',
    aumico_annual_report_fx_table_method_closing: 'Closing',
    aumico_annual_report_fx_table_method_average: 'Average',
    aumico_annual_report_fx_table_reserve: 'Translation reserve',
    aumico_annual_report_fx_proof_mixed: 'Mixed',
    aumico_annual_report_fx_proof_rate_effective: 'Effective rate',
    aumico_annual_report_fx_proof_contribution: 'Contribution',
    aumico_annual_report_fx_proof_at_closing: 'at closing rate',
    aumico_annual_report_fx_proof_sum: 'Sum of contributions',
    aumico_annual_report_fx_proof_rounding: 'Rounding difference',
    aumico_annual_report_fx_proof_rounding_hint: 'included in the translation reserve',
    aumico_annual_report_fx_proof_imbalance: 'Balance sheet does not balance in functional currency',
    aumico_annual_report_fx_proof_imbalance_banner: 'The balance sheet does not balance in functional currency. The translation cannot be correct until that is fixed.',
    aumico_annual_report_fx_proof_check_balance: 'Assets = liabilities',
    aumico_annual_report_fx_proof_check_result: 'Balance-sheet result = income-statement result',
    aumico_annual_report_fx_proof_reason_open: 'Translation not complete, open positions',
    aumico_annual_report_fx_proof_reason_imbalance: 'Balance sheet out in functional currency by',
    aumico_annual_report_fx_proof_reason_result: 'Results already differ in functional currency',
    aumico_annual_report_fx_rounding_assign: 'Assign rounding difference',
    aumico_annual_report_fx_rounding_change: 'Change assignment',
    aumico_annual_report_fx_rounding_too_large: 'The difference is {{tolerance}} {{currency}} or more — that is not rounding and cannot be assigned to an account.',
    aumico_annual_report_fx_rounding_account_missing: 'The assigned account is no longer available (reclassified, deleted or no longer on the average rate). Please assign again.',
    aumico_annual_report_fx_rounding_booked: 'Includes {{amount}} rounding difference on {{account}}',
    aumico_annual_report_fx_rounding_cell_hint: 'Includes the assigned rounding difference (Control):',
    aumico_annual_report_fx_rounding_dialog_title: 'Assign rounding difference',
    aumico_annual_report_fx_rounding_dialog_body: 'Every account is translated on its own and rounded to the cent, while the balance sheet rounds the year result only once. That is why the two results differ by a few cents. Assign the difference to an income-statement account: its amount is corrected by the difference, its rate stays unchanged.',
    aumico_annual_report_fx_rounding_dialog_difference: 'Difference {{date}}',
    aumico_annual_report_fx_rounding_dialog_account: 'Income-statement account (at the average rate)',
    aumico_annual_report_fx_rounding_dialog_assign: 'Assign',
    aumico_annual_report_fx_rounding_dialog_remove: 'Remove assignment',
    aumico_annual_report_fx_rounding_dialog_locked: "The previous year is locked — the assignment comes from the previous year's closing.",
    aumico_annual_report_fx_table_year_result: 'Result for the period',
    aumico_annual_report_fx_table_method_historical: 'Historical',
    aumico_annual_report_fx_table_hist_add_movement: 'Add movement',
    aumico_annual_report_fx_table_hist_open: 'open',
    aumico_annual_report_fx_table_hist_blocked_hint: 'Enter the prior-year rate first.',
    aumico_annual_report_fx_table_hist_provisional_hint: 'Contains positions whose historical rates are not entered yet — the amount is not final.',
    aumico_annual_report_fx_table_hist_py_rate_missing: 'Enter rate',
    aumico_annual_report_fx_hist_modal_save: 'Apply',
    aumico_annual_report_fx_hist_modal_cancel: 'Cancel',
    aumico_annual_report_fx_hist_modal_opening: 'Prior-year balance',
    aumico_annual_report_fx_hist_modal_closing: 'Current-year balance',
    aumico_annual_report_fx_hist_modal_delta: 'Change to be explained',
    aumico_annual_report_fx_hist_modal_explained: 'Explained',
    aumico_annual_report_fx_hist_modal_description: 'Description',
    aumico_annual_report_fx_hist_modal_date: 'Date',
    aumico_annual_report_fx_hist_modal_date_placeholder: 'MM/DD/YYYY',
    aumico_annual_report_fx_hist_modal_functional: 'Amount',
    aumico_annual_report_fx_hist_modal_display: 'Amount',
    aumico_annual_report_fx_hist_modal_rate: 'Rate',
    aumico_annual_report_fx_hist_modal_delete: 'Delete',
    aumico_annual_report_fx_hist_modal_title: 'Historical translation',
    aumico_annual_report_fx_hist_modal_title_previous: 'Enter prior-year rate',
    aumico_annual_report_fx_hist_modal_movements: 'Movements',
    aumico_annual_report_fx_hist_modal_history: 'History',
    aumico_annual_report_fx_hist_modal_history_opening: 'Opening balance',
    aumico_annual_report_fx_hist_modal_history_closing: 'Closing balance',
    aumico_annual_report_fx_hist_modal_history_more: 'Show all years',
    aumico_annual_report_fx_hist_modal_history_less: 'Show less',
    aumico_annual_report_fx_hist_modal_history_count_one: '{{count}} closed year',
    aumico_annual_report_fx_hist_modal_history_count_other: '{{count}} closed years',
    aumico_annual_report_fx_hist_modal_year: 'Financial year',
    aumico_annual_report_fx_hist_modal_weighted: 'weighted',
    aumico_annual_report_fx_hist_modal_previous_required: 'Enter the prior-year rate first — the movements build on the prior-year balance.',
    aumico_annual_report_fx_hist_modal_locked_note: 'The prior year is locked. Unlock it in the “Closing / period rates” step, on the prior-year card.',
    aumico_annual_report_fx_hist_modal_rate_hint: 'Enter either the rate or the amount — the other is calculated.',
    aumico_annual_report_fx_rates_step_period: 'Closing / period rates',
    aumico_annual_report_fx_rates_estv_hint: 'Official closing and annual average rates for all currencies:',
    aumico_annual_report_fx_rates_estv_link: 'FTA rate list (ictax.admin.ch)',
    aumico_annual_report_fx_rates_current_year: 'Current year',
    aumico_annual_report_fx_rates_previous_year: 'Prior year',
    aumico_annual_report_fx_rates_closing_rate: 'Closing rate',
    aumico_annual_report_fx_rates_average_rate: 'Average rate',
    aumico_annual_report_fx_rates_locked: 'Locked',
    aumico_annual_report_fx_rates_unlocked: 'Unlocked',
    aumico_annual_report_fx_rates_lock_scope: 'The lock covers the entire prior year: the rates here and the per-account historical rates in the conversion table.',
    aumico_annual_report_fx_rates_import_label: 'OR calculate automatically from a rate list:',
    aumico_annual_report_fx_rates_import_error: 'The file could not be read. No rates were applied.',
    aumico_annual_report_fx_rates_import_error_columns: 'The file has no «Date» and «Actual Rate» columns. No rates were applied.',
    aumico_annual_report_fx_rates_import_error_period: 'The rate list has no rates for {{year}} — it runs from {{from}} to {{to}}. No rates were applied.',
    aumico_annual_report_fx_rates_import_error_rows: 'The «Date» and «Actual Rate» columns contain no readable values. No rates were applied.',
    aumico_annual_report_fx_rates_import_confirm_title: 'Apply rates?',
    aumico_annual_report_fx_rates_import_confirm_body: 'Please check the calculated rates before they are applied.',
    aumico_annual_report_fx_rates_import_confirm_action: 'Apply',
    aumico_annual_report_fx_rates_import_no_closing: 'No closing rate found — the rate list does not end on the balance sheet date. Please enter it manually.',
    aumico_annual_report_fx_rates_import_closing_last_business_day: 'The balance sheet date falls on a weekend — the rate of {{date}}, the last business day before it, is applied.',
    aumico_annual_report_fx_rates_guide_open: 'What should the Excel look like?',
    aumico_annual_report_fx_rates_guide_title: 'Rate list from Excel',
    aumico_annual_report_fx_rates_guide_headline: 'Take the rates straight from your rate list',
    aumico_annual_report_fx_rates_guide_lead: 'Upload the rate export of your bank or system. aumico reads the date and the rate and calculates the closing and average rates automatically.',
    aumico_annual_report_fx_rates_guide_callout_date: 'Date',
    aumico_annual_report_fx_rates_guide_callout_rate: 'Rate',
    aumico_annual_report_fx_rates_guide_legend_read: 'is read',
    aumico_annual_report_fx_rates_guide_legend_ignored: 'is ignored',
    aumico_annual_report_fx_rates_guide_point_file_title: 'One Excel file',
    aumico_annual_report_fx_rates_guide_point_file_text: 'Format .xlsx or .xls, with a header row. It may also sit further down the sheet.',
    aumico_annual_report_fx_rates_guide_point_columns_title: 'Two columns count',
    aumico_annual_report_fx_rates_guide_point_columns_text: '«Date» and «Actual Rate» — in any position. All other columns are ignored.',
    aumico_annual_report_fx_rates_guide_point_direction_title: 'Rate in {{display}} per 1 {{functional}}',
    aumico_annual_report_fx_rates_guide_point_direction_text: '0.79270 means: 1 {{functional}} = 0.79270 {{display}}.',
    aumico_annual_report_fx_rates_guide_calc_title: 'How it is calculated',
    aumico_annual_report_fx_rates_guide_calc_closing: 'Closing rate = rate on the balance sheet date. If it falls on a weekend, the rate of the last business day before it applies.',
    aumico_annual_report_fx_rates_guide_calc_average: 'Average rate = mean of all rates of the year. Rates of other years in the same file are not included.',
    aumico_annual_report_fx_rates_guide_close: 'Got it',
    aumico_annual_report_fx_rates_unlock_confirm_title: 'Unlock prior-year rates?',
    aumico_annual_report_fx_rates_unlock_confirm_body: 'The prior-year rates come from the prior-year report. Once unlocked they can be changed.',
    aumico_annual_report_fx_rates_unlock_confirm_action: 'Unlock',
    aumico_annual_report_general_information_currency: 'Currency',
    aumico_annual_report_general_information_functional_currency: 'Functional currency',
    aumico_annual_report_general_information_display_currency: 'Presentation currency',
    aumico_annual_report_general_information_please_determine_display_currency: 'Please select a presentation currency',
    aumico_annual_report_general_information_previous_sheet_date_error: 'Previous date must be before current date',
    aumico_annual_report_general_information_previous_year_reporting_date: "Previous year's balance sheet date",
    aumico_annual_report_general_information_revision_type: 'Revision type',
    aumico_annual_report_general_information_select_company: 'Select company',
    aumico_annual_report_general_information_set_specification: 'General information',
    aumico_annual_report_import_definition_click_cell: 'Please click on the corresponding cell in the preview',
    aumico_annual_report_import_definition_click_corresponding_sheet:
        'Please click on the corresponding cell in the preview',
    aumico_annual_report_import_definition_fill_manually: 'Fill manually',
    aumico_annual_report_import_definition_specify_titles_line_1:
        'Specify the line number on which the titles are fixed in the',
    aumico_annual_report_import_definition_specify_titles_line_2: 'Table',
    aumico_annual_report_import_definition_transfer_entries: 'Transfer entries for',
    aumico_annual_report_import_definition_which_spreadsheet_1: 'In which spreadsheet is the',
    aumico_annual_report_import_definition_which_spreadsheet_2: 'Sheet shown?',
    aumico_annual_report_import_form_balance_title: 'Balance sheet',
    aumico_annual_report_import_form_income_title: 'Income statement',
    aumico_annual_report_import_form_income_instruction_label: 'Upload incomce statement',
    aumico_annual_report_import_form_input_placeholder: 'Please specify a version name',
    aumico_annual_report_import_form_upload_label: 'Upload file for the net balance of the client',
    aumico_annual_report_import_form_uploaded_label: 'Uploaded file for the net balance of the client',
    aumico_annual_report_import_form_version_label: 'Version name',
    aumico_annual_report_import_indicate_account_names_column: 'Indicate the column where the account designations are',
    aumico_annual_report_import_indicate_account_numbers_column: 'Indicate the column where the account numbers are',
    aumico_annual_report_import_indicate_balance_column: 'Indicate the reporting period column.',
    aumico_annual_report_import_indicate_previous_year_column: 'Enter the column for the comparison period.',
    aumico_annual_report_interpretation_account_name: 'Account designation',
    aumico_annual_report_interpretation_account_number: 'Length of account no. (Ex.: 4-5 or 5-5)',
    aumico_annual_report_interpretation_active: 'Assets',
    aumico_annual_report_interpretation_closing_value: 'Closing value',
    aumico_annual_report_interpretation_excluded_word: 'Excluded word',
    aumico_annual_report_interpretation_expense: 'Expense',
    aumico_annual_report_interpretation_included_word: 'Included word',
    aumico_annual_report_interpretation_income: 'Income',
    aumico_annual_report_interpretation_negative: 'Negative',
    aumico_annual_report_interpretation_opening_value: 'Opening value',
    aumico_annual_report_interpretation_passive: 'Liabilities',
    aumico_annual_report_interpretation_positive: 'Positive',
    aumico_annual_report_interpretation_select_signs: 'Define +/- of your trial balance.',
    aumico_annual_report_interpretation_specify_excluded_word:
        'Optional: Please specify one word that must be excluded in the account name',
    aumico_annual_report_interpretation_specify_included_word:
        'Optional: Please specify one word that must be included in the account name',
    aumico_annual_report_interpretation_specify_number_of_characters: 'Optional filter criteria',
    aumico_annual_report_interpretation_title: 'Number interpretation',
    aumico_annual_report_mandatory_field_error: 'This field is mandatory',
    aumico_annual_report_not_found_error: 'Not Found',
    aumico_annual_report_print_options_add_metadata: 'Add metadata',
    aumico_annual_report_print_options_caption: '-',
    aumico_annual_report_print_options_collective_signature: 'Collective signature',
    aumico_annual_report_print_options_custom_page_numbers: 'Custom page numbers',
    aumico_annual_report_print_options_dont_show_name: 'Do not show name (can be entered manually)',
    aumico_annual_report_print_options_show_decimal_places: 'Show decimal places',
    aumico_annual_report_print_options_place_of_signing: 'Place of signing (optional)',
    aumico_annual_report_print_options_print: 'Print',
    aumico_annual_report_print_options_print_only_greyscale: 'Print only greyscale',
    aumico_annual_report_print_options_show_empty_lines: 'Show empty lines',
    aumico_annual_report_print_options_show_company_info: 'Organisation information',
    aumico_annual_report_print_options_show_cover_sheet: 'Cover sheet',
    aumico_annual_report_print_options_show_table_of_contents: 'Table of contents',
    aumico_annual_report_print_options_show_uid: 'UID (cover sheet)',
    aumico_annual_report_print_options_signatory_1: 'Signatory 1 (optional)',
    aumico_annual_report_print_options_signatory_2: 'Signatory 2 (optional)',
    aumico_annual_report_print_options_signature: 'Signature',
    aumico_annual_report_print_options_title: 'Print options',
    aumico_annual_report_print_preview_aop: 'Appropriation of profit',
    aumico_annual_report_print_preview_attachement: 'Notes to the financial statements',
    aumico_annual_report_print_preview_balance: 'Balance sheet',
    aumico_annual_report_print_preview_income: 'Income statement',
    aumico_annual_report_profit_calculation_annual_profit: 'Annual Profit',
    aumico_annual_report_profit_calculation_annual_result: 'Annual Result',
    aumico_annual_report_profit_calculation_annual_loss: 'Annual Loss',
    aumico_annual_report_profit_calculation_header: 'Available retained earnings',
    aumico_annual_report_profit_calculation_header_profit: 'Available profit',
    aumico_annual_report_profit_calculation_header_loss: 'Available loss',
    aumico_annual_report_proposal_add_new_item: 'Add new item',
    aumico_annual_report_proposal_available_retained_earnings: 'Total retained earnings',
    aumico_annual_report_proposal_available_retained_earnings_profit: 'Total retained profit',
    aumico_annual_report_proposal_available_retained_earnings_loss: 'Total retained loss',
    aumico_annual_report_proposal_carried_forward_to_new_account: 'Balance to be carried forward',
    aumico_annual_report_proposal_carried_forward_to_new_account_profit: 'Profit carried forward to new account',
    aumico_annual_report_proposal_carried_forward_to_new_account_loss: 'Loss carried forward to new account',
    aumico_annual_report_table_label_accounting_basis: 'Accounting basis',
    aumico_annual_report_table_label_company: 'Company',
    aumico_annual_report_table_label_created_on: 'Created on',
    aumico_annual_report_table_label_language: 'Language',
    aumico_annual_report_table_label_currency: 'Currency',
    aumico_annual_report_table_label_last_change: 'last change',
    aumico_button_cancel: 'Cancel',
    aumico_button_companies_form_cancel: 'Cancel',
    aumico_button_companies_form_save: 'Save and continue',
    aumico_button_confirm: 'Confirm',
    aumico_button_delete: 'Delete',
    aumico_button_download: 'Download',
    aumico_button_edit: 'Edit',
    aumico_button_copy: 'Copy',
    aumico_button_preview: 'Preview',
    aumico_button_save: 'Save',
    aumico_button_submit: 'Submit',
    aumico_button_update: 'Update',
    aumico_button_add: 'Add more',
    aumico_companies_form_label_addition_to_address: 'Addition to address',
    aumico_companies_form_label_address: 'Address',
    aumico_tags_box_title: 'Tag',
    aumico_companies_form_section_linked_persons: 'Linked persons',
    aumico_tags_box_new_tag_placeholder: 'Create new tag',
    aumico_tags_box_create: 'Create',
    aumico_tags_box_cancel: 'Cancel',
    aumico_tags_box_delete: 'Delete',
    aumico_tags_box_delete_warning: 'is used by {{companies}} companies and {{persons}} persons and will be removed there. Really delete?',
    aumico_tags_box_delete_aria: 'Delete tag',
    aumico_persons_form_details_text: 'Person details',
    aumico_persons_form_section_personal: 'Personal details',
    aumico_persons_form_first_name: 'First name',
    aumico_persons_form_last_name: 'Last name',
    aumico_persons_form_assignee: 'Mandate manager',
    aumico_persons_form_clerk: 'Clerk',
    aumico_persons_form_search: 'Search',
    aumico_persons_form_placeholder: 'Please enter',
    aumico_persons_form_section_address: 'Address',
    aumico_persons_form_street: 'Street & number',
    aumico_persons_form_addition_to_address: 'Addition to address',
    aumico_persons_form_zip: 'Zip code',
    aumico_persons_form_city: 'City',
    aumico_persons_form_section_contact: 'Contact details',
    aumico_persons_form_email: 'E-mail',
    aumico_persons_form_phone: 'Phone',
    aumico_persons_form_email_invalid: 'Invalid e-mail address',
    aumico_persons_form_add_contact: 'Add contact',
    aumico_persons_form_remove_contact_aria: 'Remove contact',
    aumico_persons_form_section_companies: 'Linked companies',
    aumico_persons_form_company: 'Company',
    aumico_persons_form_role: 'Role',
    aumico_persons_form_please_choose: 'Please choose',
    aumico_persons_form_link: 'Link',
    aumico_persons_form_unlink_aria: 'Remove link',
    aumico_persons_form_company_deleted: 'Company deleted',
    aumico_persons_form_role_OWNER: 'Owner',
    aumico_persons_form_role_SHAREHOLDER: 'Shareholder',
    aumico_persons_form_role_MANAGING_DIRECTOR: 'Managing director',
    aumico_persons_form_role_BOARD_MEMBER: 'Board member',
    aumico_persons_form_role_OTHER: 'Other',
    aumico_persons_form_save: 'Save',
    aumico_persons_form_delete: 'Delete',
    aumico_persons_form_deactivate: 'Deactivate',
    aumico_persons_form_activate: 'Activate',
    aumico_persons_form_dialog_cancel: 'Cancel',
    aumico_person_delete_failed_title: 'Error deleting the person',
    aumico_person_delete_failed_has_projects_message:
        'The person still has projects. You must first delete the existing projects of this person.',
    aumico_persons_form_clerk_change_dialog_text:
        "You're changing the clerk for this person. How should existing tasks be reassigned?",
    aumico_persons_form_delete_dialog_title: 'Delete person?',
    aumico_persons_form_delete_dialog_text: 'The person will be deleted permanently. This cannot be undone.',
    aumico_persons_overview_tab_active: 'Active',
    aumico_persons_overview_tab_inactive: 'Inactive',
    aumico_persons_overview_search: 'Search',
    aumico_persons_overview_filter_assignee: 'Mandate manager',
    aumico_persons_overview_filter_clerk: 'Clerk',
    aumico_persons_overview_filter_tag: 'Tag',
    // REV-22155 — person projects
    aumico_projects_toggle_companies: 'Companies',
    aumico_projects_toggle_persons: 'Persons',
    aumico_person_projects_filter_person: 'Person',
    aumico_person_projects_filter_period: 'Period',
    aumico_person_projects_filter_tag: 'Tag',
    aumico_person_projects_col_person: 'Person',
    aumico_person_projects_col_period: 'Period',
    aumico_person_projects_col_tag: 'Tag',
    cpmm_projects_overview_col_tag: 'Tag',
    aumico_projects_overview_filter_tag: 'Tag',
    aumico_person_projects_tax_period: 'Tax period {{year}}',
    aumico_person_projects_empty: 'No person projects yet',
    aumico_person_projects_empty_instructions: 'Create a project for a person to start their mandate management.',
    aumico_person_projects_create_failure_title: 'Project not created',
    aumico_person_projects_create_failure_description: 'The project could not be created. Please try again.',
    aumico_person_projects_create_failure_inactive: 'This mandate is inactive. It is not possible to add new projects.',
    aumico_create_person_project_dialog_select_person_title: 'Select person',
    aumico_create_person_project_dialog_select_person_description: 'Which person is the project for?',
    aumico_create_person_project_dialog_select_person_input_title: 'Person',
    aumico_create_person_project_dialog_select_person_input_placeholder: 'Search person',
    aumico_create_person_project_dialog_select_period_title: 'Select period',
    aumico_create_person_project_dialog_select_period_description: 'Which period is the project for?',
    aumico_create_person_project_dialog_select_period_input_label: 'Period',
    aumico_create_person_project_dialog_select_period_input_placeholder: 'Choose period',
    aumico_pm_tasks_type_filter_label: 'Type',
    aumico_pm_tasks_type_company: 'Company',
    aumico_pm_tasks_type_person: 'Person',
    aumico_tasks_col_mandant: 'Client',
    aumico_person_projects_next_year_reason_inactive: 'Inactive – no new projects possible',
    aumico_person_projects_next_year_reason_no_project: 'No project yet',
    aumico_person_projects_next_year_reason_not_found: 'Person not found',
    aumico_persons_overview_export: 'Export XLS',
    aumico_persons_overview_new: 'New person',
    aumico_persons_overview_col_name: 'Name',
    aumico_persons_overview_col_street: 'Street & number',
    aumico_persons_overview_col_zip: 'Zip code',
    aumico_persons_overview_col_city: 'City',
    aumico_persons_overview_col_tag: 'Tag',
    aumico_persons_overview_col_assignee: 'Mandate manager',
    aumico_persons_overview_col_clerk: 'Clerk',
    aumico_persons_overview_empty_text1: 'No persons yet',
    aumico_persons_overview_empty_text2: 'Add the first person with "New person".',
    aumico_persons_overview_bulk_assignee: 'Change mandate manager',
    aumico_persons_overview_bulk_clerk: 'Change clerk',
    aumico_persons_overview_bulk_next_financial_year: 'Create next financial year',
    aumico_persons_overview_bulk_deactivate: 'Deactivate persons',
    aumico_persons_overview_bulk_deactivate_confirm: 'Are you sure you want to deactivate {{count}} persons?',
    aumico_persons_overview_bulk_selected: 'selected',
    aumico_persons_overview_bulk_assignee_title: 'Change mandate manager for {{count}} persons?',
    aumico_persons_overview_bulk_clerk_title: 'Change clerk for {{count}} persons?',
    aumico_persons_overview_cancel: 'Cancel',
    aumico_persons_overview_save: 'Save',
    aumico_persons_overview_please_choose: 'Please choose',
    aumico_companies_form_label_city: 'City',
    aumico_companies_form_label_country: 'Country',
    aumico_companies_form_label_email: 'E-Mail',
    aumico_companies_form_label_first_name: 'First Name',
    aumico_companies_form_label_last_name: 'Last Name',
    aumico_companies_form_label_legal_form: 'Legal form',
    aumico_companies_form_label_name: 'Name',
    aumico_companies_form_label_phone: 'Phone',
    aumico_companies_form_label_street_and_number: 'Street & number',
    aumico_companies_form_label_uid_number: 'UID number',
    aumico_companies_form_label_zip_code: 'Zip code',
    aumico_companies_form_placeholder_optional: 'optional',
    aumico_companies_form_placeholder_please_enter: 'Please enter',
    aumico_companies_form_placeholder_please_select: 'Please select',
    aumico_companies_form_section_name_contact_details: 'Contact details',
    aumico_companies_form_section_name_legal_information: 'Legal information',
    aumico_companies_fx_section_title: 'Functional currency',
    aumico_companies_fx_inactive_hint:
        'For clients whose books are kept in a foreign currency. Once activated, new financial statements can use a functional currency.',
    aumico_companies_fx_activate_button: 'Activate',
    aumico_companies_fx_deactivate_button: 'Deactivate functional currency',
    aumico_companies_fx_pending_chip: 'Pending',
    aumico_companies_fx_pending_hint: 'Will be activated as soon as the company is saved.',
    aumico_companies_fx_pending_cancel: 'Cancel activation',
    aumico_companies_fx_active_chip: 'Active',
    aumico_companies_fx_activated_on: 'Activated on',
    aumico_companies_fx_minimum_term_until: 'Minimum term until',
    aumico_companies_fx_no_permission_hint:
        'Only an organisation administrator can activate the functional currency.',
    aumico_companies_fx_modal_title: 'Activate functional currency',
    aumico_companies_fx_modal_intro:
        'The functional currency is a chargeable add-on. It becomes available for newly created financial statements; existing ones are unaffected.',
    aumico_companies_fx_modal_price: 'Additional cost',
    aumico_companies_fx_modal_per_year: 'year',
    aumico_companies_fx_modal_term: 'Minimum term',
    aumico_companies_fx_modal_months: 'months',
    aumico_companies_fx_modal_consent_checkbox:
        'I confirm that I am aware of the additional cost and the minimum term.',
    aumico_companies_fx_modal_confirm: 'Confirm & activate',
    aumico_companies_fx_modal_cancel: 'Cancel',
    aumico_companies_fx_deactivate_confirm_title: 'Deactivate functional currency',
    aumico_companies_fx_deactivate_confirm_body:
        'New financial statements will no longer be able to use a functional currency. Statements already created remain unchanged. The minimum term continues to run.',
    aumico_companies_form_validation_email_invalid: 'Invalid E-Mail',
    aumico_companies_form_validation_enter_company_name_exists: 'Company name already exists',
    aumico_companies_form_validation_enter_company_name_required: 'Please enter company name',
    aumico_companies_form_validation_legal_form_required: 'Please select legal form',
    aumico_companies_toast_error_something_went_wrong: 'Something went wrong',
    aumico_core_form_invalid_error: 'This field is invalid',
    aumico_core_form_mandatory_error: 'This Field is Mandatory',
    aumico_errors_server_error: 'Server Error',
    aumico_no_read_permission: 'Sorry, You do not have read permission',
    aumico_notes_component_options_add_more: 'Add more',
    aumico_notes_component_options_current_value_title_1: 'Current Value Title 1',
    aumico_notes_component_options_current_value_title_2: 'Current Value Title 2',
    aumico_notes_component_options_previous_value_title_1: 'Previous Value Title 1',
    aumico_notes_component_options_previous_value_title_2: 'Previous Value Title 2',
    aumico_notes_component_options_selection_option: 'Selection Option',
    aumico_notes_component_options_text_title: 'Text Title',
    aumico_notes_equity: 'Equity',
    aumico_notes_fli: 'Financial Line Item',
    aumico_notes_fli_component_add_more: 'Add more flis',
    aumico_notes_free_table_with_amounts: 'Free Table incl. Amounts',
    aumico_notes_information_dialog_title: 'General Information',
    aumico_notes_mandatory_error: 'This field is mandatory',
    aumico_notes_name_exist_error: 'Name already exists',
    aumico_notes_notespage_notes_not_found: 'There is no notes found by this legal form and accounting basis.',
    aumico_notes_notestemplate_form_legal_form_and_accounting_basis_combination_exist:
        'This combination of selected legal form and account basis already exist',
    aumico_notes_notestemplate_list_add_new: 'Add new notes template',
    aumico_notes_notestype_form_components: 'Components',
    aumico_notes_notestype_form_information: 'Information',
    aumico_notes_notestype_form_min_length_error: 'The minimum length is 5 characters',
    aumico_notes_notestype_form_name: 'Name',
    aumico_notes_notestype_form_title: 'Section title',
    aumico_notes_notestype_list_add_new: 'Add new notes type',
    aumico_notes_options: 'Options',
    aumico_notes_preview: 'Preview',
    aumico_notes_rich_text: 'Rich Text',
    aumico_notes_select: 'Select',
    aumico_notes_server_error: 'Internal Server Error',
    aumico_notes_table_with_form_add_new_item: 'Add new row',
    aumico_notes_table_with_form_no_formfield_defined: 'NO FORM FIELD DEFINED FOR',
    aumico_notes_table_with_form_no_properties_defined: 'No properties defined.',
    aumico_notes_table_with_form_no_properties_error: 'No properties defined',
    aumico_notes_table_with_form_total: 'Total',
    aumico_notes_template: 'Notes Template',
    aumico_notes_testing_procedure: 'Testing procedure',
    aumico_notes_testing_procedure_comment: 'Comment',
    aumico_notes_testing_procedure_flis: 'Flis',
    aumico_notes_testing_procedure_references: 'References',
    aumico_notes_text: 'Text',
    aumico_notes_total_row: 'Total Row',
    aumico_notes_types: 'Notes Types',
    aumico_reporting_contentBlocks_addNew: 'Add new content block',
    aumico_reporting_contentBlocks_options_content: 'Content blocks content',
    aumico_reporting_contentBlocks_options_owner: 'Content blocks owner',
    aumico_reporting_contentBlocks_options_properties: 'Content blocks properties',
    aumico_reporting_report_content: 'Content',
    aumico_reporting_report_edit_addNewContent: 'Add new content',
    aumico_reporting_report_edit_addNewFooter: 'Add new footer',
    aumico_reporting_report_edit_addNewHeader: 'Add new header',
    aumico_reporting_report_footer: 'Footer',
    aumico_reporting_report_header: 'Header',
    aumico_reporting_report_name: 'Report Name',
    aumico_reporting_settings_options_name: 'Name',
    aumico_reporting_settings_options_owner: 'Owner',
    aumico_reporting_templatesPreview_show: 'Show Preview',
    aumico_reporting_templates_addNew: 'Add new reporting template',
    aumico_reporting_templates_edit: 'Edit reporting template',
    aumico_reporting_templates_livePreview: 'Live preview',
    aumico_reporting_templates_options_accountingBasis: 'Accounting basis',
    aumico_reporting_templates_options_legalForm: 'Legal form',
    aumico_reporting_variables_addNew: 'Add new reporting variable',
    aumico_reporting_variables_edit: 'Edit reporting variable',
    aumico_reporting_variables_options_currentVersion: 'Current version',
    aumico_reporting_variables_options_identifier: 'Identifier',
    aumico_reporting_variables_options_property: 'Property',
    aumico_reporting_variables_title: 'Variables',
    aumico_reports_fs_notes_instruction: 'Work instruction',
    aumico_reports_input_please_enter_placeholder: 'Please enter',
    aumico_reports_intro_side_text: 'Take your financial statements to the next level!',
    aumico_reports_login_bottom_button_of_question_register: 'Register now',
    aumico_reports_login_bottom_question: "You don't have an account yet?",
    aumico_reports_login_credentials_error: 'Username or password is incorrect!',
    aumico_reports_login_credentials_toomany_requests_error:
        'Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.',
    aumico_reports_login_credentials_network_request_failed: 'Network failure',
    aumico_reports_login_invalid_role_error: 'Your account does not have a valid role to access this application.',
    aumico_reports_login_forgot_password: 'Forgot password',
    aumico_reports_login_introduction: '',
    aumico_reports_login_login_button: 'Login',
    aumico_reports_login_title: 'Login',
    aumico_reports_page_not_found: 'Page Not Found',
    aumico_reports_password: 'Password',
    aumico_reports_placeholder_needs_implementation: 'Placeholder Page, needs to be implemented...',
    aumico_reports_registration_bottom_button_of_question_login: 'Login now',
    aumico_reports_registration_bottom_question: 'Already have an account?',
    aumico_reports_registration_confirmation_bottom_question: 'Did not get an e-mail?',
    aumico_reports_registration_confirmation_bottom_question_button: 'Resend E-Mail',
    aumico_reports_registration_confirmation_introduction: 'Short introduction and instructions',
    aumico_reports_registration_confirmation_title: 'Please confirm your e-mail address',
    aumico_reports_registration_create_account_button: 'Create Account',
    aumico_reports_registration_introduction:
        'Welcome! Sign up and start creating financial statements for your own organization and your customers.',
    aumico_reports_registration_welcome_button_login_go_dashboard: 'Login and go to Dashboard',
    aumico_reports_registration_welcome_company_name_error: 'Company name is required',
    aumico_reports_registration_welcome_company_name_label: 'Company name',
    aumico_reports_registration_welcome_first_name_error: 'First name is required',
    aumico_reports_registration_welcome_first_name_label: 'First name',
    aumico_reports_registration_welcome_last_name_error: 'Last name is required',
    aumico_reports_registration_welcome_last_name_label: 'Last name',
    aumico_reports_registration_welcome_market_communication_subscription:
        'I would like to receive news about products, services, and events from aumico.',
    aumico_reports_registration_welcome_password_error: 'Password is required',
    aumico_reports_registration_welcome_password_label: 'Password',
    aumico_reports_registration_welcome_password_match_error: 'Passwords must match',
    aumico_reports_registration_welcome_password_rules:
        'Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character of (@$!%*?&._) ',
    aumico_reports_registration_welcome_password_validation_error: "Password doesn't meet the rules.",
    aumico_reports_registration_welcome_privacy_policy: 'I have read and agree to the privacy policy on the website*',
    aumico_reports_registration_welcome_repeat_password_error: 'Repeat password is required',
    aumico_reports_registration_welcome_repeat_password_label: 'Please repeat password',
    aumico_reports_reset_password_credentials_error: 'Username or email is wrong!',
    aumico_reports_reset_password_forgot_email_username: 'E-Mail / Username',
    aumico_reports_reset_password_forgot_password_title: 'Forgot password?',
    aumico_reports_reset_password_forgot_send_instruction_button: 'Send me instructions via E-Mail',
    aumico_reports_reset_password_introduction:
        'Please enter your e-mail and we will send you instructions on how to reset your password.',
    aumico_reports_signup_title: 'Create new account',
    aumico_reports_welcome_page_footer_about: 'GTC',
    aumico_reports_welcome_page_footer_imprint: 'Imprint',
    aumico_reports_welcome_page_footer_privacy_policy: 'Privacy Policy',
    aumico_reports_write_permission_error: "Sorry you don't have write permission.",
    aumico_reports_referral_invite_title: 'Referral',
    aumico_reports_referral_invite_text: 'Tell a friend',
    aumico_reports_referral_invite_invite_button: 'Invite Now',
    aumico_reports_referral_invite_dialog_title: 'Tell a friend',
    aumico_reports_referral_invite_dialog_content: 'Tell a friend about aumico',
    aumico_reports_referral_invite_dialog_input_label: 'Add e-mail address',
    aumico_reports_referral_invite_dialog_input_placeholder: 'Enter e-mail addresses',
    aumico_reports_referral_invite_dialog_save_button: 'Send Invite',
    aumico_settings_accountingBasis: 'Accounting basis',
    aumico_settings_accountingbasis_id: 'ID',
    aumico_settings_accountingbasis_name: 'Name',
    aumico_settings_accountingbasis_owner: 'Owner',
    aumico_settings_accountingbasis_text: 'Text',
    aumico_settings_accountingbasis_version: 'Version',
    aumico_settings_currency_id: 'ID',
    aumico_settings_currency_name: 'Name',
    aumico_settings_currency_owner: 'Owner',
    aumico_settings_currency_text: 'Text',
    aumico_settings_currency_version: 'Version',
    aumico_settings_financialLineItem: 'Financial Line Item',
    aumico_settings_financialLineItem_cashflow: 'Cashflow',
    aumico_settings_financialLineItem_description: 'Description',
    aumico_settings_financialLineItem_id: 'ID',
    aumico_settings_financialLineItem_invalidText: 'Please enter numbers only starting from 1000',
    aumico_settings_financialLineItem_name: 'Name',
    aumico_settings_financialLineItem_owner: 'Owner',
    aumico_settings_financialLineItem_position: 'Position',
    aumico_settings_financialLineItem_text: 'Text',
    aumico_settings_financialLineItem_type: 'Type',
    aumico_settings_financialLineItem_version: 'Version',
    aumico_settings_legalForm_id: 'ID',
    aumico_settings_legalForm_name: 'Name',
    aumico_settings_legalForm_owner: 'Owner',
    aumico_settings_legalForm_text: 'Text',
    aumico_settings_legalForm_version: 'Version',
    aumico_templates_cancel: 'Cancel',
    aumico_templates_combination_exist_error: 'Legal form and account basis combination already exists',
    aumico_templates_description: 'Description',
    aumico_templates_form_account_basis: 'Accounting Basis',
    aumico_templates_form_back_to_templates_list: 'Back to templates list',
    aumico_templates_form_cash_and_cash_equivalents: 'Cash and Cash Equivalents',
    aumico_templates_form_create_template: 'Create Template',
    aumico_templates_form_enter_template_name_error: 'Please enter the name of the template',
    aumico_templates_form_legal_form: 'Legal form',
    aumico_templates_form_profit_of_the_year: 'Profit of the year',
    aumico_templates_form_select_account_basis_error: 'Please select account basis',
    aumico_templates_form_select_legal_form_error: 'Please select legal form',
    aumico_templates_form_template_name_exists_error: 'Template name already exists',
    aumico_templates_form_update_template: 'Update Template',
    aumico_templates_group_form_allow_groups: 'Allow groups',
    aumico_templates_group_form_allow_items: 'Allow items',
    aumico_templates_group_form_create_group: 'Create Group',
    aumico_templates_group_form_enter_group_description_error: 'Please enter group description',
    aumico_templates_group_form_enter_group_name_error: 'Please enter group name',
    aumico_templates_group_form_hide_total: 'Hide total',
    aumico_templates_group_form_name_already_exists_error: 'Group name already exists',
    aumico_templates_group_form_select_option: 'Select at least one option:',
    aumico_templates_group_form_update_group: 'Update Group',
    aumico_templates_group_list_new_group: 'New Group',
    aumico_templates_group_view_add_fli: 'Add financial line items',
    aumico_templates_group_view_add_group: 'Add Group',
    aumico_templates_group_view_add_subtotal: 'Add Subtotal',
    aumico_templates_list_edit: 'Edit',
    aumico_templates_list_new: 'New',
    aumico_templates_list_new_template: 'New Template',
    aumico_templates_name: 'Name',
    aumico_templates_save: 'Save',
    aumico_templates_subtotal_form_enter_subtotal_description_error: 'Please enter subtotal description',
    aumico_templates_subtotal_form_enter_subtotal_name_error: 'Please enter subtotal name',
    aumico_templates_subtotal_form_name_already_exists_error: 'Group item name already exists',
    aumico_templates_subtotal_form_subtotal_name: 'Subtotal Name',
    mocked_data: 'Changed data',
    mocked_data_1: 'Changed date',
    aumico_reports_annualreport_navigation_fcp: 'Financial Closing Process',
    aumico_reports_annualreport_fcp_input_data_has_changed_notification_title: 'Data has changed',
    aumico_reports_annualreport_fcp_input_data_has_changed_notification_text: 'The data has changed.',
    aumico_reports_annualreport_fcp_input_data_has_changed_dialog_title: 'Mapping Daten changed?',
    aumico_reports_annualreport_fcp_input_data_has_changed_dialog_text: 'Do you want to update?',
    aumico_reports_annualreport_fcp_input_data_has_changed_dialog_action_button: 'Yes',

    aumico_reports_annualreport_navigation_aop: 'Appropriation Of Profit',
    aumico_reports_annualreport_navigation_generalinformation: 'General Information',
    aumico_reports_annualreport_navigation_finish_and_print: 'Finish & Print',
    aumico_reports_annualreport_navigation_import: 'Import balance sheet',
    aumico_reports_annualreport_navigation_import_upload: 'Upload balance sheet',
    aumico_reports_annualreport_navigation_import_mapping: 'Account mapping',
    aumico_reports_annualreport_navigation_notes: 'Notes',
    aumico_reports_annualreport_navigation_notes_and_aop: 'CFS | Notes | Appropriation of profit',
    aumico_reports_main_navigation_company: 'Organization',
    aumico_reports_main_navigation_financialstatements: 'Financial Statement',
    aumico_reports_main_navigation_logout: 'Logout',
    aumico_reports_profile_navigation_security: 'Security',
    aumico_reports_profile_navigation_generalinformation: 'General Information',
    aumico_annual_report_general_information_please_determine_currency: 'Select currency',
    aumico_annual_report_general_information_please_determine_previous_year_date: 'Enter date',
    aumico_annual_report_general_information_please_determine_date: 'Select balance sheet date',
    aumico_annual_report_general_information_please_select_company: 'Select company',
    aumico_annual_report_general_information_select_revision_type: 'Select revision type',
    aumico_annual_report_general_information_select_accounting_basis: 'Select accounting basis',
    aumico_annual_report_import_please_select: 'Please select',
    aumico_annual_report_interpretation_enter_excluded_word: 'Enter word',
    aumico_annual_report_interpretation_enter_included_word: 'Enter word',
    aumico_annual_report_print_options_date_of_signing: 'Date of signing',
    aumico_annual_report_print_options_place_of_signing_placeholder: 'Place of signing',
    aumico_annual_report_print_options_start_at_page: 'Start at page',
    aumico_annual_report_print_page_content_preview: 'Content Preview',
    aumico_annual_report_profit_calculation_enter_text: 'Enter text / amount',
    aumico_annual_report_proposal_enter_text: 'Enter text / amount',
    aumico_annual_report_print_options_show_aop: 'Appropriation of profit',
    aumico_annual_report_print_options_show_Fcp: 'Financial Closing Process',
    aumico_annual_report_proposal_description: 'Proposal for the appropriation of retained earnings',
    aumico_annual_report_proposal_description_profit: 'Proposal for the appropriation of profit',
    aumico_annual_report_proposal_description_loss: 'Proposal for the appropriation of loss',
    aumico_annual_report_label_cover_page: 'Cover Page Guide Title (will not be visible in the pdf)',
    aumico_annual_report_print_preview_cashflow: 'Cash flow statement',
    aumico_annual_report_label_table_of_contents: 'Table of Contents',
    aumico_annual_report_table_label_previous_year_date: 'Previous year date',
    aumico_core_data_grid_accounts: 'Accounts',
    aumico_annual_report_table_label_current_year_date: 'Balance sheet date',
    aumico_core_data_grid_all: 'all',
    aumico_core_data_grid_remove: 'Remove all accounts',
    aumico_core_data_grid_search_placeholder: 'Search',
    aumico_core_empty_data_grid_assigned_all_accounts: 'Great, you have assigned all accounts!',
    aumico_core_empty_data_grid_information_text: '-',
    aumico_core_empty_data_grid_information_title: '-',
    aumico_core_file_upload_extension_error: 'Please upload a .xlsx or a .xls file',
    aumico_core_file_upload_instruction_text: 'Drag & Drop the net balance of the client here',
    aumico_core_file_upload_instruction_label: 'Upload balance sheet',
    aumico_core_form_min_length_error: 'The minimum length for this input is',
    aumico_core_file_upload_title: 'File Upload',
    aumico_reports_action_bar_footer_back_to: 'Back to',
    aumico_reports_action_bar_footer_proceed_to: 'Save and continue to',
    aumico_reports_annualreport_toc_label_balance_sheet: 'Balance sheet',
    aumico_reports_annualreport_toc_label_cash_flow_statement: 'Cash flow statement',
    aumico_reports_annualreport_toc_label_notes_to_the_financial_statement: 'Notes to the financial statements',
    aumico_reports_annualreport_toc_label_income_statement: 'Income statement',
    aumico_reports_annualreport_cover_annual_label_title_prefix: 'Annual financial statement für die Periode',
    aumico_reports_annualreport_cover_quarterly_label_title_prefix: 'Quarterly financial statement für die Periode',
    aumico_reports_annualreport_cover_monthly_label_title_prefix: 'Monthly financial statement für die Periode',
    aumico_reports_annualreport_cover_custom_label_title_prefix: 'Financial statement für die Periode',
    aumico_templates_account_mapping_child_form_name: 'Name',
    aumico_templates_account_mapping_form_balance: 'Balance',
    aumico_templates_sub_fli_form_fli: 'Select account',
    aumico_templates_account_mapping_child_form_number: 'No.',
    aumico_templates_template_account_mapping_form_expand_all: 'Expand all',
    aumico_users_edit_user_company_general_information_city: 'City',
    aumico_users_edit_user_company_general_information_enter_no: 'Enter No.',
    aumico_users_edit_user_company_general_information_street: 'Street',
    aumico_users_edit_user_company_general_information_address_addition: 'Address Addition',
    aumico_users_edit_user_general_information_enter_email_address: 'Enter the E-Mail address',
    aumico_reports_annualreport_toc_label_table_of_contents: 'Table of contents',
    aumico_reports_annualreport_print_date_from: 'from',
    aumico_reports_annualreport_print_date_to: 'to',
    aumico_reports_annualreport_print_date_of: 'as of',
    aumico_users_edit_user_general_information_name: 'Name',
    aumico_users_edit_user_company_general_information_enter_city: 'Enter City',
    aumico_users_edit_user_general_information_surname: 'Surname',
    aumico_users_edit_user_company_general_information_name: 'Name',
    aumico_users_edit_user_security_enable_two_factor_authentication: 'Enable 2-Factor Authentication',
    aumico_users_edit_user_general_information_edit_your_profile: 'Edit Profile',
    aumico_templates_template_account_mapping_form_collapse_all: 'Collapse all',
    aumico_users_edit_user_general_information_enter_surname: 'Enter Surname',
    aumico_templates_caption: 'Caption',
    aumico_templates_subtotal_name: 'Subtotal name',
    aumico_templates_subtotal_scope: 'Subtotal scope',
    aumico_templates_subtotal_position_after: 'Select position before',
    aumico_templates_subtotal_select_position: 'Select Position',
    aumico_templates_subtotal_select_position_as_first_element: 'As first element',
    aumico_users_edit_user_general_information_select_salutation: 'Select the Salutation',
    aumico_users_edit_user_company_general_information_choose_country: 'Choose Country',
    aumico_users_edit_user_security_confirm_new_password: 'Confirm new password',
    aumico_users_aumico_form_error: 'aumico form error',
    aumico_users_edit_user_security_new_password: 'New Passowrd',
    aumico_users_edit_user_company_general_information_enter_name: 'Enter Name',
    aumico_users_edit_user_company_general_information_edit_your_profile: 'Edit Profile',
    aumico_users_edit_user_company_general_information_no: 'No.',
    aumico_users_edit_user_company_general_information_enter_zip: 'Enter Zip',
    aumico_users_edit_user_general_information_email_address: 'E-Mail Address',
    aumico_users_edit_user_general_information_choose_language: 'Choose the language',
    aumico_users_edit_user_general_information_langugage: 'Language',
    aumico_users_edit_user_general_information_enter_phone_number: 'Enter the phone number',
    aumico_users_edit_user_general_information_settings: 'Settings',
    aumico_users_edit_user_general_information_salutation: 'Salutation',
    aumico_users_edit_user_security_current_password: 'Current Password',
    aumico_users_edit_user_security_change_password: 'Change Password',
    aumico_users_edit_user_security_repeat_new_password: 'Repeat new Password',
    aumico_reports_annualreport_toc_label_proposal_for_the_appropriation_of_profit:
        'Proposal for the appropriation of profit',
    aumico_users_edit_user_security_enter_new_password: 'Enter new password',
    aumico_templates_account_mapping_form_income: 'Income',
    aumico_templates_template_account_mapping_form_mapped_accounts: 'Mapped Accounts',
    aumico_users_edit_user_company_general_information_country: 'Country',
    aumico_users_edit_user_company_general_information_enter_street: 'Enter Street',
    aumico_users_edit_user_company_general_information_zip: 'Postal Code',
    aumico_users_edit_user_general_information_enter_name: 'Enter the Name',
    aumico_users_edit_user_general_information_phone: 'Phone',
    aumico_users_edit_user_security_authentication: 'Authentication',
    aumico_users_edit_user_security_enter_current_password: 'Enter current password',
    aumico_templates_account_mapping_form_map_sme_account_plan: 'Auto Mapping / SME Account Plan',
    aumico_templates_account_mapping_form_datev_format_mismatch_warning:
        'The imported chart of accounts expects account purposes, but the uploaded file has none — the existing mapping is left unchanged.',
    aumico_templates_account_mapping_form_datev_unknown_purpose_warning: 'Unknown account purpose: {{key}}',
    aumico_templates_account_mapping_form_datev_purpose_shaped_value_warning:
        'Purpose-shaped value in the account-number path: {{key}}',
    aumico_templates_account_mapping_form_datev_no_candidate_warning: 'Account {{key}}: the DATEV file allows no unambiguous item. Please map it manually.',
    aumico_templates_account_mapping_form_datev_ambiguous_candidates_warning:
        'Account {{key}}: the DATEV file assigns it to several items ({{candidates}}). Please map it manually.',
    aumico_templates_account_mapping_form_datev_warnings_dismiss: 'Close message',
    aumico_templates_account_mapping_form_datev_unknown_format_warning:
        'Unknown assignment format on the template, account-number path used: {{key}}',
    aumico_annual_report_import_form_balance_end: 'Please specify the last row for balance accounts',
    aumico_annual_report_import_form_error_invalid_row_input: 'Invalid row input',
    aumico_annual_report_import_form_balance_start: 'Please specify the starting row for balance accounts',
    aumico_annual_report_import_form_error_overlapping: 'Ranges for balance & income accounts are overlapping',
    aumico_annual_report_import_form_income_end: 'Please specify the last row for income accounts',
    aumico_annual_report_import_form_income_start: 'Please specify the starting row for income accounts',
    aumico_annualreport_aop_word_before_currency: 'in',
    aumico_core_form_submit: 'Save',
    aumico_notes_word_in: 'in',
    aumico_reports_annualreport_cover_annual_label_title_1st_prefix: 'Annual financial statement',
    aumico_reports_annualreport_cover_quarterly_label_title_1st_prefix: 'Quarterly financial statement',
    aumico_reports_annualreport_cover_monthly_label_title_1st_prefix: 'Monthly financial statement',
    aumico_reports_annualreport_cover_custom_label_title_1st_prefix: 'Financial statement',
    aumico_reports_annualreport_page_print_account_mapping_label_total: 'Total',
    aumico_reports_annualreport_page_print_account_mapping_label_word_before_currency: 'in',
    aumico_reports_annualreport_page_print_account_mapping_label_notes: 'Notes',
    aumico_users_edit_user_general_information_salutations_mr: 'Mr',
    aumico_users_edit_user_general_information_salutations_mrs: 'Mrs',
    aumico_users_edit_user_general_information_languages_english_us: 'English (US)',
    aumico_users_edit_user_general_information_languages_german_switzerland: 'German (Switzerland)',
    aumico_users_edit_user_general_information_languages_german_germany: 'German (Germany)',
    aumico_users_edit_user_general_information_languages_italian_switzerland: 'Italian (Switzerland)',
    aumico_users_edit_user_general_information_languages_french_switzerland: 'French (Switzerland)',
    aumico_templates_group_account_mapping_create_subfli: 'SubFli',

    aumico_reports_annualreport_cover_label_title_2nd_prefix: 'for the period from',
    aumico_templates_sub_fli_form_fli_options_label: 'Choose Fli',
    aumico_annual_report_table_menu_option_archive: 'Archive',
    aumico_annual_report_table_menu_option_display_active: 'Display active',
    aumico_annual_report_table_menu_option_delete: 'Delete',
    aumico_annual_report_table_menu_option_restore: 'Restore',
    aumico_notes_fli_selection_placeholder: 'Select Position',
    aumico_notes_fli_drag_disabled_tooltip: 'All positions must be selected before dragging and dropping',
    aumico_annual_report_table_menu_option_display_archived: 'Display archived',
    aumico_notes_rich_text_placeholder: 'Insert text',
    aumico_reports_bexio_error:
        'Either you rejected to grant the needed permissions or an error occurred while processing your request',
    aumico_reports_unsaved_changes_warning_dialog_cancel: 'Cancel',
    aumico_notes_table_with_form_enter_placeholder: 'Enter',
    aumico_reports_unsaved_changes_warning_dialog_content: 'You have unsaved changes. Do you want to save your data?',
    aumico_reports_unsaved_changes_warning_dialog_discard: 'Discard changes',
    aumico_reports_unsaved_changes_warning_dialog_save: 'Save',
    aumico_reports_unsaved_changes_warning_dialog_save_unsuccessful: 'Saving is unsuccessful',
    aumico_annual_report_cash_flow_add_new_item: 'Add new item',
    aumico_annual_report_cash_flow_financing_activities_title: 'Cash flow from financing activities',
    aumico_annual_report_cash_flow_button_recalculate_flis: 'Reset',
    aumico_annual_report_cash_flow_investing_activities_disinvestments: 'Disinvestments',
    aumico_annual_report_cash_flow_investing_activities_title: 'Cash flow from investing activities',
    aumico_annual_report_cash_flow_investing_activities_investments: 'Investments',
    aumico_annual_report_cash_flow_operating_activities_title: 'Cash flow from business activities',
    aumico_annual_report_cash_flow_total: 'Total change in cash and cash equivalents',
    aumico_annual_report_cash_flow_total_operating_activities: 'Total change in cash from operating activities',
    aumico_annual_report_cash_flow_total_investing_activities: 'Total change in cash from investing activities',
    aumico_annual_report_cash_flow_total_financing_activities: 'Total change in cash from financing activities',
    aumico_annual_report_cash_flow_total_cashAndCashEnd: 'Cash and cash equivalents at end of period',
    aumico_annual_report_cash_flow_total_cashAndCashStart: 'Cash and cash equivalents at beginning of period',
    aumico_annual_report_cash_flow_total_total1_name: 'Total change in cash and cash equivalents',
    aumico_annual_report_cash_flow_total_total2: 'Total change in cash and cash equivalents',
    aumico_annual_report_print_options_label_show_reclasses_in_sums: 'including reclassifications',
    aumico_annual_report_print_options_mainTitle: 'Title',
    aumico_annual_report_cash_flow_total_total1: 'Total change in cash and cash equivalents',
    aumico_notes_component_options_movementschedule_column2: 'Column 2',
    aumico_notes_component_options_movementschedule_column3: 'Column 3',
    aumico_annual_report_print_options_date: 'Period',
    aumico_reports_annualreport_navigation_cfs: 'Cash flow statement',
    aumico_reports_annualreport_navigation_label_balance: 'Balance',
    aumico_templates_reclass_label_adjustment: 'Hidden reserves',
    aumico_annual_report_cash_flow_total_recapitulation: 'Recapitulation',
    aumico_annual_report_interpretation_remove_account_with_zero_balance: 'Remove accounts with zero balance',
    aumico_annual_report_print_options_show_cfs: 'Cash flow statement',
    aumico_templates_reclass_label_change_in_adjustment: '△ Adjust.',
    aumico_notes_component_options_movementschedule_column4: 'Column 4',
    aumico_templates_reclass_label_reclass: 'Reclass.',
    aumico_reports_annualreport_navigation_label_income: 'Income',
    aumico_annual_report_print_options_subTitle: 'Subtitle',
    aumico_templates_reclass_label_in: 'in',
    aumico_notes_preview_attention:
        'Attention: This section to show only how the component looks like and any change in it will not reflect on the saved data',
    aumico_templates_reclass_label_total: 'Total reclassifications',
    aumico_annual_report_cash_flow_total_total2_name: 'Total change in cash and cash equivalents',
    aumico_reports_annualreport_page_adjustments_label_account_number: 'Account Number',
    aumico_annual_report_print_options_label_show_adjustments_in_sums: 'Internal (incl. hidden reserves)',
    aumico_templates_reclass_label_income: 'Income statement',
    aumico_notes_component_options_movementschedule_column1: 'Column 1',
    aumico_reports_annualreport_navigation_adjustments_and_reclasses: 'Adjustments and Reclasses',
    aumico_templates_reclass_label_account_number: 'Account Number',
    aumico_templates_reclass_label_internal: 'Internal',
    aumico_annual_report_cash_flow_print_preview_notes: 'Notes',
    aumico_annual_report_print_options_decimal_and_empty_lines_title: 'Decimal and Empty Lines',
    aumico_annual_report_print_options_reclasses_and_internal_title: 'Values and ratios',
    aumico_annual_report_print_options_design_settings_title: 'Design and Formatting',
    aumico_annual_report_print_options_show_organization_logo: 'Organization logo',
    aumico_annual_report_print_options_show_company_logo: 'Print company logo',
    aumico_annual_report_print_options_show_components_title: 'Components',
    aumico_annual_report_print_options_show_accounts: 'Detailed accounts',
    aumico_annual_report_print_options_hide_previous_year: 'Hide previous year',
    aumico_annual_report_print_options_show_notes: 'Notes',
    aumico_companies_table_label_company_legal_status: 'Legal form',
    aumico_companies_table_label_status: 'Status',
    aumico_companies_table_new_button: 'Add New Company',
    aumico_companies_table_search_button: 'Search',
    aumico_companies_table_label_company_badge_active: 'Active',
    aumico_companies_table_label_company_badge_inactive: 'Inactive',
    aumico_companies_details_text: 'Company Details',
    aumico_companies_delete_dialog_ok: 'Delete',
    aumico_companies_delete_dialog_cancel: 'Cancel',
    aumico_companies_delete_dialog_text_2: 'This action is permanent and cannot be undone.',
    aumico_companies_activate_button: 'Activate',
    aumico_companies_activate_state: 'Active',
    aumico_companies_inactivate_state: 'Inactive',
    aumico_companies_changes_saved_successfully_dialog: 'The company was updated successfully.',
    aumico_companies_table_label_company_location: 'Location',
    aumico_companies_table_label_company_name: 'Company Name',
    aumico_companies_table_label_company_street_and_number: 'Street and Number',
    aumico_reports_main_navigation_company_list: 'Companies',
    aumico_reports_print_highlight_color_1: 'Highlight 1',
    aumico_reports_print_highlight_color_2: 'Highlight 2',
    aumico_companies_table_label_company_postal_code: 'Postal Code',
    aumico_templates_adjustmentAndReclassed_group_form_tooltip: 'Send change of adjustment to specific income accounts',
    aumico_templates_income_selection_popup_done_btn: 'Done',
    aumico_users_edit_user_company_general_information_upload_logo_label: 'Upload letterhead template',
    aumico_templates_income_selection_popup_title: 'Income accounts',
    aumico_users_edit_user_company_general_information_upload_logo_text:
        'Drag & Drop a pdf with the letterhead template here',
    aumico_reports_print_text_color: 'Text',
    aumico_users_edit_user_company_general_information_company_logo: 'Letterhead template',
    aumico_reports_main_navigation_edit_company: 'Edit / Create Company',
    aumico_reports_print_title_color: 'Title',
    aumico_reports_print_table_header_color: 'Table Header',
    aumico_reports_print_table_footer_color: 'Table Footer',
    aumico_reports_design_settings_select_colors_title: 'Select colors',
    aumico_reports_design_settings_preview_title: 'Preview',
    aumico_reports_design_settings_save_button: 'Save Settings',
    aumico_reports_design_settings_example_title: '1. Example Table',
    aumico_reports_design_settings_example_subtitle: '1.1 Example Subtitle',
    aumico_reports_design_settings_example_title_row: 'This is a example title row',
    aumico_reports_design_settings_example_normal_row: 'This is a example common row',
    aumico_reports_design_settings_example_footer_row: 'This is a example footer row',
    aumico_users_edit_user_company_general_information_upload_logo_extension_error: 'upload pdf file',
    aumico_annual_report_import_balance_and_income_from_separate_files_option:
        'Upload balance sheet & income statement separately',
    aumico_annual_report_import_definition_specify_data_start_line_1:
        'Specify the line number on which the data for accounts starts',
    aumico_annual_report_import_definition_specify_data_start_line_2: 'Table',
    aumico_annual_report_import_form_balance_instruction_text: 'Drag & Drop the balance file of the client here',
    aumico_annual_report_import_form_income_instruction_text: 'Drag & Drop the income file of the client here',
    aumico_annual_report_import_optional_settings_title: 'Optional settings',
    aumico_annual_report_aop_accounts_placeholder: 'Select account',
    aumico_annual_report_general_information_autofill_from_list_btn_text: 'Choose annual report to autofill from',
    aumico_annual_report_general_information_autofill_from_previous_year_btn_text:
        'Autofill annual report from previous year',
    aumico_annual_report_general_information_balance_sheet: 'Balance sheet',
    aumico_annual_report_general_information_current_year: 'Current year',
    aumico_annual_report_general_information_date_from: 'From',
    aumico_annual_report_general_information_date_to: 'To',
    aumico_annual_report_general_information_income_current_date_from_error:
        'Income current from date must be less than current to date & greater than or equal previous to date',
    aumico_annual_report_general_information_income_current_date_to_error: 'End date is before start date',
    aumico_annual_report_general_information_income_previous_date_from_error:
        'Income previous from date must be less than previous to date',
    aumico_annual_report_general_information_income_previous_date_to_error:
        'Income previous to date must be less than or equal current from date & greater than previous from date',
    aumico_annual_report_general_information_income_statement: 'Income statement',
    aumico_annual_report_general_information_no_previous_data: 'No previous data available (foundation)',
    aumico_annual_report_general_information_optional_or: 'or',
    aumico_annual_report_general_information_options: 'Options',
    aumico_annual_report_general_information_please_determine_income_date: 'Determine the income statement date',
    aumico_annual_report_general_information_previous_period: 'Previous period',
    aumico_annual_report_general_information_take_autofill_from_previous_annual_report:
        'Copy configuration from the previous year without data',
    aumico_annual_report_general_information_take_previous_data_from_annual_report:
        'Transfer data from the previous year (upload only actual year)',
    aumico_annual_report_import_choose_annual_report_for_autofill_and_mapping_button:
        'Choose the annual report to take upload/mapping autofill from',
    aumico_annual_report_import_select_annual_report_for_autofill_and_mapping:
        'Select an annual report to take upload/mapping autofill from',
    aumico_annual_report_selection_list_accounting_basis: 'Accounting Basis',
    aumico_annual_report_selection_list_company: 'Company',
    aumico_annual_report_selection_list_current_year_date: 'Current Year',
    aumico_annual_report_selection_list_legal_form: 'Legal Form',
    aumico_new_button: 'New',
    aumico_reports_annualreport_page_financial_statement_general_information_label_general_information:
        'General information',
    aumico_reports_print_page_adjustments_reclasses_warning:
        'Please be aware that manually performed changes in cash flow statement might be overwritten through internal values.',
    aumico_reports_print_title_establishment: 'Establishment',
    aumico_reports_warning_popup_warning_title: 'Warning',
    aumico_search_placeholder: 'Search',
    aumico_templates_account_mapping_form_map_income_total: 'Transfer annual result to balance',
    aumico_templates_account_mapping_form_transferred_profit_account_name: 'Transferred profit',
    aumico_annual_report_print_options_disable_balance_sheet_page_break: 'Balance on one page',
    aumico_annual_report_print_options_place_signature_after_aop: 'Place signature after AOP',
    aumico_core_data_grid_items: 'items',
    aumico_core_pagination_action_bar_range_text: 'of',
    aumico_core_accordion_Information_dialog_title: 'Information',
    aumico_core_table_filter_placeholder: 'Filter',
    aumico_users_company_profile_general_information_side_margins: 'Page margins: 1.5cm from all sides',
    aumico_admin_navigation_accounting_basis: 'Accounting Basis',
    aumico_admin_navigation_change_password: 'Change Password',
    aumico_admin_navigation_aumico_users: 'aumico Users',
    aumico_admin_navigation_home: 'Home',
    aumico_admin_navigation_legal_form: 'Legal Form',
    aumico_admin_navigation_financial_line_item: 'Financial Line Item',
    aumico_admin_navigation_localization: 'Localization',
    aumico_admin_navigation_logout: 'Logout',
    aumico_admin_navigation_manage: 'Manage',
    aumico_admin_navigation_login: 'Login',
    aumico_admin_navigation_notes: 'Notes',
    aumico_admin_navigation_settings: 'Settings',
    aumico_admin_navigation_signup: 'Sign up',
    aumico_admin_navigation_templates: 'Templates',
    aumico_admin_navigation_user_management: 'User Management',
    aumico_admin_navigation_types: 'Types',
    aumico_annual_report_cash_flow_mandatory_field: 'The following field is mandatory',
    aumico_admin_user_already_exists: 'User already exists',
    aumico_settings_financialLineItem_form_name_already_exists_error: 'Financial line item name already exists',
    aumico_settings_accountingbasis_form_name_already_exists_error: 'Accounting basis name already exists',
    aumico_settings_legalForm_form_name_already_exists_error: 'Legal form name already exists',
    aumico_annual_report_general_information_company: 'Company',
    aumico_reports_main_navigation_user_profile: 'Edit User Profile',
    aumico_annual_report_print_options_show_fli_total: 'FlI totals',
    aumico_reports_internal_mapping_changes_warning:
        'The system made some mapping changes so please save if you want to keep them.',
    aumico_annual_report_interpretation_account_number_invalid_input:
        'Only positive numbers or ranges (e.g. 3 or 3-5) are allowed',
    aumico_reports_welcome_page_footer_about_link: 'https://aumico.io/en/agb/',
    aumico_reports_welcome_page_footer_impressum_link: 'https://aumico.io/impressum/',
    aumico_reports_welcome_page_footer_privacy_policy_link:
        'https://aumico.io/en/datenschutz/aumico_reports_welcome_page_footer_impressum_link',
    aumico_templates_group_account_mapping_unallowed:
        'Mapping of the selected accounts to the desired FlI is not allowed because it contains one or more sub fli.',
    aumico_information_dialog_title: 'Information',
    aumico_reports_equality_check_dialog_assets_and_liabilities_closing_not_equal:
        'Assets is not equal to Liabilities and equity in current year',
    aumico_reports_equality_check_dialog_assets_and_liabilities_opening_and_closing_not_equal:
        'Assets is not equal to Liabilities and equity in both current and previous years',
    aumico_reports_equality_check_dialog_assets_and_liabilities_opening_not_equal:
        'Assets is not equal to Liabilities and equity in previous year',
    aumico_reports_equality_check_dialog_cashflow_totals_closing_not_equal:
        'Cashflow totals are not equal in the current year',
    aumico_reports_equality_check_dialog_cashflow_totals_opening_and_closing_not_equal:
        'Cashflow totals are not equal in both current and previous years',
    aumico_reports_equality_check_dialog_cashflow_totals_opening_not_equal:
        'Cashflow totals are not equal in the previous year',
    aumico_reports_equality_check_dialog_go_back_and_correct_it: 'Go back and correct it',
    aumico_potential_impact_on_all_users_utilizing_that_template_will_occur:
        'a potential impact on all users utilizing that template will occur en',
    aumico_reports_equality_check_dialog_proceed: 'Proceed',
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_closing_not_equal:
        'Profit Income is not equal to Profit FLI in the current year',
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_opening_and_closing_not_equal:
        'Profit Income is not equal to Profit FLI in both current and previous years',
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_opening_not_equal:
        'Profit Income is not equal to Profit FLI in the previous year',
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_closing_not_equal:
        'Total adjustments assets and total adjustments liabilities are not equal in the current year',
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_opening_and_closing_not_equal:
        'Total adjustments assets and total adjustments liabilities are not equal in both current and previous years',
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_opening_not_equal:
        'Total adjustments assets and total adjustments liabilities are not equal in the previous year',
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_closing_not_equal:
        'Total adjustments income and total adjustments profit fli are not equal in the current year',
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_opening_and_closing_not_equal:
        'Total adjustments income and total adjustments profit fli are not equal in both current and previous years',
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_opening_not_equal:
        'Total adjustments income and total adjustments profit fli are not equal in the previous year',
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_opening_and_closing_not_equal:
        'Total reclasses assets and total reclasses liabilities are not equal in both current and previous years',
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_closing_not_equal:
        'Total reclasses assets and total reclasses liabilities are not equal in the current year',
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_closing_not_equal:
        'Total reclasses income and total reclasses profit fli are not equal in the current year',
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_opening_and_closing_not_equal:
        'Total reclasses income and total reclasses profit fli are not equal in both current and previous years',
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_opening_not_equal:
        'Total reclasses income and total reclasses profit fli are not equal in the previous year',
    aumico_reports_equality_check_print_preview_table_adjustments: 'Adjustments',
    aumico_reports_equality_check_print_preview_information_dialog_content:
        'Our consistency checks help you to avoid errors in your financial statements.',
    aumico_reports_equality_check_print_preview_table_adjustments_profit_income_equals_adjustments_profit_balance:
        'Adjustments Profit Income = Adjustments Profit Balance',
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_opening_not_equal:
        'Total reclasses assets and total reclasses liabilities are not equal in the previous year',
    aumico_reports_equality_check_print_preview_table_assets_equal_liabilities: 'Assets = Liabilities',
    aumico_reports_equality_check_print_preview_table_current_year_column: 'Current Year',
    aumico_reports_equality_check_print_preview_table_cashflow_statement: 'Cashflow Statement',
    aumico_reports_equality_check_print_preview_table_previous_year_row: 'Previous Year',
    aumico_reports_equality_check_print_preview_table_profit_income_equals_profit_fli: 'Profit Income = Profit FLI',
    aumico_reports_equality_check_print_preview_table_previous_year_column: 'Previous Year',
    aumico_reports_equality_check_print_preview_table_reclasses_profit_income_equals_reclasses_profit_balance:
        'Reclasses Profit Income = Reclasses Profit Balance',
    aumico_reports_equality_check_print_preview_table_current_year_row: 'Current Year',
    aumico_reports_equality_check_print_preview_table_title: 'Overview',
    aumico_reports_equality_check_print_preview_table_reclasses: 'Reclasses',
    aumico_reports_equality_check_print_preview_title: 'Consistency Checks',
    aumico_reports_required_data_not_completed: 'The data from the previous steps is no completed yet!',
    aumico_reports_template_not_found: 'There is no template found with the selected legal form and account basis',
    aumico_reports_error_dialog_something_went_wrong: 'Something went wrong',
    aumico_annual_report_print_options_label_income_ratio_reference: 'Income Ratio Reference',
    aumico_annual_report_print_options_income_ratio_reference_internal_change_warning_message:
        'Please be aware that the value you selected as income ratio reference has been changed by the system.This is due to the fact that the opening or closing value of the previously selected item became 0',
    aumico_annual_report_print_options_label_show_ratios: 'Ratios',
    aumico_companies_notification_error_description: 'The company could not be updated.',
    aumico_reports_notification_information_title: 'Information',
    aumico_reports_notification_success_title: 'Successfully updated',
    aumico_reports_default_page_header: 'Undefined',
    aumico_reports_notification_error_title: 'Something went wrong',
    aumico_admin_edit_user_profile: 'Edit user profile',
    aumico_core_information_popup_default_title: 'Information',
    aumico_templates_group_form_enter_group_title_error: 'Please enter group title',
    aumico_templates_group_form_enter_group_total_name_error: 'Please enter group total name',
    aumico_templates_group_form_title: 'Group title',
    aumico_templates_group_form_total_name: 'Group total name (Total ...)',
    aumico_annual_report_complementary_reports_add_report_button: 'Add report',
    aumico_annual_report_complementary_reports_description:
        'Add additional reports to your financial statements such as management summary, a declaration of completeness or many more.',
    aumico_annual_report_complementary_reports_headline: 'Complementary reports',
    aumico_annual_report_complementary_reports_report_rich_text_placeholder: 'Enter your text',
    aumico_annual_report_complementary_reports_report_title: 'Report title',
    aumico_annual_report_complementary_reports_title_error: 'Title is required',
    aumico_annual_report_print_options_show_complementary_reports: 'Complementary reports',
    aumico_empty_field_error: 'This field is mandatory',
    aumico_reports_annualreport_navigation_complementary_reports: 'Complementary Reports',
    aumico_users_personal_information_language_error: 'Language is required',
    aumico_users_personal_information_organization_label: 'Name of your organization',
    aumico_users_personal_information_language_section_title: 'Choose your language',
    aumico_users_registration_email_username_placeholder: 'Pleas enter your E-Mail address',
    aumico_users_personal_information_sub_title: 'Please provide us with the following information:',
    aumico_users_personal_information_main_title: 'We would like to get to know you',
    aumico_users_registration_password_label: 'Set password',
    aumico_users_registration_password_placeholder: 'Please enter password',
    aumico_users_registration_email_username_required_error: 'Business e-mail address is required',
    aumico_users_personal_information_organization_error: 'Organization is required',
    aumico_users_reset_password_button: 'Reset Password',
    aumico_users_signup_continue_button: 'Continue',
    aumico_users_signup_creating_your_account_button: 'Creating your account',
    aumico_users_registration_read_and_agree: 'I have read the',
    aumico_users_registration_main_title: 'Start your 10-day free trial! ',
    aumico_annual_report_ems_add_new_item_button_text: '+ New row',
    aumico_annual_report_ems_total_equity_header_text: 'Total Equity',
    aumico_annual_report_ems_new_total_column: 'New total',
    aumico_annual_report_ems_manual_column: 'Manually added column',
    aumico_annual_report_ems_row_title: 'Equity as of',
    aumico_annual_report_ems_business_year: 'Financial year',
    aumico_annual_report_ems_difference_to: 'Difference from Equity as of',
    aumico_annual_report_ems_position_column_header: 'Item / movement',
    aumico_annual_report_ems_add_column: '+ New column',
    aumico_annual_report_ems_add_column_limit: 'The PDF can display a maximum of 8 columns.',
    aumico_annual_report_ems_column_type_select_label: 'Select column type',
    aumico_annual_report_ems_column_type_value: 'Value column',
    aumico_annual_report_ems_column_type_value_description: 'Item with enterable values',
    aumico_annual_report_ems_column_type_total: 'Total column',
    aumico_annual_report_ems_column_type_total_description: 'Sum of selected value columns',
    aumico_annual_report_ems_structure_diff_intro: 'The account structure in the mapping has changed.',
    aumico_annual_report_ems_structure_diff_new: 'Newly added: {{names}}.',
    aumico_annual_report_ems_structure_diff_removed: 'No longer in the mapping: {{names}}.',
    aumico_annual_report_ems_structure_diff_apply: 'Update columns',
    aumico_annual_report_print_options_show_ems: 'Equity Movement Schedule',
    aumico_reports_annualreport_navigation_equity_movement_schedule: 'Equity Movement',
    aumico_reports_annualreport_navigation_fixed_assets_schedule: 'Fixed Assets Schedule',
    aumico_reports_annualreport_navigation_reorder_report_and_print: 'Print in different order',
    aumico_reports_equity_movement_schedule_no_table_shown_error_message:
        'There are no flis in the equity group eligible for equity movement schedule',
    aumico_reports_reorder_report_cover_section_title: 'Cover',
    aumico_reports_reorder_report_section_save_button: 'Save',
    aumico_reports_reorder_report_sections_dialog_title: 'Reorder Report Sections',
    aumico_annual_report_ems_text_addition_above_title: 'Introduction',
    aumico_annual_report_ems_text_addition_below_title: 'Note',
    aumico_annual_report_ems_title: 'Equity movement schedule',
    aumico_annual_report_print_preview_ems: 'Equity movement schedule',
    aumico_reports_main_navigation_organization_settings: 'Organization settings',
    aumico_reports_main_navigation_design_settings: 'Design Settings',
    aumico_reports_organization_settings_navigation_organization_profile: 'Profile',
    aumico_reports_organization_settings_navigation_text_snippets: 'Report templates',
    aumico_reports_organization_settings_text_snippets_title: 'Report templates',
    aumico_annual_report_complementary_reports_delete_icon_text: 'Delete',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_cancel_button: 'Cancel',
    aumico_annual_report_complementary_reports_prefill_with_text_snippet_icon_text: 'Prefill with report template',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_description:
        'Are you sure ? You are going to overwrite your text box',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_yes_button: 'Yes',
    aumico_annual_report_complementary_reports_text_snippets_dialog_description: 'Description',
    aumico_annual_report_complementary_reports_text_snippets_dialog_insert_text_snippet_button: 'Insert template',
    aumico_annual_report_complementary_reports_text_snippets_dialog_title: 'Insert predefined template',
    aumico_reports_equity_movement_schedule_refresh_button_text: 'Refresh EMS',
    aumico_reports_organization_settings_text_snippets_add_new_button: 'Add new',
    aumico_reports_organization_settings_text_snippets_create_dialog_title: 'Add new template',
    aumico_reports_organization_settings_text_snippets_form_dialog_content_field_required_error: 'Content is required',
    aumico_reports_organization_settings_text_snippets_form_dialog_create_conflict_error_notification_description:
        'Failed to create text snippet: description already exists',
    aumico_reports_organization_settings_text_snippets_form_dialog_create_success_notification_description:
        'Text snippet created successfully',
    aumico_reports_organization_settings_text_snippets_form_dialog_create_internal_server_error_description:
        'Failed to create text snippet: Internal server error',
    aumico_reports_organization_settings_text_snippets_form_dialog_cancel_button: 'Cancel',
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field_already_exists_error:
        'Description already exists',
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field_required_error:
        'Description required',
    aumico_reports_organization_settings_text_snippets_form_dialog_save_button: 'Save',
    aumico_reports_organization_settings_text_snippets_form_dialog_error_notification_title: 'Error',
    aumico_reports_organization_settings_text_snippets_form_dialog_title_field: 'Title',
    aumico_reports_organization_settings_text_snippets_list_created_by_column_header: 'Created by',
    aumico_reports_organization_settings_text_snippets_form_dialog_title_field_required_error: 'Title required',
    aumico_reports_organization_settings_text_snippets_list_created_at_column_header: 'Created at',
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field: 'Description',
    aumico_reports_organization_settings_text_snippets_list_delete_error_notification_description:
        'Failed to delete text snippets: internal server error',
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_description:
        'Are you sure you want to delete the selected text snippets ?',
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_yes_button: 'Yes',
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_cancel_button: 'Cancel',
    aumico_reports_organization_settings_text_snippets_list_delete_success_notification_title: 'Successful',
    aumico_reports_organization_settings_text_snippets_list_last_modified_column_header: 'Last modified',
    aumico_reports_organization_settings_text_snippets_form_dialog_success_notification_title: 'Success',
    aumico_reports_organization_settings_text_snippets_list_delete_success_notification_description:
        'Text snippets deleted successfully',
    aumico_reports_organization_settings_text_snippets_list_description_column_header: 'Description',
    aumico_reports_organization_settings_text_snippets_list_title_column_header: 'Title',
    aumico_reports_organization_settings_text_snippets_list_delete_button: 'Delete',
    aumico_reports_organization_settings_text_snippets_list_delete_error_notification_title: 'Error',
    aumico_reports_organization_settings_text_snippets_list_modified_by_column_header: 'Modified by',
    aumico_admin_ar_template_data_not_completed_error: 'General Information data must be completed first',
    aumico_admin_ar_template_define_pdf_template: 'Define PDF Template',
    aumico_admin_ar_template_download_pdf_template: 'Download PDF Template',
    aumico_admin_ar_template_general_information_accounting_bases: 'Accounting Bases',
    aumico_admin_ar_template_general_information_annual_report_steps: 'Annual Report Navigation Steps',
    aumico_admin_ar_template_general_information_consistency: 'Consistency',
    aumico_admin_ar_template_general_information_countries: 'Country',
    aumico_admin_ar_template_general_information_field_required_error: 'This field is required',
    aumico_admin_ar_template_general_information_legal_forms: 'Legal Forms',
    aumico_admin_ar_template_general_information_business_models: 'Business Model',
    aumico_admin_ar_template_general_information_state: 'State',
    aumico_admin_ar_template_general_information_name: 'Name',
    aumico_admin_ar_template_list_delete_error_notification_description: 'Failed to delete annual report template',
    aumico_admin_ar_template_list_delete_failed_notification_title: 'Error',
    aumico_admin_ar_template_list_delete_success_notification_description:
        'Annual report template deleted successfully',
    aumico_admin_ar_template_list_menu_item_delete: 'Delete',
    aumico_admin_ar_template_navigation_general_information: 'General Information',
    aumico_admin_ar_template_list_delete_success_notification_title: 'Success',
    aumico_admin_ar_template_navigation_balance_sheet_taxonomy: 'Balance Sheet Taxonomy',
    aumico_admin_ar_template_navigation_income_statement_taxonomy: 'Income Statement Taxonomy',
    aumico_admin_ar_template_pdf_error_notification_description_file_too_large:
        'Failed to upload PDF Template: file is too large',
    aumico_admin_ar_template_navigation_notes: 'Notes',
    aumico_admin_ar_template_navigation_pdf_template: 'Pdf Template',
    aumico_admin_ar_template_pdf_updated_success_notification_description: 'PDF template updated Successfully',
    aumico_admin_countries_label: 'Countries',
    aumico_admin_ar_template_table_actions: 'actions',
    aumico_admin_ar_template_specifications: 'Specifications',
    aumico_admin_ar_template_pdf_error_notification_description_file_type_invalid:
        'Failed to upload PDF Template: file type must be docx',
    aumico_admin_menu_item_demote_to_admin: 'Demote Admin',
    aumico_admin_navigation_ar_templates: 'AR Templates',
    aumico_admin_menu_item_unblock_user: 'Unblock User',
    aumico_admin_menu_item_promote_to_admin: 'Promote to Admin',
    aumico_admin_menu_item_block_user: 'Block User',
    aumico_admin_user_list_notification_failure_description: 'Error Occurred please try again later or contact us',
    aumico_admin_user_list_notification_success_title: 'Success',
    aumico_admin_user_list_notification_success_description: 'User Updated Successfully',
    aumico_admin_user_list_notification_failure_title: 'failure',
    aumico_admin_user_list_status_inactive: 'inactive',
    aumico_admin_usermanagement_confirmation_modal_change_user_role: 'Do you want to change role of {email} from',
    aumico_admin_usermanagement_confirmation_modal_change_user_activity_state: 'Do you want to change {email} from',
    aumico_admin_usermanagement_confirmation_modal_cancel_button: 'cancel',
    aumico_admin_usermanagement_confirmation_modal_title_block_user: 'Block User',
    aumico_admin_usermanagement_confirmation_modal_title_promote_admin: 'Promote to Admin',
    aumico_admin_usermanagement_confirmation_modal_title_unblock_user: 'unblock User',
    aumico_admin_usermanagement_confirmation_modal_title_demote_admin: 'Demote Admin',
    aumico_admin_navigation_aumico_organization: 'aumico Organizations',
    aumico_annual_report_import_page_can_not_navigate_to_mapping_dialog_description:
        'You have to upload data first to navigate to mapping step',
    aumico_annual_report_print_options_experimental_section: 'Create your own design',
    aumico_annual_report_print_options_experimental_section_description:
        'Create your own design including font style and layout. Contact us at sales@aumico.ch for more information. We will get in touch with you.',
    aumico_annual_report_print_options_aop: 'Appropriation Of Profit',
    aumico_annual_report_print_options_fin_statement: 'Financial Statement',
    aumico_annual_report_print_options_hide_decimal_places_in_values: 'Hide decimal places in values',
    aumico_annual_report_print_options_hide_decimal_places_in_ratios: 'Hide decimal places in ratios',
    aumico_annual_report_print_options_hide_empty_lines: 'Remove empty lines',
    aumico_admin_user_list_status_active: 'Active',
    aumico_annual_report_print_options_show_account_numbers: 'Show account numbers',
    aumico_change_password_notification_success: 'Password Changed Successfully',
    aumico_change_password_notification_failed_title: 'Failed!',
    aumico_change_password_relogin_title: 'Password changed',
    aumico_change_password_relogin_description: 'Your password has been changed. Please log in again.',
    aumico_change_password_relogin_failed_title: 'Log in again',
    aumico_change_password_relogin_failed_description: 'Your password was not changed. Please log in again.',
    aumico_change_password_relogin_button: 'Log out',
    aumico_change_password_notification_failed: 'Error occurred while changing password',
    aumico_admin_usermanagement_confirmation_modal_confirm_button: 'confirm',
    aumico_companies_form_country_has_no_legal_form: "this country doesn't contain your previous selected legal form",
    aumico_editable_account_number_unique_validator: 'Account Number should be unique',
    aumico_editable_account_invalid_data_modal_title: 'invalid data',
    aumico_editable_account_invalid_data_modal_content: 'Account name and account number are required.',
    aumico_editable_account_placeholder_name: 'Account name',
    aumico_annual_report_country_has_no_legal_account_basis: "No available account basis for company's country",
    aumico_editable_account_placeholder_opening_value: 'Previous year',
    aumico_general_information_autofill_date_popup_autofill_btn: 'Autofill',
    aumico_editable_account_placeholder_number: 'Number',
    aumico_general_information_autofill_date_popup_no_autofill_btn: "Don't autofill",
    aumico_annual_report_print_options_experimental_section_text:
        'Please note that this print options only work if you are printing with the new print button and the are not reflected in the preview.',
    aumico_googleidp_invalid_code_error_message_title: 'Expired or Invalid Code',
    aumico_invitation_expired_description:
        'It appears your invitation code has expired, please contact an adminstrator',
    aumico_notification_resend_email_failed_content: 'Failure in sending an email, please try again later',
    aumico_googleidp_invalid_code_error_message_content:
        'Your verification email expired. Click the button to resend email',
    aumico_notification_resend_email_success_content: 'Email sent successfully, please check your mail',
    aumico_notification_resend_email_success: 'Success!',
    aumico_annual_report_print_options_notes: 'Notes',
    aumico_reports_ar_templates_list_dialog_save_button: 'Save Chosen Annual Report Template',
    aumico_notification_resend_email_failure: 'Failure',

    aumico_reports_invitation_intro: "You've been invited by {inviterName}",
    aumico_change_password_notification_success_title: 'Successful',
    aumico_reports_ar_templates_list_dialog_title: 'Annual Report Templates',
    aumico_reports_invite_new_users_dialog_input_placeholder: 'Add Email Address',
    aumico_reports_invite_users_email_already_exist_error_message:
        'The following e-mails were not invited because e-mails already exist in another organization',
    aumico_reports_invite_users_cannot_invite_same_organization_users:
        'The following e-mails were not invited because e-mails already exist in your organization',
    aumico_reports_organization_navigation_users: 'Users',
    aumico_reports_invite_users_success_message: 'Users have been invited successfully',
    aumico_reports_invite_new_users_dialog_title: 'Invite a New User to the Organization',
    aumico_reports_invite_new_users_dialog_save_button: 'Send Invite',
    aumico_reports_remove_users_success_message: 'Users have been removed successfully',
    aumico_reports_organization_settings_text_snippets_form_dialog_update_success_notification_description:
        'Text snippet updated successfully.',
    aumico_editable_account_placeholder_closing_value: 'Reporting period',
    aumico_users_organization_change_organization_state_modal_confirm_no_action: 'Cancel',
    aumico_user_email_already_exists_error: 'The email address is already in use by another account',
    aumico_reports_no_annualreport_template_defined:
        'There is no annual report template defined for the selected legal form and accounting basis and specified country',
    aumico_reports_invite_users_wrong_data_error_message: 'Wrong data has been sent',
    aumico_general_information_autofill_date_popup_content: 'Do you want to autofill other dates?',
    aumico_users_organization_users_table_email_label: 'E-Mail',
    aumico_users_organization_users_remove_cancel_button: 'Cancel',
    aumico_reports_print_page_data_not_available: 'No data available',
    aumico_users_organization_users_table_phone_number_label: 'Phone Number',
    aumico_users_organization_users_table_role_label: 'Role',
    aumico_users_organization_users_table_date_added_label: 'Date Added',
    aumico_users_organization_users_table_status_label: 'Status',
    aumico_users_organization_users_table_pending_label: 'Pending',
    aumico_users_organization_users_table_active_label: 'Active',
    aumico_users_organization_users_table_resend_invite: 'Resend Invite',
    aumico_users_organization_users_table_withdraw_invite_action: 'Withdraw Invite',
    aumico_users_organization_users_table_resend_invite_action: 'Resend Invite',
    aumico_users_organization_users_table_withdraw_invite_modal_title: 'Withdraw Invitation',
    aumico_users_organization_users_table_resend_invite_modal_title: 'Resend Invitation',
    aumico_reports_organization_settings_text_snippets_update_dialog_title: 'Update Text Snippet',
    aumico_invitation_expired_title: 'Invitation Code Expired',
    aumico_users_organization_change_organization_state_modal_confirm_action: 'Confirm',
    aumico_users_organization_change_organization_state_action: 'Change State',
    aumico_reports_annualreport_navigation_print_using_pdf_tron: 'Export PDF',
    aumico_users_organization_users_remove_confirmation_button: 'Remove',
    aumico_users_organization_users_remove_confirmation_text:
        'The selected users will lose their access to the platform. Are you sure you want to remove them?',
    aumico_reports_invite_new_users_dialog_input_label: 'Add e-mail address',
    aumico_users_organization_users_table_remove_users: 'Remove from organization',
    aumico_reports_invite_users_failure_okay_button_label: 'OK',
    aumico_reports_organization_settings_text_snippets_form_dialog_update_error_notification_description:
        'Failed to update text snippet: internal server error',
    aumico_reports_remove_users_user_removing_self_error_message: 'You cannot remove yourself from the users',
    aumico_users_organization_change_organization_state_modal_title: 'Change Organization State',
    aumico_users_organization_users_table_name_label: 'User',
    aumico_admin_home_welcome_label: 'EN - Welcome to the administration interface!',
    aumico_reports_share_annual_report_dialog_text:
        'Wants to share a financial statement. Do you want to accept the share of this organization?',
    aumico_reports_share_annual_report_dialog_accept_button: 'Accept',
    aumico_reports_share_annual_report_dialog_decline_button: 'Decline',
    aumico_annual_report_table_menu_option_per_row_secure_share: 'Share',
    aumico_reports_share_annual_report_dialog_title: 'Share Annual Report',
    aumico_reports_share_annual_report_dialog_content: 'You can share annual report with any email address',
    aumico_reports_invitation_dialog_validation_message_enter_valid_email: 'Please enter a valid email address',
    aumico_reports_share_annual_report_dialog_input_label: 'email',
    aumico_reports_share_annual_report_dialog_save_button: 'Share',
    aumico_reports_annualreport_footer_share_annual_report: 'Secure Share',
    aumico_reports_customer_attraction_dialog_title: 'Curious about how you can use aumico with your company ?',
    aumico_reports_customer_attraction_dialog_button_text: 'Talk to us',
    aumico_reports_customer_attraction_dialog_text_below_button: 'or call us: +12 345 67686',
    aumico_reports_customer_attraction_dialog_descriptive_text:
        'We have some great solutions for Pellentesque sem mi sapien diam sem sed porttitor. Feugiat ultrices molestie varius adipiscing vitae amet tempor amet. Pharetra vulputate sagittis bibendum. ',
    aumico_reports_share_annual_report_confirmation_dialog_message: 'Are you sure you want to share your report with: ',
    aumico_reports_share_annual_report_confirmation_go_back_cancel_button: 'go back',
    aumico_reports_share_annual_report_confirmation_dialog_save_button: 'Yes, Share',
    aumico_reports_share_annual_report_success_notification_title: 'Shared successfully',
    aumico_reports_share_annual_report_success_notification_description: 'Your Annual Report has Shared Successfully',
    aumico_annual_report_print_only: 'Print',
    aumico_annual_reports_export_excel: 'Export Excel',
    aumico_annual_report_export_to_word: 'Export Word',
    aumico_admin_navigation_translations: 'Translations',
    aumico_admin_translations_expand_all: 'Expand All',
    aumico_admin_translations_collapse_all: 'Collapse All',
    aumico_admin_translations_show_only_untranslated: 'Show only untranslated',
    aumico_admin_translations_save: 'Save',
    aumico_admin_translations_notes_types: 'Notes Types',
    aumico_admin_translations_notes_templates: 'Notes Templates',
    aumico_admin_translations_accounting_bases: 'Accounting Bases',
    aumico_admin_translations_tasks: 'Tasks',
    aumico_admin_translations_checklists: 'Checklists',
    aumico_admin_translations_legal_forms: 'Legal Forms',
    aumico_admin_translations_financial_line_items: 'Financial Line Items',
    aumico_admin_translations_groups: 'Groups',
    aumico_admin_translations_name_column_header: 'Name',
    aumico_admin_filter_translation_by_name: 'Filter Translations',
    aumico_reports_error_dialog_bad_request: 'Bad request',
    aumico_reports_error_dialog_bad_request_first_and_last_names_required: 'First and last names are required',
    aumico_reports_error_dialog_bad_request_phone_number_invalid:
        'Phone number must be in the correct format and must not be empty. Correct format: +<country_code><phone_number>',
    aumico_annual_report_print_preview_fcp: 'Financial Closing Process',
    aumico_annual_report_print_preview_fas: 'Fixed Assets Schedule',
    aumico_annual_report_fas_section_costs_title: 'Acquisition and Production Costs',
    aumico_annual_report_fas_section_depr_title: 'Depreciations',
    aumico_annual_report_fas_section_valAppr_title: 'Value Appreciations',
    aumico_annual_report_fas_select_reference: 'Select Reference',
    aumico_annual_report_fas_remove_group: 'Remove Group',
    aumico_annual_report_fas_add_group: 'Add Group',
    aumico_annual_report_fas_remove_column: 'Remove Column',
    aumico_annual_report_fas_add_column: 'Add Column',
    aumico_annual_report_fas_costs: 'AHK',
    aumico_annual_report_fas_additions_column: 'Additions',
    aumico_annual_report_fas_disposals_column: 'Disposals',
    aumico_annual_report_fas_transfers_column: 'Transfers',
    aumico_annual_report_fas_depr_additions_column: 'Depreciation for the period',
    aumico_annual_report_fas_depr_disposals_column: 'Disposals',
    aumico_annual_report_fas_depr_transfers_column: 'Transfers',
    aumico_annual_report_fas_depr_cumulated: 'Cumulated Depreciations',
    aumico_annual_report_fas_valueAppreciation: 'Value Appreciations',
    aumico_annual_report_fas_bookvalue_current: 'Book value',
    aumico_annual_report_fas_bookvalue_previous: 'Book value',
    aumico_annual_report_fas_depreciations: 'Depreciations',
    aumico_annual_report_fas_direct_assigned_accounts: 'directly assigned accounts',
    aumico_annual_report_fas_file_upload_instruction_label: 'Upload your fixed assets file',
    aumico_annual_report_datev_error_detected:
        'We have discovered at least one error! Please correct the errors or use a different file.',
    aumico_annual_report_datev_error_malformatted_file: 'Malformatted file',
    aumico_annual_report_datev_error_wrong_asset_data: 'Assets cannot be interpreted',
    aumico_annual_report_datev_error_wrong_liabilties_data: 'Liabilities cannot be interpreted',
    aumico_annual_report_datev_error_wrong_income_data: 'Income statement cannot be interpreted',
    aumico_annual_report_datev_error_root_node_empty: 'First element empty',
    aumico_annual_report_datev_master_file_detected:
        'We detected a DATEV master data import file. please click "save and continue" if you want to import the taxonomy and accounts.',
    aumico_annual_report_datev_account_file_detected:
        'We detected a DATEV account data import file. please click "save and continue" if you want to import the accounts.',
    aumico_annual_report_show_settings: 'display settings',
    aumico_annual_report_hide_settings: 'hide settings',
    aumico_annual_report_special_flis_form_title: 'Special Flis',
    aumico_annual_report_special_flis_form_intro: 'Select the financial items that serve a special function.',
    aumico_annual_report_special_flis_equity_group_label: 'Equity',
    aumico_annual_report_special_flis_profit_fli_label: 'Profit',
    aumico_annual_report_special_flis_uncoveredShortfallAssets_label: 'Uncovered Shortfall Assets',
    aumico_annual_report_special_flis_uncoveredShortfallLiabilities_label: 'Uncovered Shortfall Liabilities',
    aumico_annual_report_special_flis_field_required_error: 'selection is required',
    aumico_annual_report_special_flis_please_select: 'Please select',
    aumico_report_fas_print_subtotal: 'Subtotal',
    aumico_report_fas_print_section_costs_title: 'Acquisition and Production Costs',
    aumico_report_fas_print_section_depr_title: 'Cumulated Depreciations',
    aumico_report_fas_print_section_valueApr_title: 'Appreciation for the period',
    aumico_report_fas_print_section_bookvalue_current: 'Book value',
    aumico_report_fas_print_section_bookvalue_previous: 'Book value',
    aumico_report_fas_print_costs_additions: 'Costs Additions',
    aumico_report_fas_print_costs_disposals: 'Costs Disposals',
    aumico_report_fas_print_costs_transfers: 'Costs Transfers',
    aumico_report_fas_print_depreciations_additions: 'Depreciation for the period',
    aumico_report_fas_print_depreciations_disposals: 'Depreciations Disposals',
    aumico_report_fas_print_depreciations_transfers: 'Depreciations Transfers',
    aumico_report_fas_print_value_appreciation: 'Value Appreciation',
    aumico_annual_report_table_label_share_date: 'Shared on',
    aumico_annual_report_aop_profit_calculation_custom_account_name_placeholder: 'Enter account caption',
    aumico_annual_report_aop_profit_calculation_account_caption_form_field_label: 'Caption',
    aumico_users_edit_user_general_information_name_required: 'the first name is mandatory',
    aumico_users_edit_user_general_information_surname_required: 'the surname is mandatory',
    aumico_users_edit_user_general_information_phone_invalid:
        'the phone number is invalid. It should be in the format of +<country_code><phone_number>',
    aumico_annual_report_print_options_show_balance_account_proof: 'Balance Account Proof',
    aumico_annual_report_print_options_show_income_account_proof: 'Income Account Proof',
    aumico_annual_report_print_preview_account_proof_for_balance: 'Account Proof For Balance Sheet',
    aumico_annual_report_print_preview_account_proof_for_income: 'Account Proof For Income Statement',
    aumico_templates_group_account_mapping_add_subtotal: 'Subtotal',
    aumico_templates_group_account_mapping_add_subtotal_form_group_options_label: 'Select Group',
    aumico_templates_group_account_mapping_add_subtotal_form_group_options: 'Groups',
    aumico_templates_group_account_mapping_add_fli: 'FLI',

    aumico_templates_fli_form_cash_flow_types: 'Cash Flow Type',
    aumico_templates_fli_form_cash_flow_options_label: 'Select Cash Flow Type',
    aumico_templates_fli_form_fli_types: 'Financial Line Item Type',
    aumico_templates_fli_form_fli_type_options_label: 'Select Fli Type',
    aumico_templates_fli_form_groups: 'Select group',
    aumico_templates_fli_form_group_options_label: 'Select Group',
    aumico_templates_group_account_mapping_cash_flow_type_none: 'None',
    aumico_templates_group_account_mapping_cash_flow_type_operations: 'Operations',
    aumico_templates_group_account_mapping_cash_flow_type_networking_capital: 'Networking Capital',
    aumico_templates_group_account_mapping_cash_flow_type_investing: 'Investing',
    aumico_templates_group_account_mapping_cash_flow_type_financing: 'Financing',
    aumico_templates_group_account_mapping_fli_type_assets: 'Assets',
    aumico_templates_group_account_mapping_fli_type_liabilities: 'Liabilities',
    aumico_templates_group_account_mapping_fli_type_income: 'Income',
    aumico_templates_group_account_mapping_fli_type_expenses: 'Expenses',
    aumico_organization_settings_print_closing_value_totals_in_separate_columns:
        'Print closing value totals in separate columns',
    aumico_organization_settings_display_assets_and_liabilities_in_same_page:
        'Display Assets And Liabilities In Same Page',
    aumico_organization_settings_print_success_notification_title: 'Success',
    aumico_organization_settings_print_success_notification_description: 'Organization settings saved successfully',
    aumico_templates_group_account_mapping_add_more_items_of_that_item_checkbox: 'Create as of-that-item',
    aumico_templates_group_account_mapping_of_that_item_text: '{of that item} ',
    aumico_annual_report_fas_accounts_select_reference_placeholder: 'Select Reference',
    aumico_users_organization_upload_pdf_template_action: 'Upload Pdf Template',
    aumico_users_organization_reset_to_default_template_action: 'Reset to default template',
    aumico_users_organization_reset_to_default_template_action_success: 'Reset to default template succeeded',
    aumico_users_organization_reset_to_default_template_action_failed: 'Reset to default template failed',
    aumico_users_organization_upload_pdf_template_failure_notification_description:
        'Failed to upload reporting template',
    aumico_users_organization_upload_pdf_template_success_notification_description:
        'Reporting template uploaded successfully',
    aumico_reports_print_page_fixed_assets_schedule_invalid_warning:
        'Fixed assets schedule is invalid against the mapping data',
    aumico_reports_referral_invite_notification_failure_title: 'Referral Invite',
    aumico_reports_referral_invite_notification_failure_description: 'Failed to send referral emails',
    aumico_reports_referral_invite_notification_success_title: 'Referral Invite',
    aumico_reports_referral_invite_notification_success_description: 'Sent referral emails successfuly',
    aumico_annual_report_complementary_reports_autofill_button: 'Autofill from previous year',
    aumico_annual_report_complementary_reports_autofill_dialog_description:
        'Are you sure you want to overwrite your complementary reports with the previous year ones?',
    aumico_annual_report_complementary_reports_autofill_dialog_yes: 'Yes',
    aumico_annual_report_complementary_reports_autofill_dialoh_cancel: 'Cancel',
    aumico_admin_ar_template_navigation_settings: 'Settings',
    aumico_admin_ar_template_settings_title: 'Define Settings',
    aumico_admin_ar_template_settings_uncovered_shortfall: 'Equity Uncovered Shortfall',
    aumico_organization_settings_uncoveredShortfall: 'Uncovered Shortfall',
    aumico_templates_account_mapping_form_apply_uncovered_shortfall: 'Apply Uncovered Shortfall',
    aumico_templates_switch_accounts_dialog_title: 'Define Switch Account',
    aumico_templates_switch_accounts_dialog_initial_situation: 'Initial State',
    aumico_templates_switch_accounts_dialog_preview_output: 'Preview Output',
    aumico_templates_switch_accounts_dialog_drop_account: 'Where should we drop the new account?',
    aumico_templates_switch_accounts_dialog_selection_label: 'Select Fli or SubFLi',
    aumico_templates_switch_accounts_dialog_selection_placeholder: 'Please Select Fli or SubFLi',
    aumico_templates_switch_accounts_dialog_error_mandatory_selection: 'You must select an Fli or SubFli',
    aumico_reports_share_not_found: 'Share must have been withdrawn, expired, or rejected before',
    aumico_organization_settings_show_shareholder_info: 'Show Shareholder Information',
    aumico_annual_report_print_options_label_show_shareholderInformation: 'Show shareholder info',
    aumico_templates_fli_form_error_name_already_exists: 'Fli name already exists',
    aumico_templates_mapping_engine_equity_group_not_defined_title: 'Uncovered Shortfall Error',
    aumico_templates_mapping_engine_equity_group_not_defined_description:
        'Equity Group is not defined in balance taxonomy',
    aumico_templates_account_mapping_form_uncovered_shortfall_assets_fli_caption: 'Uncovered Shortfall',
    aumico_templates_account_mapping_form_uncovered_shortfall_equity_fli_caption: 'Uncovered Shortfall',
    aumico_templates_account_mapping_form_uncovered_shortfall_assets_account_name: 'Uncovered Shortfall Account',
    aumico_templates_account_mapping_form_uncovered_shortfall_equity_account_name: 'Uncovered Shortfall Account ',
    aumico_templates_form_equity_group: 'Please Select Equity group',
    aumico_templates_form_uncovered_shortfall_assets_fli: 'Please Select Uncovered Shortfall Assets Fli',
    aumico_templates_form_uncovered_shortfall_liabilities_fli: 'Please Select Uncovered Shortfall Liabilities Fli',
    aumico_templates_form_add_hidden_group: 'Add hidden group',
    aumico_templates_form_create_sub_fli_or_of_that_item: 'Create Sub FLI or Of That Item',
    aumico_annual_report_import_indicate_shareholder_column: 'Specify Shareholder Column',
    aumico_admin_ar_template_settings_show_shareholder_information: 'Show Shareholder Information',
    aumico_companies_form_label_tax_domicile: 'Tax Domicile',
    aumico_companies_form_label_GICSCode: 'Industry',
    aumico_core_search: 'Search',
    aumico_core_search_not_found: 'Not Found',
    aumico_reports_annualreport_navigation_balance_account_proof: 'Balance Account Proof',
    aumico_reports_annualreport_navigation_income_account_proof: 'Income Account Proof',
    aumico_templates_mapping_remove_group_warning_dialog_text:
        'Removing this group will lead to resetting any other step that uses this group or any item inside this group. Are you sure you want to remove it ?',
    aumico_templates_mapping_remove_item_warning_dialog_cancel_button: 'Cancel',
    aumico_templates_mapping_remove_item_warning_dialog_remove_button: 'Remove',
    aumico_templates_mapping_remove_item_warning_dialog_text:
        'Removing this item will lead to resetting any other step that uses it. Are you sure you want to remove it ?',
    aumico_reports_accept_policy_dialog_title: 'Update GTC, Data Privacy, DPA',
    aumico_reports_accept_policy_dialog_first_paragraph:
        'On September 1st, the revised Federal Data Protection Act (DSG) came into force. In this context, we have updated our',
    aumico_reports_accept_policy_dialog_first_paragraph_the: 'the',
    aumico_reports_accept_policy_dialog_first_paragraph_as_well_as_those: 'as well as the',
    aumico_reports_accept_policy_dialog_first_paragraph_adjusted: '',
    aumico_reports_accept_policy_dialog_second_paragraph:
        'The revised versions are now fully compliant with the new Swiss data protection law, as well as the European General Data Protection Regulations (GDPR). You can find the new regulations under the links mentioned above or at https://aumico.io/. The new regulations apply retroactively to September 1, 2023.',
    aumico_reports_accept_policy_dialog_third_paragraph:
        'Please accept our new GTC, the data protection regulations and data processing agreement in order to continue using aumico.',
    aumico_reports_accept_policy_dialog_privacy_policy: 'Data Protection Regulation',
    aumico_reports_accept_policy_dialog_terms_and_conditions: 'General Terms and conditions (GTC),',
    aumico_reports_accept_policy_dialog_agreement_on_data_processing: 'Data Processing Agreement (DPA)',
    aumico_reports_accept_policy_to_continue_dialog_first_paragraph:
        'Are you sure you do not want to continue using aumico?',
    aumico_reports_accept_policy_to_continue_dialog_second_paragraph:
        'If you do not agree to the new terms, you will not be able to continue using aumico. All data of your organization will be deleted within 30 days.',
    aumico_reports_accept_policy_to_continue_dialog_third_paragraph: 'If you have any questions, please contact',
    aumico_reports_accept_policy_to_continue_dialog_third_paragraph_contact_email: 'privacy@aumico.ch',
    aumico_reports_accept_policy_to_continue_dialog_i_agree_button: 'I Agree',
    aumico_reports_accept_policy_to_continue_dialog_decline_policy_button: 'Delete my account',
    aumico_users_registration_privacy_policy: 'Data Protection Regulation.',
    aumico_users_registration_prices: 'Prices,',
    aumico_users_registration_terms_and_conditions: 'General Terms and conditions,',
    aumico_users_registration_text_between_links:
        'of aumico and I agree with them. Furthermore, I have taken note of aumico',
    aumico_users_registration_text_after_links: '',
    aumico_users_registration_agreement_on_data_processing: 'Data Processing Agreement',
    aumico_annual_report_account_proof_display_account_number_column_header: 'Number',
    aumico_annual_report_account_proof_display_account_name_column_header: 'Name',
    aumico_annual_report_print_options_show_group_headers: 'Show Group Headers',
    aumico_annual_report_print_options_show_group_totals: 'Show Group Totals',
    aumico_templates_template_account_mapping_form_show_details: 'Show Details',
    aumico_templates_template_account_mapping_form_hide_details: 'Hide Details',
    aumico_templates_group_account_mapping_create_group: 'Group',
    aumico_templates_group_account_mapping_create_group_form_fli_options_label: 'Select FLIs',
    aumico_templates_group_account_mapping_create_group_form_fli_options: 'Select FLIs',
    aumico_templates_group_account_mapping_create_group_form_name_label: 'Group Name',
    aumico_templates_group_account_mapping_create_group_form_name: 'Group Name',
    aumico_templates_group_account_mapping_create_group_form_name_required_error: 'Group name is required',
    aumico_templates_group_account_mapping_create_group_form_name_already_exists_error: 'Group name already exists',
    aumico_templates_group_account_mapping_create_group_form_total_name_required_error: 'Group total name is required',
    aumico_templates_group_account_mapping_create_group_form_total_name_label: 'Group Total Name',
    aumico_templates_group_account_mapping_create_group_form_total_name: 'Group Total Name',
    aumico_templates_group_account_mapping_create_group_form_button: 'Save',
    aumico_templates_group_account_mapping_there_is_an_empty_group_warning:
        'There is one or more empty groups that does not contain financial line items',
    aumico_annual_report_print_options_title_and_signature: 'Title and Signature',
    aumico_reports_equality_check_print_preview_hide_details: 'Hide Details',
    aumico_reports_equality_check_print_preview_show_details: 'Show Details',
    aumico_templates_group_account_mapping_menu_edit: 'Edit',
    aumico_templates_group_account_mapping_switch_account: 'Switch Account',
    aumico_templates_group_account_mapping_add_account: 'Add new Account',
    aumico_templates_group_account_mapping_add_sub_total: 'Subtotal',
    aumico_templates_group_account_mapping_add_group: 'Group',
    aumico_templates_group_account_mapping_add_empty_space_above: 'Insert spacing above',
    aumico_templates_group_account_mapping_add_empty_space_below: 'Insert spacing below',
    aumico_templates_group_account_mapping_add_header_above: 'Insert header above',
    aumico_templates_group_account_mapping_add_header_below: 'Insert header below',
    aumico_users_registration_country_placeholder: 'Choose Country',
    aumico_users_registration_country_label: 'Place of your company',
    aumico_users_registration_country_required_error: 'Country Selection is required',
    aumico_users_registration_country_tool_tip_message:
        'Please ensure accurate country selection. It is crucial for compliance with your organizations data protection regulations.',
    aumico_templates_group_account_mapping_fli_disable_numbering: 'Disable numbering',
    aumico_templates_group_account_mapping_fli_enable_numbering: 'Add numbering',
    aumico_annual_report_print_options_show_fas: 'Fixes Asset Schedule',

    aumico_annual_report_display_current_date_column_header: 'Fiscal year',
    aumico_annual_report_display_previous_date_column_header: 'Previous Year',
    aumico_annual_report_general_information_report_language: 'Report Language',
    aumico_templates_account_mapping_form_transferred_surplus_account_name: 'Transferred profit',
    aumico_templates_subtotal_form_subtotal_scope: 'Scope',
    aumico_templates_subtotal_form_subtotal_position: 'Select position before',
    aumico_templates_account_mapping_form_map_income_total_to_annual_surplus: 'Transfer Income Total To Annual Surplus',
    aumico_annual_report_special_flis_annual_surplus_fli_label: 'Annual Surplus',
    aumico_annual_report_general_information_select_locale: 'Select Report language',
    aumico_annual_report_general_information_update_company_btn_text: 'Update Company Info',
    aumico_reports_general_info_company_update_confirm: 'Update',
    aumico_reports_general_info_company_update_cancel: 'Cancel',
    aumico_reports_general_info_company_update_confirmation_text:
        'Do you want to update the company information in the report?',
    aumico_reports_general_info_update_company_success_notification_title: 'Successful Update',
    aumico_reports_general_info_update_company_success_notification_description:
        'Company Information was updated successfully',
    aumico_reports_company_legal_form_update_confirmation_text:
        'Do you want to update the company information? A *change in legal form* will have an impact on the structure of balance sheet and income statement',
    aumico_templates_group_account_mapping_duplicate_account: 'Duplicate Account',
    aumico_templates_group_account_mapping_duplicate_account_form_of_that_items_options: 'Select of that item',
    aumico_templates_group_account_mapping_duplicate_account_form_of_that_items_options_label: 'Select of that item',
    aumico_templates_group_account_mapping_duplicate_account_form_button: 'Duplicate account',
    aumico_general_information_no_template_for_your_combination: 'No template for your combination',
    aumico_general_information_no_template_for_your_combination_content_1:
        'We have not found a template for the combination of legal form and accounting standard. Please check your selection',
    aumico_general_information_no_template_for_your_combination_content_2:
        'You can also contact us at support@aumico.ch. We will be happy to help you.',
    aumico_reports_annualreport_print_label_previous_year: 'Previous year',
    aumico_reports_annualreport_print_label_current_year: 'Current year',
    aumico_reports_annualreport_print_label_ratio: 'Ratio',
    aumico_reports_annualreport_print_label_taxdomicile: 'Tax domicile',
    aumico_reports_annualreport_print_label_taxid: 'Tax id',
    aumico_reports_annualreport_print_label_assets: 'ASSETS',
    aumico_reports_annualreport_print_label_liabilities: 'LIABILITIES',
    aumico_reports_annualreport_print_label_page: 'page',
    aumico_dialog_error: 'Error',
    aumico_dialog_error_too_many_requests:
        'Oops! It looks like too many requests were made at once. Please wait a moment and reload the page. We appreciate your patience',
    aumico_notes_input_options_compare_years: 'Compare years',
    aumico_notes_input_options_text: 'Text',
    aumico_notes_input_options_data_type: 'Select type of values',
    aumico_notes_input_options_number_of_decimal_places: 'Number of digits after comma',
    aumico_notes_input_options_use_as_parameter: 'Available as report parameter',
    aumico_notes_input_options_parameter_name: 'Enter Parameter Name',
    aumico_notes_input_options_data_type_text: 'Text',
    aumico_notes_input_options_data_type_number: 'Number',
    aumico_notes_input_options_data_type_currency: 'Currency',
    aumico_confirmation_modal_cancel_button: 'Cancel',
    aumico_confirmation_modal_delete_button: 'Delete',
    aumico_edit_notes_toggle: 'Edit notes',
    aumico_add_notes_button: 'Add Notes',
    aumico_new_note_placeholder: 'New Notes',
    aumico_add_notes_component_button: 'Add another component',
    aumico_confirmation_modal_notes_deletion:
        'Do you want to delete the note? It will be not possible to restore the information after deletion.',
    aumico_confirmation_modal_notes_component_deletion:
        'Do you want to delete this note component? It will be not possible to restore the information after deletion. de',
    aumico_notes_add_all_text: 'Add all text to the note',
    aumico_reports_main_navigation_company_valuation: 'Company Valuation',
    aumico_reports_company_valuation_navigation_valuation_report: 'Valuation Report',
    aumico_reports_company_valuation_report_title: 'Automatic calculation of the tax value for your clients',
    aumico_reports_company_valuation_report_descriptive_text_1:
        'Based on your clients past annual financial statements.',
    aumico_reports_company_valuation_report_descriptive_text_2:
        'Get a professional and comprehensive valuation report within two working days',
    aumico_reports_company_valuation_report_descriptive_text_3:
        'Receive a 3-page report in your inbox, for CHF 49 per report (excluding VAT).',
    aumico_reports_company_valuation_report_download_button_text: 'Download example report',
    aumico_reports_company_valuation_report_order_button_text: 'Order report',
    aumico_reports_company_valuation_dialog_title: 'Order a tax value report',
    aumico_reports_company_valuation_dialog_text:
        "The tax calculation costs CHF 49 per report (excluding VAT). The report is received within two working days. By placing the order, you agree that aumico may process the client's financial data for the purpose of creating the valuation report.",
    aumico_reports_company_valuation_dialog_place_order_button_text: 'Place Order',
    aumico_reports_company_valuation_confirmation_dialog_content_title: 'Order Confirmation',
    aumico_reports_company_valuation_confirmation_dialog_text:
        'We have received your order. You will receive the report(s) within two working days.',
    aumico_reports_company_valuation_confirmation_dialog_button_text: 'Done',
    aumico_reports_valuation_report_announcement_dialog_title: 'Discover Tax Value Report',
    aumico_reports_valuation_report_announcement_dialog_content_1:
        ' Create a tax value calculation for your clients using the practitioner method.',
    aumico_reports_valuation_report_announcement_dialog_content_2:
        'Select the customers for whom you want to create the report. Confirm your selection and receive the tax value calculations within 2 working days.',
    aumico_reports_valuation_report_announcement_dialog_content_3:
        'Offer your customers added value and send them a tax value calculation with every annual financial statement.',
    aumico_reports_valuation_report_announcement_dialog_button_text: 'Try it out',
    aumico_notes_super_table_options_title: 'Title',
    aumico_notes_super_table_options_col_type: 'Column Type',
    aumico_notes_super_table_col_title: 'Column Title',
    aumico_notes_super_table_options_segment_type: 'Segment Type',
    aumico_notes_super_table_segment_title: 'Segment Title',
    aumico_notes_super_table_options_col_type_current_year: 'Current year',
    aumico_notes_super_table_options_col_type_previous_year: 'Previous Year',
    aumico_notes_super_table_options_col_type_text: 'Text',
    aumico_notes_super_table_options_col_type_number: 'Number',
    aumico_notes_super_table_options_segment_type_basic: 'Basic Segment',
    aumico_notes_super_table_options_segment_type_total: 'Total Segment',
    aumico_notes_super_table_options_col_belonging_year_current: 'Current Year',
    aumico_notes_super_table_options_col_belonging_year_previous: 'Previous Year',
    aumico_notes_super_table_options_col_belonging_year: 'Belonging Year',
    aumico_notes_super_table_segment_child_columns: 'Child Columns',
    aumico_notes_super_table_options_define_columns: 'Define Columns',
    aumico_notes_super_table_options_define_segments: 'Define Segments',
    aumico_notes_super_table_add_row: 'Add Row',
    aumico_notes_super_table_add_row_menu_option_select_from_balance: 'Select from Balance Sheet',
    aumico_notes_super_table_add_row_menu_option_select_from_income: 'Select from Income',
    aumico_notes_super_table_add_row_menu_option_add_calculation: 'Add calculation',
    aumico_notes_super_table_add_row_menu_option_add_title_row: 'Add title row',
    aumico_notes_super_table_add_row_menu_option_add_space_row: 'Add space row',
    aumico_notes_super_table_add_row_menu_option_add_free_text_row: 'Add free text row',
    aumico_notes_super_table_add_row_menu_option_add_rate: 'Rate row',
    aumico_notes_super_table_add_rate_row_title: 'Add rate row',
    aumico_notes_super_table_add_rate_select_source: 'Which rate should the row show?',
    aumico_notes_super_table_rate_source_closing: 'Closing rate',
    aumico_notes_super_table_rate_source_average: 'Average rate',
    aumico_notes_super_table_rate_source_position: 'Rate of a position',
    aumico_annual_report_fx_notes_reserve_label: 'Translation reserve',
    aumico_notes_fli_currency_chip_tooltip: 'Switches this table\'s currency columns: functional → both → display currency',
    aumico_annual_report_print_options_fx_accordion_title: 'Functional currency',
    aumico_annual_report_print_options_fx_show_statement_display_columns: 'Balance sheet & income statement in both currencies',
    aumico_notes_super_table_add_row_menu_option_add_text_row: 'Add text row',
    aumico_notes_super_table_add_row_menu_option_create_segments: 'Create segments',
    aumico_notes_super_table_current_value_placeholder: 'Enter Current Year Value',
    aumico_notes_super_table_previous_value_placeholder: 'Enter Previous year Value',
    aumico_notes_super_table_numeric_value_placeholder: 'Enter number',
    aumico_notes_super_table_text_value_placeholder: 'Enter text',
    aumico_notes_super_table_data_selection_title: 'Add Row',
    aumico_notes_super_table_data_selection_label: 'Please select one or multiple items for a new row:',
    aumico_notes_super_table_create_segment_title: 'Create Segment',
    aumico_notes_super_table_enter_here: 'Enter Here',
    aumico_notes_super_table_create_segment_select_columns_placeholder: 'Select Columns',
    aumico_notes_super_table_create_segment_save_button: 'Add Segment',
    aumico_annual_report_main_navigation_new: 'NEW',
    aumico_notes_movement_schedule: 'Movement Schedule',
    aumico_notes_fli_table: 'FLI Table',
    aumico_notes_equity_table: 'Equity table',
    aumico_notes_super_table_add_calculation_row_title: 'Add Calculation Row',
    aumico_notes_super_table_add_calculation_column_title: 'Add Calculation Column',
    aumico_notes_super_table_add_caclulation_select_calculation_type: 'Select the calculation type',
    aumico_notes_super_table_add_calculation_function_summation: 'Sum of Items',
    aumico_notes_super_table_add_calculation_function_ratio: 'Ration',
    aumico_notes_super_table_add_calculation_function_subtraction: 'Subtraction',
    aumico_notes_super_table_add_calculation_function_multiplication: 'Multiplication',
    aumico_notes_super_table_add_calculation_title_placeholder: 'Enter calculation title',
    aumico_notes_super_table_add_calculation_button: 'Add Calculation',
    aumico_notes_super_table_add_calculation_select_relation_item_placeholder: 'In Relation to',
    aumico_notes_super_table_add_calculation_select_column_placeholder: 'Select columns',
    aumico_notes_super_table_add_calculation_select_column_placeholder_SUM: 'Select columns which shall be summed up',
    aumico_notes_super_table_add_calculation_select_column_placeholder_MUL: 'select columns which shall be multiplied',
    aumico_notes_super_table_add_calculation_select_column_placeholder_RATIO:
        'Select columns for which the ratio shall be calculated',
    aumico_notes_super_table_add_calculation_select_rows_placeholder: 'Select for table rows',
    aumico_notes_super_table_add_calculation_select_rows_placeholder_SUM: 'Select the rows which shall be summed up',
    aumico_notes_super_table_add_calculation_select_rows_placeholder_MUL: 'Select the rows which shall be multiplied',
    aumico_notes_super_table_add_calculation_select_rows_placeholder_RATIO:
        'Select the rows for which the ratio shall be calculated',
    aumico_notes_super_table_add_calculation_minuend_placeholder: 'Select the X item',
    aumico_notes_super_table_add_calculation_subtrahend_placeholder: 'Select the Y item',
    aumico_notes_super_table_add_column: 'Add Column',
    aumico_notes_super_table_add_column_menu_option_add_calculation: 'Add Calculation Column',
    aumico_notes_super_table_add_column_menu_option_add_column: 'Add Free Column',
    aumico_notes_super_table_add_free_column_title_placeholder: 'Column Title',
    aumico_notes_super_table_add_free_column_col_type: 'Column Values format',
    aumico_notes_super_table_add_free_column_belonging_year: 'Column belongs to year',
    aumico_notes_super_table_add_free_column_save_button: 'Add Column',
    aumico_notes_super_table_select_income_or_balance: 'Please select where the data comes from:',
    aumico_reports_company_valuation_dialog_select_company: 'Select Company',
    aumico_add_to_notes_button: 'Add to note',
    aumico_add_to_notes_dialog_title: 'Notes components library',
    aumico_notes_extra_settings: 'Extra settings',
    aumico_notes_extra_settings_title: 'Enter title (optional)',
    aumico_notes_select_option_description: 'Description (optional)',
    aumico_notes_select_options: 'Options',
    aumico_notes_extra_settings_add_option: 'Add option',
    aumico_notes_extra_settings_options: 'Dropdown values',
    aumico_notes_simple_input: 'Simple Input',
    aumico_notes_extra_settings_option: 'Option',
    aumico_core_ck_editor_add_custom_style: 'Add custom style',
    aumico_core_ck_editor_make_row_total: 'Make row total',
    aumico_core_ck_editor_make_column_total: 'Make column total',
    aumico_core_ck_editor_make_column_highlight: 'Make column highlighted',
    aumico_core_ck_editor_make_column_number_column: 'Make column number column',
    aumico_core_ck_editor_remove_row_style: 'Remove row style',
    aumico_core_ck_editor_remove_column_style: 'Remove column style',
    aumico_core_ck_editor_align_table: 'Align table',
    aumico_core_ck_editor_align_table_left: 'Align table left',
    aumico_core_ck_editor_align_table_right: 'Align table right',
    aumico_core_ck_editor_align_table_center: 'Align table center',
    aumico_core_ck_editor_align_cell_horizontal: 'Align cell horizontal',
    aumico_core_ck_editor_align_cell_horizontal_left: 'Align cell left',
    aumico_core_ck_editor_align_cell_horizontal_right: 'Align cell right',
    aumico_core_ck_editor_align_cell_vertical: 'Align cell vertical',
    aumico_core_ck_editor_align_cell_vertical_top: 'Align cell top',
    aumico_core_ck_editor_align_cell_vertical_bottom: 'Align cell bottom',
    aumico_core_ck_editor_table_column: 'Column',
    aumico_core_ck_editor_table_column_header_column: 'Header column',
    aumico_core_ck_editor_table_column_insert_column_left: 'Insert column left',
    aumico_core_ck_editor_table_column_insert_column_right: 'Insert column right',
    aumico_core_ck_editor_table_column_delete_column: 'Delete column',
    aumico_core_ck_editor_table_column_select_column: 'Select column',
    aumico_core_ck_editor_table_row: 'Row',
    aumico_core_ck_editor_table_row_header_row: 'Header row',
    aumico_core_ck_editor_table_row_insert_row_above: 'Insert row above',
    aumico_core_ck_editor_table_row_insert_row_below: 'Insert row below',
    aumico_core_ck_editor_table_row_delete_row: 'Delete row',
    aumico_core_ck_editor_table_row_select_row: 'Select row',
    aumico_core_ck_editor_table_merge_cells: 'Merge cells',
    aumico_core_ck_editor_table_merge_cells_up: 'Merge cells up',
    aumico_core_ck_editor_table_merge_cells_down: 'Merge cells down',
    aumico_core_ck_editor_table_merge_cells_right: 'Merge cells right',
    aumico_core_ck_editor_table_merge_cells_left: 'Merge cells left',
    aumico_core_ck_editor_table_split_cell_vertically: 'Split cell vertically',
    aumico_core_ck_editor_table_split_cell_horizontally: 'Split cell horizontally',
    aumico_core_ck_editor_enforce_page_break: 'force page break',
    aumico_notes_components_list_reset_values_from_mapping: 'Refresh values',
    aumico_notes_components_list_no_content: ' click edit to add content',
    aumico_notes_super_table: 'Super Table',
    aumico_notes_select_options_min_options: 'Please select at least two options.',
    aumico_templates_form_annual_surplus: 'Annual Surplus',
    aumico_notes_super_table_options_transpose: 'Transpose 90',
    aumico_notes_super_table_options_col_belonging_year_none: 'None',
    aumico_notes_super_table_add_free_column_edit_button: 'Edit Column',
    aumico_notes_super_table_reset_form_values_from_mapping_confirmation_dialog_ok: 'Yes',
    aumico_notes_super_table_reset_form_values_from_mapping_confirmation_dialog_cancel: 'Cancel',
    aumico_notes_super_table_reset_form_values_from_mapping_confirmation_dialog_description:
        'Are you sure you want to reset the values from mapping step',
    aumico_notes_super_table_turning_on_transpose_toggle_not_allowed:
        'The maximum number of allowed rows for transpose view is 7 rows. Cannot turn on transpose toggle.',
    aumico_notes_super_table_turning_off_transpose_toggle_not_allowed:
        'The maximum number of allowed columns for non-transpose view is 7 columns. Cannot turn off transpose toggle.',
    aumico_reports_main_navigation_company_profile: 'Company Profile',
    aumico_reports_main_navigation_person_list: 'Persons',
    aumico_reports_export_all_persons_file_name: 'all persons',
    aumico_reports_main_navigation_person_new: 'New person',
    aumico_reports_main_navigation_person_profile: 'Profile',
    aumico_notes_super_table_remove_confirmation_dialog_ok: 'Okay',
    aumico_notes_super_table_remove_confirmation_dialog_cancel: 'Cancel',
    aumico_notes_super_table_remove_confirmation_dialog_description:
        'You are about to remove a column. Do you still want to proceed?',
    aumico_print_preview_rename_section_title_dialog_title: 'Rename Section Title',
    aumico_print_preview_rename_section_title_dialog_input_field_placeholder: 'Enter Section Title',
    aumico_print_preview_rename_section_title_dialog_input_field_title: 'Section Title',
    aumico_users_registration_password_lower_case_criteria_message: 'at least one lower case character',
    aumico_users_registration_password_upper_case_criteria_message: 'at least one upper case character',
    aumico_users_registration_password_digits_criteria_message: 'at least one digit',
    aumico_users_registration_password_special_char_criteria_message: 'at least one special character',
    aumico_users_registration_password_min_chars_criteria_message: 'at least 8 characters',
    aumico_admin_ar_template_general_information_caption: 'Description',
    aumico_report_copy_success_notification_description: 'Copied to clipboard',
    aumico_report_save_success_notification_description: 'Saved Successfully',
    aumico_report_save_failure_notification_description: 'Save Failed',
    aumico_annual_report_save_error_not_loaded: 'The report data has not loaded yet. Please wait a moment and try again.',
    aumico_add_referencing_in_balance_and_income_btn: 'Add referencing',
    aumico_add_numbering_toggle: 'Add numbering',
    aumico_view_notes_components_in_edit_mode_toggle: 'View components in edit mode',
    aumico_notes_title: 'Title',
    aumico_notes_referencing_title: 'Add referncing',
    aumico_notes_referencing_sub_title: 'You can select one ore more FLis or SubFlis:',
    aumico_notes_referencing_add_referencing: 'Add referencing',
    aumico_admin_translations_ar_templates: 'Annual Report Templates',
    aumico_annual_report_fas_unmapped_uploaded_accounts_warning: 'The following accounts uploaded are not mapped',
    aumico_annual_report_fas_invalid_file_format_warning_text: 'The uploaded sheet has a wrong format',
    aumico_admin_menu_item_change_fcp: 'Change FCP subscription',
    aumico_admin_menu_item_deactivate_fcp: 'Deactivate closing process',
    aumico_view_notes_components_highlight_todos_toggle: 'Highlight Todos',
    aumico_annual_report_complementary_reports_show_in_toc_toggle: 'Show report in table of contents',
    aumico_annual_report_complementary_reports_at_the_start: 'BEFORE the financial statements',
    aumico_annual_report_complementary_reports_at_the_end: 'AFTER the financial statements',
    aumico_annual_report_complementary_reports_as_appendix: 'Appendix to the financial statements',
    aumico_annual_report_print_preview_appendix_section_title: 'Appendix',
    aumico_copy_notes_structure_from_another_annual_report: 'Copy notes structure',
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_description:
        'This will replace all the notes created and cannot be undone. Are you sure you want to continue ?',
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_yes_button: 'Yes',
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_yes_inclusive_data_button:
        'Yes, inclusive referencing and data',
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_cancel_button: 'Cancel',
    aumico_notes_copy_notes_structure_fetch_error: 'The notes could not be fetched from this report.',
    aumico_users_organization_upload_or_pdf_template_action: 'Upload OR Pdf template',
    aumico_users_organization_upload_hgb_pdf_template_action: 'Upload HGB Pdf template',
    aumico_users_organization_reset_to_default_or_template_action: 'Reset OR template to default',
    aumico_users_organization_reset_to_default_hgb_template_action: 'Reset HGB template to default',
    aumico_reports_organization_settings_navigation_checklists: 'Checklists',

    aumico_admin_change_fcpstate_select_fcp_status: 'FCP Status',
    aumico_admin_change_fcp_statefcp_status: 'Change Status',
    aumico_admin_change_fcpstate_cancel: 'Cancel',
    aumico_admin_change_fcpstate_confirm: 'Confirm',
    aumico_reports_main_navigation_closing_process_enabling: 'Closing Process',
    aumico_reports_closing_process_request_approval: 'Sign up for Beta',
    aumico_reports_closing_process_waiting_for_approval: 'Beta Approval in Progress',
    aumico_reports_closing_process_cancel: 'Cancel Subscription',

    aumico_reports_closing_process_benefits: 'Benefits',
    aumico_reports_closing_process_pricing: 'Pricing',
    aumico_reports_closing_process_terms_and_conditions: 'Terms and Conditions',

    aumico_confirmation_modal_activate_button: 'Activate',
    aumico_confirmation_modal_cancel_subscription_button: 'Cancel Subscription',
    aumico_confirmation_modal_activate_subscription_description:
        'By clicking "Activate", you will activate a 30-day free trial. During this period, you will have full access to closing process feature. Trial will be converted to automatic renewal once the trial ends!',
    aumico_reports_closing_process_deactivate: 'Deactivate',
    aumico_reports_cant_activate_fcp:
        'You can not activate FCP trial as you have already subscribed to, for annual subscription contact aumico sales sales@aumico.ch',
    aumico_reports_cant_activate_fcp_ok: 'Ok',

    aumico_reports_create_new_checklist: 'Create new checklist',
    aumico_reports_checklist_title_label: 'Title',
    aumico_reports_checklist_title_placeholder: 'Enter checklist title',
    aumico_reports_select_flis_label: 'Select financial line item',
    aumico_reports_enter_task_placeholder: 'enter task',
    aumico_reports_add_more_tasks_button: 'Add more tasks',
    aumico_reports_cancel_button: 'Cancel',
    aumico_reports_save_checklist_button: 'Save checklist',
    aumico_admin_user_notification_success_description: 'Data saved successfully',
    aumico_reports_checklist_title: 'Checklist',
    aumico_reports_checklist_content:
        'Here will be the checklists for your financial line items. They will help you to track the process and make sure, you don’t forget anything.',
    aumico_reports_comments_title: 'Comments',
    aumico_reports_comments_content:
        'Here you can add comments for the accounts. You can use it as notes for yourself and for your collaborators.',
    aumico_reports_docs_title: 'Documents',
    aumico_reports_docs_content:
        'Documents will be available here. You can upload and download documents for the accounts.',
    aumico_reports_no_checklist_message: 'We couldn’t find any checklist for this financial line item.',
    aumico_reports_create_checklist_button: 'Create a new checklist',
    aumico_reports_or_text: 'or',
    aumico_reports_import_checklist_button: 'Import a checklist',

    aumico_reports_last_year: 'Last Year',
    aumico_reports_this_year: 'This Year',
    aumico_reports_select_checklist: 'Select a checklist',
    aumico_reports_import_checklist: 'Import a checklist',
    aumico_reports_custom_checklist_creation_text: 'You can also {{linkText}} in the organization settings.',

    aumico_reports_custom_checklist_creation_link_text: 'create your own checklists',
    aumico_reports_closing_entries_title: 'Closing entries',
    aumico_reports_closing_entries_content: 'Please select closing entry',
    aumico_checklist_management_table_checklist_name: 'Name',
    aumico_checklist_management_table_checklist_created_at: 'Created at',
    aumico_checklist_management_table_checklist_last_change: 'Last change',
    aumico_checklist_management_table_checklist_modified_by: 'Modified  by',
    aumico_reports_annualreport_print_with_legacy_service: 'Print with legacy service',
    aumico_reports_fcp_enable_title: 'Enable Financial Closing Process',
    aumico_reports_fcp_enable_subtitle: 'Get full access to the closing process for a competitive annual rate.',
    aumico_reports_fcp_teaser_1_title: 'Automate your financial closings',
    aumico_reports_fcp_teaser_1_text: 'Plan it, create it, launch it. Collaborate seamlessly with your organization.',
    aumico_reports_fcp_teaser_2_title: 'Reduce manual errors',
    aumico_reports_fcp_teaser_2_text: 'Protect your organization and stay compliant with structured workflows.',
    aumico_reports_fcp_teaser_3_title: 'Ensure compliance with accounting standards',
    aumico_reports_fcp_teaser_3_text: 'Auto-assign tasks and use hundreds of templates.',
    aumico_reports_fcp_beta_terms_title: 'Beta Information',
    aumico_reports_fcp_trial_terms_1: '30-day free trial',
    aumico_reports_fcp_trial_terms_2: 'Automatically converts to an annual contract if not canceled',
    aumico_reports_fcp_trial_terms_3: 'Cancel anytime during the trial period',
    aumico_reports_fcp_trial_info_title: 'Trial Information',
    aumico_reports_fcp_trial_info_text: 'You have {{x}} days remaining in your trial period.',
    aumico_reports_fcp_subscription_info_title: 'Subscription Information',
    aumico_reports_fcp_subscription_info_text: 'You have {{x}} days remaining in your subscription period.',
    aumico_reports_fcp_trial_deactivation_title: `We'd love to hear your feedback`,
    aumico_reports_fcp_trial_deactivation_text: `Please tell us why you're stopping the trial...`,
    aumico_reports_fcp_subscription_deactivation_title: `We'd love to hear your feedback`,
    aumico_reports_fcp_subscription_deactivation_text: `Please tell us why you're stopping the subscription...`,
    aumico_reports_fcp_deactivation_placeholder: `Write feedback here ...`,
    aumico_reports_fcp_deactivation_feedback_button: `Submit Feedback and Disable`,
    aumico_reports_fcp_deactivation_confirmation_question_text: `Are you sure you want to deactivate closing process?`,
    aumico_reports_fcp_deactivation_terms: `Note:`,
    aumico_reports_fcp_deactivation_term_data_storage: `Data produced during the activation will be lost.`,
    aumico_reports_fcp_deactivation_term_end_date: `The feature will be terminated at {{date}}`,
    aumico_reports_fcp_deactivation_term_costs: `No charges will be made.`,
    aumico_reports_add_a_new_comment_placeholder: 'Add a new comment ',
    aumico_reports_add_new_comments_button: 'Add',
    aumico_reports_add_edit_comments_button: 'Edit',
    aumico_reports_mark_comment_as: 'Mark as:',
    aumico_reports_comments_section_description:
        'Here you can add comments for the accounts. You can use it as notes for yourself and for your collaborators.',
    aumico_reports_mark_as_internal_comment: 'internal ',
    aumico_reports_mark_as_external_comment: 'external ',
    aumico_reports_mark_as_review_comment: 'to review ',
    aumico_reports_mark_comment_as_pendency: 'pendency ',
    aumico_reports_copy_comment: 'copy',
    aumico_reports_delete_comment: 'delete ',
    aumico_reports_is_internal_comment: 'internal ',
    aumico_reports_is_external_comment: 'external ',
    aumico_reports_is_pendancy_comment: 'pendency ',
    aumico_reports_is_review_comment: 'review ',

    aumico_reports_fcp_file_virused_error_message: 'The uploaded file is infected with virus',
    aumico_reports_fcp_file_uploaded_success_message: 'File uploaded successfully',

    aumico_reports_fcp_edit_checklist: 'Edit checklist',
    aumico_reports_fcp_tree_adjustment_col_header: 'Adjustment',
    aumico_reports_fcp_tree_current_year_col_header: 'Current Year',
    aumico_reports_fcp_tree_previous_year_col_header: 'Previous Year',

    aumico_reports_notes_search_reports: 'Search',
    aumico_reports_finalize_and_continue_button: 'Finalize and Continue',
    aumico_reports_preview_button_text: 'Preview',
    aumico_reports_export_button_text: 'Export',
    aumico_reports_export_unlabeled_comment: 'Include unlabeld comments',
    aumico_reports_export_internal_comment: 'Include internal comment',
    aumico_reports_export_external_comment: 'Include external comment',
    aumico_reports_export_review_comment: 'Include comments for review',
    aumico_reports_export_pendency: 'Include pendencies',
    aumico_reports_export_excel: 'export as Excel',
    aumico_reports_export_closing: 'Include closing entries',
    aumico_reports_closing_process_balance_navigation_tab: 'Balance',
    aumico_reports_closing_process_income_navigation_tab: 'Income',
    aumico_reports_fcp_save_checklist_button: 'Save checklist',
    aumico_reports_fcp_closing_edit_entry: 'Edit',
    aumico_reports_fcp_closing_delete_entry: 'Delete',
    aumico_reports_fcp_closing_add_entry: 'Add entry',
    aumico_reports_fcp_closing_save_entry: 'Save',
    aumico_reports_fcp_closing_enter_amount: 'Enter amount',
    aumico_reports_fcp_closing_add_new_amount: 'Add a new amount',
    aumico_reports_fcp_closing_select_debit: 'Select debit',
    aumico_reports_fcp_closing_add_new_debit: 'Add a new debit',
    aumico_reports_fcp_closing_select_credit: 'Select credit',
    aumico_reports_fcp_closing_add_new_credit: 'Add a new credit',
    aumico_reports_fcp_closing_add_details: 'Add details',
    aumico_reports_fcp_closing_details: 'Details',
    aumico_reports_fcp_closing_add_new_text: 'Add a new text',
    aumico_reports_fcp_closing_no_closing_entries_last_year: 'There are no closing entries for this account last year.',
    aumico_reports_fcp_closing_amount: 'Amount',
    aumico_reports_fcp_closing_debit: 'Debit',
    aumico_reports_fcp_closing_credit: 'Credit',
    aumico_reports_fcp_closing_done: 'Done',
    aumico_reports_fcp_no_items: 'No items',
    aumico_reports_fcp_unknown_state: 'UNKNOWN STATE',
    aumico_reports_fcp_search_placeholder: 'Search',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_done: 'Mark all as done',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_done_confirm: 'Yes',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_done_cancel: 'No',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_dont_show_again: "Don't show this pop up again",
    aumico_reports_fcp_closing_process_checklist_mark_all_as_done_text:
        'Do you want to complete the task for all accounts?',
    aumico_reports_fcp_closing_process_checklist_delete_checklist: 'Are you sure you want to delete this checklist?',
    aumico_reports_confirm_delete: "Yes, I'm sure",
    aumico_reports_cancel_delete: 'Cancel',
    aumico_support_nav_item: 'Support',
    aumico_annual_report_mapping_load_fli_cfs_settings_warning:
        'Press the "Load CFS Settings" button if when editing flis it is missing the cash flow type. By using this function, the cashflow types in all of the flis will be reloaded from settings.Any cash flow type that you have added yourself must be entered again. This is a temporary solution!',
    aumico_annual_report_mapping_load_fli_cfs_settings_button: 'Reaload CFS Settings',
    aumico_annual_report_mapping_load_fli_cfs_settings_dialog_content:
        'This action cannot be undone after saving. Please check the cash flow types of each fli carefully after using this function.',
    aumico_annual_report_fcp_checklist_not_allow_duplicate: 'Duplicate tasks are not allowed!',
    aumico_reports_just_now: 'just now',
    aumico_reports_fcp_uploading: 'uploading',
    aumico_reports_fcp_uploaded: 'Uploaded',
    aumico_reports_hours_of_uploading: '{{diffInHours}} hours ago',
    aumico_reports_hour_of_uploading: '{{diffInHours}} hour ago',
    aumico_reports_days_of_uploading: '{{diffInDays}} days ago',
    aumico_reports_day_of_uploading: '{{diffInDays}} day ago',
    aumico_reports_fcp_file_is_virused_warning_popup:
        ' The file you uploaded is infected with a virus and cannot be processed.',

    aumico_reports_fcp_file_allowed_files: 'Please upload a .xlsx or a .xls or a .pdf file',
    aumico_reports_fcp_file_uploaded_by: 'By',
    aumico_core_ham_referencing_input_placeholder: 'Title',
    aumico_notes_components_list_actions_break_page: 'Add page break',
    aumico_notes_components_list_actions_compare_years: 'Compare Years',
    aumico_notes_components_list_actions_settings: 'Settings',
    aumico_notes_components_list_actions_add: 'Add',
    aumico_notes_components_list_actions_show_previous_year: 'Show Previous Year',
    aumico_notes_components_list_actions_transpose: 'Transpose',
    aumico_notes_components_list_actions_flip_signs: 'Flip Signs',
    aumico_reports_drag_files: 'Drag files here to upload',
    aumico_reports_browse_files: 'or browse for files',
    aumico_notes_components_list_actions_show_total: 'Calculate Sum',
    aumico_annual_report_aop_description: 'AOP Description',

    aumico_annual_report_investing_activities: 'Investing',
    aumico_annual_report_financing_activities: 'Financing',
    aumico_annual_report_cash_flow_networking_capital: 'Networking Capital',
    aumico_annual_report_cash_flow_operating_activities: 'Operating',
    aumico_annual_report_cash_flow_manual: 'Manual Input',
    aumico_annual_report_delete_item_confirmation_text: 'Are you sure you want to delete this item?',
    aumico_annual_report_cashflow_difference_text: 'Difference',
    aumico_annual_report_cashflow_difference_should_be_zero_text: 'Calculated difference (should be 0.0)',

    aumico_annual_report_cashflow_unsaved_changes:
        'Unsaved changes detected. The print data will not be updated until you confirm and save your changes.',
    aumico_annual_report_cash_flow_investing_add_new_section: 'Add new section',
    aumico_annual_report_cash_flow_investing_add_row: 'Add row',
    aumico_reports_tooltip_text_verify_data:
        'The values have been updated. Please verify if the cash flow is still correct.',
    aumico_reports_tooltip_text_verify_fcp_data:
        'The values have been updated. Please verify if the financial closing process is still correct.',
    aumico_add_new_notes_accordion_section_title: 'Add Note',
    aumico_add_new_notes_accordion_section_note_title: 'Note title',
    aumico_add_new_notes_accordion_section_note_title_input_placeholder: 'Input text',
    aumico_add_new_notes_accordion_section_select_note_component_to_add: 'Select a note component to add:',
    aumico_add_new_notes_accordion_section_add_numbering_toggle: 'Add Numbering',
    aumico_add_new_notes_accordion_section_add_numbering_toggle_description:
        'Automatically apply numbered lists to your note',
    aumico_add_new_notes_accordion_section_button: 'Add',
    aumico_add_new_notes_component_title: 'Select another component to add:',
    aumico_add_new_notes_component_button: 'Add',
    aumico_add_new_notes_component_add_numbering_toggle: 'Add Numbering',
    aumico_add_new_notes_component_add_numbering_toggle_description: 'Automatically apply numbered lists to your note',
    aumico_reports_side_bar_organization_name: 'Organization Name',
    aumico_reports_side_bar_help: 'Help & getting started',
    aumico_text_snippets_table_search_placeholder: 'Search',
    aumico_reports_organization_settings_users_add_new_button: 'Add New',
    aumico_reports_organization_settings_checklist_add_new_button: 'Add New',
    admin_create_licence_package_title: 'Create Licence Package',
    admin_create_licence_package_type: 'Package Type',
    admin_create_licence_package_type_required: 'Package type is required.',
    admin_create_licence_package_size: 'Package Size',
    admin_create_licence_package_size_required: 'Package size is required.',
    admin_create_licence_package_size_min: 'Package size must be at least {{min}}.',
    admin_create_licence_package_start_date: 'Start Date',
    admin_create_licence_package_start_date_required: 'Start date is required.',
    admin_create_licence_package_end_date: 'End Date',
    admin_create_licence_package_end_date_required: 'End date is required.',
    admin_create_licence_package_end_date_invalid: 'End date must be after the start date.',
    admin_create_licence_package_description: 'Description',
    admin_create_licence_package_price: 'Price',
    admin_create_licence_package_price_min: 'Price must be at least {{min}}.',
    admin_create_licence_package_discount_amount: 'Discount Amount',
    admin_create_licence_package_discount_amount_min: 'Discount amount must be at least {{min}}.',
    admin_create_licence_package_discount_percent: 'Discount Percent',
    admin_create_licence_package_discount_percent_min: 'Discount percent must be at least {{min}}%.',
    admin_create_licence_package_discount_percent_max: 'Discount percent cannot exceed {{max}}%.',
    admin_create_licence_package_cancel: 'Cancel',
    admin_create_licence_package_confirm: 'Confirm',
    aumico_reports_aop_account_caption: 'Caption',
    aumico_annual_report_print_options_label_non_breaking_hyphen_toggle: 'Non breaking hyphen',
    aumico_annual_report_print_options_repeat_appendix_title: 'Repeat appendix title on every page',
    aumico_annual_report_print_options_round_to_thousands: 'Round values to thousands',
    aumico_templates_mapping_remove_account_will_change_previous_year_values_warning:
        'Please take care that removing an account will modify in the previous year value',
    aumico_companies_form_assigned_users: 'Mandate Manager',
    aumico_companies_form_assigned_on: 'Assigned on',

    aumico_admin_organization_list_package_type: 'Type',
    aumico_admin_organization_list_package_start_date: 'Start Date',
    aumico_admin_organization_list_package_end_date: 'End Date',
    aumico_admin_organization_list_package_size: 'Size',
    aumico_admin_organization_list_actions: 'Actions',
    aumico_admin_organization_list_add_package: 'Add Package',
    aumico_admin_organization_list_package_delete: 'Delete',
    aumico_admin_organization_list_package_edit: 'Edit',
    aumico_admin_delete_package_confirmation_dialog_description: 'Are you sure you want to delete this package?',
    aumico_admin_organization_abcp_needs_cpmm: 'Needs CPMM',
    aumico_admin_organization_abcp_update_failed: 'ABCP could not be switched.',
    aumico_users_organization_users_table_withdraw_invite_modal_body:
        'Are you sure you want to withdraw this invitation? The user will no longer be able to join the platform unless re-invited.',
    aumico_users_organization_users_table_resend_invite_modal_body: 'Are you sure you want to resend this invitation?',
    aumico_users_organization_users_table_invite_modal_body:
        'Easily collaborate with your team by inviting new employees. This feature simplifies task distribution, enhances communication, and enables seamless teamwork on annual reports.',
    aumico_companies_mandate_text: 'Mandate Management',
    aumico_annual_report_print_options_show_notes_in_detail_in_toc: 'Detailed version',
    aumico_components_ham_styling_menu_align_left: 'align left',
    aumico_components_ham_styling_menu_align_center: 'align center',
    aumico_components_ham_styling_menu_align_right: 'align right',
    aumico_components_ham_styling_menu_bold: 'bold',
    aumico_components_ham_styling_menu_underlined: 'underlined',
    aumico_components_ham_styling_menu_italic: 'italic',
    aumico_components_ham_styling_menu_percentage: 'percentage',
    aumico_components_ham_styling_menu_less_decimals: 'decrease decimals',
    aumico_components_ham_styling_menu_more_decimals: 'increase decimals',
    aumico_components_ham_styling_menu_flip_sign: 'flip sign affects only the displayed value and not the actual value',

    aumico_reports_organization_delete_user: 'Are you sure want to delete this user?',
    aumico_reports_organization_delete: 'Delete',
    aumico_reports_companies_upload_logo: 'Upload Logo',

    aumico_reports_companies_upload_logo_description:
        'The uploaded logo will appear in the company profile and can optionally be included in printed documents.',

    aumico_reports_companies_upload_file_upload_image_info: 'Upload PNG logo',
    aumico_reports_companies_upload_file_upload_image_size: '(Maximum 5MB, 100x100px)',
    aumico_annual_report_print_options_advanced_title: 'Advanced',
    aumico_annual_report_print_options_components_accordion_title: 'Components',
    aumico_annual_report_print_options_settings_accordion_title: 'Settings',
    aumico_annual_report_print_options_signature_accordion_title: 'Signature',
    aumico_annual_report_print_options_financial_statement_components_title: 'Financial statement',
    aumico_annual_report_print_options_cash_flow_component_title: 'Cash flow statement',
    aumico_annual_report_print_options_notes_component_title: 'Notes',
    aumico_annual_report_print_options_aop_component_title: 'Appropriation of profit',
    aumico_annual_report_print_options_place_signature_after_income_statement: 'Place signature after income statement',
    aumico_annual_report_file_size_error: 'File Size exceeds 5MB',
    aumico_cover_page_internal_label: 'Internal',
    aumico_annual_report_select_autofill_options: 'Select information to copy from this template',
    aumico_annual_report_autofill_options_taxonamy: 'Taxonomy',
    aumico_annual_report_autofill_options_cfs: 'Cash flow statement',
    aumico_annual_report_autofill_options_notes: 'Notes',
    aumico_annual_report_autofill_options_aop: 'Accounts of profit',
    aumico_annual_report_print_options_general_accordion_title: 'General',
    aumico_notes_super_table_row_settings: 'Row settings',
    aumico_notes_super_table_reconcile: 'Reconcile',
    aumico_notes_super_table_reconcile_dialog_description: 'Select one item to reconcile',
    aumico_notes_super_table_mapping_row_settings_description: 'Please select one or multiple items for a new row',
    aumico_notes_super_table_mapping_row_settings_row_title: 'Row Title',
    aumico_notes_super_table_delete_column_confirmation_text: 'Are you sure want to delete this Column ?',
    aumico_notes_super_table_delete_row_confirmation_text: 'Are you sure want to delete this Row ?',
    aumico_notes_super_table_add_calculation_next: 'Next',
    aumico_notes_super_table_add_calculation_cancel: 'Go Back',
    aumico_notes_super_table_segmented_columns: 'Select the Columns to be Segmented',
    aumico_notes_super_table_select_columns: 'Select Columns',
    aumico_notes_super_table_select_from_here: 'Select from here',
    aumico_notes_super_table_edit_column: 'Edit Column',
    aumico_admin_ar_template_list_reporting_template_name: 'Pdf template name',
    aumico_admin_ar_template_reset_pdf_template_to_default_button: 'Reset template to default',
    aumico_admin_ar_template_uploaded_pdf_template_name: 'Uploaded pdf template name',
    aumico_admin_ar_template_no_custom_pdf_template_uploaded: 'No custom template uploaded',
    aumico_notes_super_table_select_summation_columns_label: 'Select the columns which shall be summed up',
    aumico_notes_super_table_select_subtraction_column_mineund: 'Mineund',
    aumico_notes_super_table_select_subtraction_column_subtrahend: 'Subtrahend',
    aumico_notes_super_table_select_multiplication_columns_label: 'Select the columns which shall be multiplied',
    aumico_notes_super_table_ratio_choose_rows_for: 'Choose Rows For',
    aumico_notes_super_table_ratio_choose_row_for: 'Choose Row For',
    aumico_notes_super_table_ratio_choose_cell: 'Choose Cell',
    aumico_notes_super_table_ratio_numerator: 'Numerator',
    aumico_notes_super_table_calculation_item_selected: 'Item Selected',
    aumico_notes_super_table_ratio_denomenator: 'Denomenator',
    aumico_annual_reports_export_excel_structured: 'Export Excel',
    aumico_notes_super_table_previous_column_removal_confirmation:
        'Are you sure you want to delete the previous year column?',
    aumico_notes_fli_component_remove_fli_confirmation_text: 'Are you sure you want to remove this item?',
    aumico_admin_navigation_survey_management: 'Survey Management',
    aumico_admin_survey_management_page_title: 'Survey Management',
    aumico_admin_survey_management_table_creation_date: 'Creation date',
    aumico_admin_survey_management_table_end_date: 'End date',
    aumico_admin_survey_management_table_survey_status: 'Survey status',
    aumico_admin_survey_management_table_number_of_participants: 'Number of participants',
    aumico_admin_survey_management_start_new_survey_button: 'Start new survey',
    aumico_admin_survey_management_start_new_survey_button_tooltip:
        'A new survey can only be launched if no other surveys are active.',
    aumico_admin_survey_management_table_survey_status_badge_ACTIVE: 'Aktiv',
    aumico_admin_survey_management_table_survey_status_badge_INACTIVE: 'Inaktiv',
    aumico_admin_survey_management_table_menu_options_delete: 'Delete survey',
    aumico_admin_survey_management_table_menu_options_stop: 'Stop survey',
    aumico_admin_survey_management_table_menu_options_download: 'Download CSV',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_DISAPPOINTED: 'Neutral',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_NOT_DISAPPOINTED: 'Detractor',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_VERY_DISAPPOINTED: 'Promoter',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_OPEN: 'Open',
    aumico_admin_survey_satisfaction_table_user: 'USER',
    aumico_admin_survey_satisfaction_table_organization: 'ORGANIZATION',
    aumico_admin_survey_satisfaction_table_pmf_response: 'PMF RESPONSE',
    aumico_admin_survey_satisfaction_table_question_2: 'MAIN BENEFIT YOU RECEIVE FROM AUMICO',
    aumico_admin_survey_satisfaction_table_question_3: 'HOW CAN WE IMPROVE OUR PRODUCT',
    aumico_admin_survey_satisfaction_table_question_4: 'TYPE OF PERSON WOULD BENEFIT MOST',
    aumico_admin_survey_satisfaction_page_pmf_score: 'PMF Score',
    aumico_admin_survey_satisfaction_page_participants: 'Participants',
    aumico_admin_survey_satisfaction_page_participants_out_of: 'out of',
    aumico_admin_survey_satisfaction_page_users: 'Users',
    aumico_admin_survey_satisfaction_page_promoters: 'Promoters',
    aumico_admin_survey_satisfaction_page_neutrals: 'Neutrals',
    aumico_admin_survey_satisfaction_page_detractors: 'Detractors',
    aumico_admin_survey_satisfaction_page_end_survey_button: 'End Survey',
    aumico_admin_survey_satisfaction_page_download_csv_button: 'Download CSV',
    aumico_admin_navigation_survey_satisfaction: 'Employee Satisfaction Survey',
    aumico_survey_popup_go_back_button: 'Go back',
    aumico_survey_popup_of: 'of',
    aumico_reports_navigation_survey_give_feedback: 'Give Feedback',
    aumico_survey_popup_thank_you: 'Thank you!',
    aumico_survey_popup_we_value_your_feedback:
        'We truly appreciate your feedback! Your insights help us make aumico even better. Thanks for taking the time to share your thoughts!',
    aumico_survey_popup_question_one: 'How would you feel if you could no longer use aumico?',
    aumico_survey_popup_question_two: 'What do you enjoy most about aumico?',
    aumico_survey_popup_question_three: 'How can we further improve aumico for you?',
    aumico_survey_popup_question_four: 'What type of person would benefit most from aumico?',
    aumico_survey_popup_question_one_response_very_disappointed: 'Very disappointed',
    aumico_survey_popup_question_one_response_somewhat_disappointed: 'Somewhat disappointed',
    aumico_survey_popup_question_one_response_not_disappointed: 'Not disappointed',
    aumico_survey_popup_close_button: 'Close',
    aumico_survey_popup_next_button: 'Next',
    aumico_survey_popup_maybe_later_button: 'Maybe Later',
    aumico_survey_popup_submit_button: 'Submit',
    aumico_survey_popup_placeholder: 'Write text here...',
    aumico_annual_report_complementary_reports_drag_here: 'Drag a report here',

    aumico_complementary_reports_report_organize_reports: 'Organize Reports',
    aumico_complementary_reports_report_create_edit_reports: 'Create reports',
    aumico_annual_reports_export_excel_structured_tooltip: 'Newly structured, and visually appealing Excel export',
    aumico_annual_report_print_seal_report_action: 'Seal Annual Report',
    aumico_annual_report_print_seal_report_history: 'Seal History',
    aumico_annual_report_print_seal_report_history_tooltip: 'There is no history to show',
    aumico_annual_report_print_seal_report_history_empty: 'No seal history available',
    aumico_annual_report_confirmation_seal_dialog_title: 'Seal report?',
    aumico_annual_report_confirmation_seal_dialog_description:
        'All exports will be generated without the "Draft" label. The report can be unsealed again at any time.',
    aumico_annual_report_confirmation_seal_dialog_action: 'Yes, Seal',
    aumico_annual_report_confirmation_unseal_dialog_title: 'Unseal Report?',
    aumico_annual_report_confirmation_unseal_dialog_description:
        'The report will be reverted to the draft state. All new exports will once again include the "Draft" label.',
    aumico_annual_report_confirmation_unseal_dialog_action: 'Unseal Report',
    aumico_annual_report_seal: 'Sealed',
    aumico_annual_report_unseal: 'Unsealed',
    aumico_annual_report_sealed_tag: 'Annual Report Sealed',
    aumico_annual_report_fs_overview_sealed_tag: 'Sealed',

    aumico_annual_report_locked: 'Locked Report',
    aumico_annual_report_Unlock: 'Unlock',
    aumico_annual_report_sealed_by: 'By ',
    aumico_button_close: 'Close',
    aumico_annual_report_complementary_report_name: 'Report Name',
    aumico_annual_report_complementary_reports_title_no_brackets: 'The title must not contain [ or ] characters.',
    aumico_annual_report_print_page_no_seal_history: 'No seal history available',
    aumico_annual_report_complementary_report_create_report: 'Reports',
    aumico_annual_report_complementary_report_organize_report: 'Order',
    aumico_notes_movement_schedule_component_column1_header: 'Additions',
    aumico_notes_movement_schedule_component_column2_header: 'Disposals',
    aumico_notes_movement_schedule_component_column3_header: 'Ord. deprec.',
    aumico_notes_movement_schedule_component_column4_header: 'Extra. deprec.',
    aumico_companies_table_label_company_assignee: 'Manager',
    aumico_companies_table_download_xls: 'Download XLS',
    aumico_pm_tasks_status_filter_label: 'Status',
    aumico_pm_tasks_status_open: 'Open',
    aumico_pm_tasks_status_in_progress: 'In Progress',
    aumico_pm_tasks_status_in_review: 'In Review',
    aumico_pm_tasks_status_done: 'Completed',
    aumico_pm_tasks_company_filter_label: 'Company',
    aumico_pm_tasks_apply_filter: 'Apply',
    aumico_pm_tasks_clear_filter: 'Clear',
    aumico_pm_tasks_assignee_filter_label: 'Manager',
    aumico_pm_tasks_due_date_filter_label: 'Due Date',
    aumico_create_project_dialog_select_company_title: 'Choose a Company',
    aumico_create_project_dialog_select_company_description:
        'To create a new project, please first select the company.',
    aumico_create_project_dialog_select_company_input_title: 'Company',
    aumico_create_project_dialog_select_company_input_placeholder: 'Set a company to assign this project',
    aumico_create_project_dialog_cancel_button: 'Cancel',
    aumico_create_project_dialog_next_button: 'Next',
    aumico_create_project_dialog_submit_button: 'Submit',
    aumico_create_project_dialog_back_button: 'Back',
    aumico_create_project_dialog_select_balance_sheet_date_title: 'Select Balance Sheet Date',
    aumico_create_project_dialog_select_balance_sheet_date_description:
        'Pick the end date of the financial year (balance sheet date).',
    aumico_create_project_dialog_select_balance_sheet_date_input_title: 'Balance Sheet Date',
    aumico_create_project_dialog_select_balance_sheet_date_input_placeholder: 'Select a balance sheet date',
    aumico_create_project_dialog_select_balance_sheet_date_calendar_today: 'Today',
    aumico_create_project_dialog_select_balance_sheet_date_calendar_clear: 'Clear',
    aumico_create_project_dialog_select_mandate_management_title: 'Set Mandate Management Configuration',
    aumico_create_project_dialog_select_mandate_management_copy_from_previous: 'Copy configuration from previous year',
    aumico_create_project_dialog_select_mandate_management_reset_to_standard: 'Reset to standard configuration',
    aumico_create_project_dialog_select_closing_workflow_title: 'Set Closing Workflow Configuration',
    aumico_create_project_dialog_select_closing_workflow_copy_from_previous: 'Copy configuration from previous year',
    aumico_create_project_dialog_select_closing_workflow_reset_to_standard: 'Reset to standard configuration',
    aumico_create_project_dialog_of: 'of',
    aumico_tasks_overview_search_tasks: 'Search',
    aumico_reports_organization_settings_workflow: 'Workflow',
    aumico_reports_organization_settings_mandate_management: 'Mandate Management Configurator',
    aumico_organization_settings_mandate_management_configuration_page_header: 'Mandate Management Configuration',
    aumico_reports_organization_settings_closing_workflow: 'Closing Workflow Configurator',
    aumico_closing_workflow_overview_search_configurations: 'Search',
    aumico_closing_workflow_overview_add_new_workflow: 'Add New Workflow',
    aumico_closing_workflow_overview_add_workflow_dialog_title: 'Add Workflow',
    aumico_closing_workflow_overview_add_workflow_dialog_description:
        'Do you want to start from scratch or select from a template?',
    aumico_closing_workflow_overview_start_from_scratch: 'Start from scratch',
    aumico_closing_workflow_overview_start_from_existing_workflow: 'Start from existing workflow',
    aumico_closing_workflow_overview_select_workflow_template_dialog_title: 'Select a workflow to use as template',
    aumico_closing_workflow_overview_next_button: 'Next',
    aumico_closing_workflow_overview_back_button: 'Back',
    aumico_closing_workflow_overview_select_workflow_template_name: 'Name',
    aumico_organization_settings_closing_workflow_configuration_page_header: 'Closing Workflow Configuration',
    aumico_cpmm_closing_workflows_table_delete_workflow_confirmation_text:
        'Are you sure you want to delete this workflow? This action cannot be undone.',
    aumico_cpmm_closing_workflows_table_title_label: 'TITLE',
    aumico_cpmm_closing_workflows_table_creation_date_label: 'CREATION DATE',
    aumico_licence_banner_trial_active:
        'You are in a trial period, you can use the application for free until {{value}}',
    aumico_licence_banner_trial_ended:
        'Your trial period has ended, please contact sales to upgrade your license count',
    aumico_licence_banner_suspended: 'Your account is suspended, please contact sales to upgrade your license count',
    aumico_licence_banner_churned:
        'Your account is cancelled. Access to your data is available until {{value}}. Please contact sales if you want to reactivate your licenses.',
    aumico_licence_tooltip_no_license: 'Maximum mandates reached, contact sales to upgrade your license count',
    aumico_licence_banner_max_is_nearing:
        'You only have {{value}} licenses left, contact sales to upgrade your license count and prevent any disruption.',
    aumico_licence_banner_max_reached:
        'You have reached the maximum number of mandates on your plan. Please contact sales to upgrade your license count.',
    aumico_licence_banner_request_more_button: 'Request Additional Licenses',
    aumico_licence_banner_dismiss_button: 'Do not show again',
    aumico_licence_banner_dialog_close_button: 'Close',
    aumico_licence_banner_dialog_title: 'Request Received',
    aumico_licence_banner_dialog_text: 'Our team will contact you shortly',
    aumico_licence_tooltip_max_reachedt: 'Maximum mandates reached, contact sales to upgrade your license count',
    aumico_reports_annual_report_navigation_mandate_management: 'Mandate Management',
    aumico_reports_annual_report_navigation_closing_workflow: 'Closing Workflow',
    aumico_reports_annual_report_navigation_closing: 'Annual Closing',
    aumico_reports_annual_report_navigation_report: 'Report',
    aumico_cp_workflow_title: 'Workflow Title',
    aumico_cpmm_enter_title: 'Enter workflow title',
    aumico_cp_general: 'General',
    aumico_cp_balance_sheet: 'Balance Sheet',
    aumico_cp_income_statement: 'Income Statement',
    aumico_cpmm_add_section: 'Add Section',
    aumico_cpmm_no_tasks_title: 'No Tasks Yet',
    aumico_cpmm_no_tasks_subtitle: 'Add a task or section to begin',
    aumico_cpmm_set_section_name: 'Enter Section Name',
    aumico_cpmm_task_name: 'Task Name',
    aumico_cpmm_task_description: 'Task Description',
    aumico_cpmm_day_title: 'Day',
    aumico_cpmm_day_placeholder: 'DD',
    aumico_cpmm_month_title: 'Month',
    aumico_cpmm_month_placeholder: 'MM',
    aumico_cpmm_period_title: 'Period',
    aumico_cpmm_period_placeholder: 'Set Period',
    aumico_cpmm_new_task: 'Add New Task',
    aumico_cpmm_max_length_notice_title: 'Maximum number of characters reached',
    aumico_cpmm_max_length_notice_description: 'You can enter a maximum of 50 characters.',
    aumico_cpmm_current_period: 'Current Period',
    aumico_cpmm_next_period: 'Next Period',
    aumico_cpmm_workflow_save_success: 'Workflow saved successfully',
    aumico_cpmm_workflow_update_failure: 'Workflow could not be updated. Please try again.',
    aumico_cpmm_section_update_success: 'Section updated successfully',
    aumico_cpmm_section_update_failure: 'Section could not be updated. Please try again.',
    aumico_cpmm_copy_of: 'Copy of ',
    aumico_cpmm_period_tooltip:
        'Current Period: year of the selected balance sheet date for the project, Next Period: year after the selected balance sheet date.',
    aumico_tasks_unassigned: 'unassigned',
    aumico_pm_tasks_company_table_header: 'Company',
    aumico_pm_tasks_due_date_table_header: 'Due Date',
    aumico_pm_tasks_section_table_header: 'Section',
    aumico_pm_tasks_task_table_header: 'Task',
    aumico_pm_tasks_latest_comment_table_header: 'Latest Comment',
    aumico_pm_tasks_status_table_header: 'Status',
    aumico_pm_tasks_responsible_table_header: 'Responsible',
    aumico_pm_tasks_select_date_today: 'Today',
    aumico_pm_tasks_filter_clear: 'Clear',
    aumico_pm_tasks_assignee_filter_my_tasks: 'My Tasks',
    aumico_companies_form_closing_workflow: 'Closing workflow',
    aumico_cpmm_closing_workflows_table_delete_section_confirmation_text:
        'Are you sure you want to remove this section from the workflow?',
    aumico_reports_main_navigation_projects: 'Projects',
    aumico_reports_my_projects: 'My Projects',
    aumico_reports_all_projects: 'All Projects',
    aumico_projects_overview_page_header: 'Projects',
    aumico_projects_overview_search_projects: 'Search',
    aumico_projects_overview_add_new_project: 'New Project',
    aumico_companies_export_excel_table_header_name: 'Name',
    aumico_companies_export_excel_table_header_street_and_number: 'Street and number',
    aumico_companies_export_excel_table_header_addition_to_address: 'Addition to address',
    aumico_companies_export_excel_table_header_zip_code: 'Zip code',
    aumico_companies_export_excel_table_header_city: 'City',
    aumico_companies_export_excel_table_header_country: 'Country',
    aumico_companies_export_excel_table_header_assigned_user: 'Assigned user',
    aumico_companies_export_excel_table_header_first_name: 'First name',
    aumico_companies_export_excel_table_header_last_name: 'Last name',
    aumico_companies_export_excel_table_header_email: 'Email',
    aumico_companies_export_excel_table_header_phone: 'Phone',
    aumico_companies_export_excel_table_header_uid_number: 'UID number',
    aumico_companies_export_excel_table_header_legal_form: 'Legal form',
    aumico_companies_export_excel_table_header_tax_domicile: 'Tax domicile',
    aumico_companies_export_excel_table_header_industry: 'Industry',
    aumico_companies_export_excel_table_header_closing_workflow: 'Closing Workflow',
    aumico_reports_main_navigation_tasks: 'Tasks',
    aumico_reports_main_navigation_tasks_and_closing: 'Closing & Tasks',
    aumico_reports_tasks_and_closing_welcome_title: '🎉 Congratulations on the Upgrade!',
    aumico_reports_tasks_and_closing_upgrade_prompt: 'Upgrade to Closing Workflow and Mandate & Task Management',
    aumico_reports_tasks_and_closing_confirm_and_continue: 'Confirm and Continue',
    aumico_reports_tasks_and_closing_cancel: 'Not at the Moment',
    aumico_reports_tasks_and_closing_start: 'Book a Meeting',
    aumico_reports_tasks_and_closing_upgrade_access_description:
        'Upgrade to access Closing Workflow and Mandate & Task Management — powerful feature to streamline your entire process and stay on top of matters. This is a paid feature, and your account will be billed upon activation.',
    aumico_reports_tasks_and_closing_success_message:
        'You have successfully activated the <b>All-in-One platform for year-end closing</b>.<br/>You now benefit from advanced features for <b>client management</b>, <b>task control</b> and the entire <b>closing process</b>.<br/>Our <b>Customer Success team</b> is here to help you set everything up – just reach out to us!',
    aumico_reports_tasks_and_closing_advertising_title: 'Enable Closing Workflow and Mandate & Task Management',
    aumico_reports_tasks_and_closing_advertising_description:
        'Seamless client management and closing workflows, no matter which accounting tool you use.',
    aumico_reports_tasks_and_closing_advertising_mandate_management_title: 'Mandate & Task Management',
    aumico_reports_tasks_and_closing_advertising_mandate_management_description:
        'Configure standardized workflows for recurring tasks (e.g., VAT, payroll, tax returns) across all clients.',
    aumico_reports_tasks_and_closing_advertising_closing_workflow_title: 'Closing Workflow',
    aumico_reports_tasks_and_closing_advertising_closing_workflow_description:
        'Configure and manage end-to-end closing workflows and manage tasks, documents & comments in one central place.',
    aumico_reports_tasks_and_closing_advertising_upgrade_button: 'Upgrade',
    aumico_create_project_invalid_date: 'Invalid Date, English format is MM/DD/YYYY, German format is DD.MM.YYYY',
    aumico_reports_project_upload_document_title: 'Upload Document',
    aumico_reports_project_upload_document_description:
        'Select a file from your device to attach to this task. Supported formats: ',
    aumico_reports_project_upload_document_drag: 'Drag files here to upload',
    aumico_reports_project_upload_document_details: '(Max. file size 25MB)',
    aumico_cpmm_workflow_configurator_empty_section_confirmation_text:
        'Are you sure you want to save with empty sections that have no tasks? This will result in the deletion of these sections',
    cpmm_projects_overview_empty_mandates: "You don't have any mandates yet!",
    cpmm_projects_overview_empty_companies: 'There are no companies yet!',
    cpmm_projects_overview_empty_assign_instructions:
        'Start by assigning companies in the company profile. They will appear here once added!',
    cpmm_projects_overview_empty_create_instructions: 'Create new companies to see them listed here.',
    cpmm_projects_overview_empty_go_to_companies_button: 'Go to companies overview',
    cpmm_projects_overview_empty_add_new_company_button: 'Add New Company',
    cpmm_projects_overview_group_mandate_management: 'Mandate Management',
    cpmm_projects_overview_group_closing_workflow: 'Closing Workflow',
    cpmm_projects_overview_group_report: 'Report',
    cpmm_projects_overview_col_company: 'Company',
    cpmm_projects_overview_col_balance_sheet_date: 'Balance Sheet Date',
    cpmm_projects_overview_col_responsible: 'Responsible',
    cpmm_projects_overview_col_status: 'Status',
    cpmm_projects_overview_action_change_status_to_done: 'Change Status to Done',
    cpmm_projects_overview_action_change_status_to_active: 'Change Status to Active',
    cpmm_projects_overview_action_delete_project: 'Delete Project',
    cpmm_projects_overview_badge_active: 'Active',
    cpmm_projects_overview_header_row_abcp_closing: 'Status',
    cpmm_projects_overview_badge_closing_started: 'Started',
    cpmm_projects_overview_badge_closing_not_started: 'Not started',
    cpmm_projects_overview_badge_done: 'Done',
    cpmm_projects_overview_badge_report_open: 'Open',
    cpmm_projects_overview_badge_report_sealed: 'Sealed',
    cpmm_projects_overview_badge_archived: 'Archived',
    cpmm_projects_overview_header_row_GENERAL: 'General',
    cpmm_projects_overview_header_row_BALANCE_SHEET: 'Balance Sheet',
    cpmm_projects_overview_header_row_INCOME_STATEMENT: 'Income Statement',
    cpmm_projects_overview_empty_individual_company: "There aren't any projects for this mandate yet.",
    cpmm_projects_overview_empty_create_instructions_individual_company:
        'Start by creating a project for this mandate!',
    aumico_companies_table_label_company_workflow: 'Workflow',
    aumico_reports_cpmm_tasks: 'Tasks',
    aumico_reports_cpmm_export_tasks: 'Export XLSX',
    aumico_reports_cpmm_export_tasks_open_tasks: 'Open Tasks',
    aumico_reports_cpmm_export_tasks_completed_tasks: 'Completed Tasks',
    aumico_reports_cpmm_export_tasks_na_tasks: 'N/A Tasks',
    aumico_reports_cpmm_export_tasks_include_documents_names: 'Include documents',
    aumico_reports_cpmm_export_tasks_include_annotations: 'Include Annotations',
    aumico_reports_cpmm_export_tasks_in_progress_tasks: 'In Progress Tasks',
    aumico_reports_cpmm_export_tasks_in_review_tasks: 'In Review Tasks',
    aumico_reports_cpmm_export_documents_zip_mandate_management_documents: 'Mandate Management Documents',
    aumico_reports_cpmm_export_documents_zip_closing_workflow_documents: 'Closing Workflow Documents',
    tasks_empty_state_text_one: "You don't have any tasks yet!",
    tasks_empty_state_text_two: 'Start by creating a new project.',
    aumico_license_book_call_text: "If you don't want to wait, book a meeting directly with the sales team.",
    aumico_license_book_call_button: 'Book a meeting',
    aumico_reports_export_all_companies_file_name: 'All Companies',
    aumico_cpmm_document_uploaded_success_title: 'Document Uploaded Successfully',
    aumico_cpmm_document_uploaded_success_description: 'The document has been uploaded successfully',
    aumico_cpmm_document_uploaded_failure_title: 'Error Uploading Document',
    aumico_cpmm_document_uploaded_failure_description: 'Failed to upload the document. Please try again',
    cpmm_projects_overview_empty_filtered_text1: 'No projects found',
    cpmm_projects_overview_empty_filtered_text2: 'Current filters return no projects. Adjust or reset them.',
    tasks_empty_state_text_one_filters: 'No tasks found',
    tasks_empty_state_text_two_filters: 'Current filters return no tasks. Adjust or reset them.',
    aumico_cpmm_task_bulk_update_success_title: 'Tasks updated successfully',
    aumico_cpmm_task_bulk_update_success_description: 'Tasks have been successfully updated.',
    aumico_cpmm_task_bulk_update_failure_title: 'Error updating tasks',
    aumico_cpmm_task_bulk_update_failure_description: 'Tasks could not be updated. Please try again.',
    aumico_company_assignee_change_confirmation_dialog_title: 'Change Clerk?',
    aumico_company_assignee_change_confirmation_dialog_text:
        "You're changing the clerk for this company. How should existing tasks be reassigned?",
    aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user:
        'Reassign only tasks assigned to the old clerk',
    aumico_company_assignee_change_confirmation_update_all_tasks:
        'Reassign all tasks, including those assigned to other users',
    aumico_company_assignee_change_confirmation_option: 'Option',
    aumico_cpmm_sync_success_title: 'Tasks are successfully synced',
    aumico_cpmm_sync_success_description: 'The tasks are all synced with the Configurator',
    aumico_cpmm_sync_failure_title: "Tasks couldn't be synced",
    aumico_cpmm_sync_failure_description: "Make sure a closing workflow is set up in this company's profile!",
    aumico_MM_sync_banner:
        'Changes in the mandate management configurator detected. Do you want to apply the changes to your project?',
    aumico_CP_sync_banner:
        'Changes in the closing process configurator detected. Do you want to apply the changes to your project?',
    aumico_MM_sync_dismiss_text: 'No, do not apply',
    aumico_MM_sync_yes_text: 'Yes, apply',
    cpmm_workflow_tasks_empty: 'No tasks available!',
    cpmm_workflow_tasks_empty_sync_instructions_CP:
        'Synchronize your project to import tasks from your Closing Process configuration.',
    cpmm_workflow_tasks_empty_sync_instructions_MM:
        'Synchronize your project to import tasks from your Mandate Management configuration.',
    aumico_workflow_sync: 'Sync Workflow',
    aumico_project_overview_project_deletion_confirmation_text:
        'Are you sure you want to delete this project? This action cannot be undone.',
    aumico_project_overview_project_delete_success_message: 'Project deleted successfully.',
    aumico_cpmm_projects_bulk_delete_success_description: 'The selected projects were deleted successfully.',
    aumico_cpmm_projects_bulk_delete_failure_title: 'Error deleting projects',
    aumico_cpmm_projects_bulk_delete_failure_description:
        'The selected projects could not be deleted. Please try again.',
    aumico_cpmm_projects_bulk_delete_success_title: 'Projects deleted successfully',
    aumico_project_overview_project_delete_error_message: 'Error deleting project. Please try again.',
    aumico_companies_form_validation_error: 'Not all required fields are filled in.',
    aumico_company_delete_failed_because_of_conf_notification_message:
        'Error deleting company due to existing dependencies... You need to delete existing projects of this company first.',
    aumico_company_delete_failed_because_of_conf_notification_title: 'We couldn’t delete this company',
    aumico_unknown_error: 'An unknown error occurred. Please try again or contact support.',
    aumico_companies_workflow_change_title: 'Change closing workflow?',
    aumico_companies_workflow_change_text:
        'Changing the closing workflow will only affect new projects. Existing projects will remain unchanged. Do you want to proceed?',
    aumico_companies_workflow_change_cancel: 'Cancel',
    aumico_companies_workflow_change_confirm: 'Confirm',
    aumico_projects_status_active: 'Active',
    aumico_projects_status_done: 'Done',
    aumico_projects_status_archived: 'Archived',
    aumico_project_overview_status_update_success_message: 'Project status updated successfully.',
    aumico_project_overview_status_update_error_message: 'There was a problem with updating the project status',
    aumico_annualreport_redo_confirmation_title: 'Restart annual report?',
    aumico_annualreport_redo_confirmation_description:
        'If you restart the annual report, the current status will be deleted and you can start a new annual report. All previous data will be lost.',
    aumico_annual_report_complementary_reports_empty_state_text1: 'No complementary reports yet!',
    aumico_annual_report_complementary_reports_empty_state_text2:
        'Add, for example, a completeness declaration or the minutes of the general meeting.\n You can automate reports with placeholders like @Companyname or @BalancesheetDate.',
    aumico_annual_report_complementary_reports_empty_state_text3:
        '<b>Tip:</b> Standardize your templates in the organization settings to reuse them for every company.',
    aumico_company_assignee_change_confirmation_dialog_save_button: 'Next',
    aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user_description_text:
        'This will transfer all tasks from the former mandate manager to the newly chosen mandate manager.',
    aumico_company_assignee_change_confirmation_update_all_tasks_description_text:
        'This will transfer all tasks to the newly chosen mandate manager, regardless of the original assignee.',
    invite_friend_modal_title: 'Tell a Friend',
    invite_friend_description:
        "If you've found our tool valuable, we'd appreciate you sharing it with a colleague or friend who might benefit from it as well.",
    invite_friend_email_label: "Friend's Email",
    invite_friend_message_label: 'Message',
    invite_friend_message_placeholder: "Add a personal note about why you think they'd find this tool useful...",
    aumico_annual_report_complementary_reports_sample_empty_state_text1: 'No report templates yet!',
    aumico_annual_report_complementary_reports_sample_empty_state_text2:
        'Create default templates for supplementary reports here, like completeness statements or general meeting minutes. \nThen you can use them later in any mandate – fully automatically with placeholders like <b>@company.name</b> or <b>@ar.duedate</b>.',
    aumico_annual_report_complementary_reports_sample_empty_state_text3:
        '<b>Tip:</b> On our <a href="https://aumico.freshdesk.com/support/solutions/articles/204000001667-erg%C3%A4nzende-berichte-alle-platzhalter-erkl%C3%A4rt-tabelle" target="_blank">Support Page</a> you can find all the placeholders you can use.',
    aumico_companies_empty_state_text1: 'No companies yet!',
    aumico_companies_empty_state_text2: 'Create your first company and start capturing projects.',
    cpmm_projects_overview_col_report_status: 'Report Status',
    cpmm_projects_overview_col_project_status: 'Project Status',
    aumico_organization_settings_mandate_management_configuration_info_text1:
        'Just enter your task due dates as if the fiscal year always ends on 31.12. (balance sheet date 31.12.)',
    aumico_organization_settings_mandate_management_configuration_info_text2:
        'If you later create a project with a different balance sheet date (e.g. <b>30.06.</b>), <b>all deadlines will magically shift for you</b> – no manual changes needed!',
    aumico_organization_settings_mandate_management_configuration_info_title: 'Tip 💡',
    aumico_organization_settings_mandate_management_configuration_info_text_example:
        '<b>Example:</b> \nA task with a due date of <b>31.03.</b> will automatically move to <b>30.09.</b> if your balance sheet date is <b>30.06.</b>.',
    aumico_backend_errors_workflow_name_already_exists: 'A workflow with this name already exists.',
    aumico_app_cpmm_documents_open: 'Preview',
    aumico_app_cpmm_documents_download: 'Download',
    aumico_app_cpmm_documents_wait_for_anti_virus: 'Waiting for virus scan',
    aumico_app_cpmm_documents_preview_loading: 'Loading...',
    aumico_app_cpmm_documents_preview_failed: 'Preview failed',
    aumico_app_cpmm_documents_preview_not_supported: 'Preview not supported',
    aumico_notes_update_banner_message:
        'Changes detected: grouping, account mapping or the trial balance changed since the notes were last saved. The notes already show the current figures. Save them so the print shows them too.',
    aumico_notes_update_banner_button: 'Apply Changes',
    aumico_print_notes_outdated_banner_message:
        'The notes are out of date: grouping, account mapping or the trial balance changed since they were last saved. Open the notes and save them so the print shows the current figures.',
    aumico_print_notes_outdated_banner_button: 'Open notes',
    aumico_notes_update_confirmation_success: 'Notes have been successfully updated.',
    aumico_notes_action_palette_column_label_name: 'Column Label Name',
    aumico_notes_action_palette_column_label_show_fiscal_year: 'Show Fiscal Year',
    aumico_notes_action_palette_column_label_show_balance_sheet_date: 'Show Balance Sheet Date',
    aumico_notes_action_palette_column_label_hide_column: 'Hide Column',
    aumico_notes_action_palette_column_label_currency: 'Currency',
    aumico_notes_super_table_show_currency: 'Show Currency',
    aumico_notes_components_list_actions_table_tooltip: 'Table Settings',
    aumico_notes_components_list_actions_footnote_tooltip: 'Footnotes',
    aumico_notes_components_list_actions_copy_tooltip: 'Copy Component',
    aumico_notes_components_list_actions_break_page_tooltip: 'Insert Page Break after component',
    aumico_notes_components_list_actions_hide_component_tooltip: 'Hide component',
    aumico_notes_components_list_actions_show_component_tooltip: 'Show component',
    aumico_notes_actions_hide_accordion_tooltip: 'Hide all components in accordion',
    aumico_notes_actions_show_accordion_tooltip: 'Show all components in accordion',
    aumico_notes_component_hidden_badge: 'HIDDEN',
    aumico_notes_super_table_edit_row: 'Edit Row',
    aumico_notes_super_table_remove_row: 'Remove Row',
    aumico_notes_super_table_row_format: 'Row Format',
    aumico_notes_super_table_column_format: 'Column Format',
    aumico_notes_super_table_remove_column: 'Remove Column',
    aumico_notes_super_table_current_year_column_removal_confirmation:
        'Are you sure you want to delete the current year column?',
    aumico_annual_report_print_page_rounding_disclaimer:
        'All displayed values are rounded for presentation. Due to rounding, there may be small differences between the shown totals and the actual overall values.',
    aumico_notes_footnote_label: 'Footnote',
    aumico_notes_footnote_placeholder: 'Add a footnote to this table',
    aumico_notes_add_more_movement: 'Add New Movement Schedule',
    aumico_notes_add_more_fli: 'Add New FLI Table',
    aumico_notes_add_more_row: 'Add New Row',
    aumico_notes_add_component: 'Add New Component',
    aumico_notes_super_table_edit_reconcile: 'Edit Reconciliation',
    aumico_add_new_notes_clipboard_title: 'Clipboard',
    aumico_add_new_notes_paste_from_clipboard: 'Paste',
    aumico_notes_component_copied_to_clipboard: 'Copied to Clipboard',
    aumico_notes_component_pasted_successfully: 'Added to Notes',
    aumico_notes_super_table_add_column_width: 'Column Width',
    aumico_notes_super_table_options_col_width_dynamic: 'Dynamic',
    aumico_notes_super_table_options_col_width_small: 'Small',
    aumico_notes_super_table_options_col_width_standard: 'Standard',
    aumico_notes_super_table_options_col_width_large: 'Large',
    aumico_notes_empty_state_text_1: 'Customize your table according to your needs.',
    aumico_notes_empty_state_text_2: 'Add the first row to get started.',
    aumico_notes_add_row_text: 'Add Row',
    aumico_projects_overview_status_update_modal_title: 'Close all open tasks?',
    aumico_projects_overview_status_update_modal_text: 'Do you want all open tasks to be automatically marked as done?',
    aumico_projects_overview_status_update_modal_confirm: 'Yes',
    aumico_projects_overview_status_update_modal_cancel: 'No',
    aumico_companies_assignee_filter_my_companies: 'My Companies',
    aumico_companies_filter_clear: 'Clear',
    aumico_notes_super_table_add_row_menu_sub_title: 'Choose the type of row you would like to add to the table.',
    aumico_notes_super_table_add_column_menu_sub_title: 'Choose the type of column you would like to add to the table.',
    aumico_notes_info_dialog_column_title: 'How to use the column width setting correctly 💡',
    aumico_notes_info_dialog_column_text1:
        '<b>Dynamic</b> distributes the available space evenly across all columns marked as dynamic.',
    aumico_notes_info_dialog_column_text2:
        '<b>Tip:</b> For example, if you want to display percentages, use <b>small</b>. For text columns, <b>dynamic</b> is recommended. <b>Standard</b> is suitable for numbers and has the same width as all other tables in the PDF.',
    aumico_notes_info_dialog_column_done: 'Understood',
    aumico_admin_navigation_announcements: 'Announcements',
    aumico_admin_announcements_message: 'Message',
    aumico_admin_announcements_link_url: 'Link Url',
    aumico_admin_announcements_link_url_placeholder: 'https://example.com',
    aumico_admin_announcements_link_name: 'Link Name',
    aumico_admin_announcements_link_name_placeholder: 'Link Name',
    aumico_admin_announcements_dismissible: 'Dismissible',
    aumico_admin_announcements_date_range: 'Date Range',
    aumico_admin_announcements_create_new_announcement: 'Create New Announcement',
    aumico_admin_announcements_edit_announcement: 'Edit Announcement',
    aumico_admin_announcements_start_date: 'Start Date',
    aumico_admin_announcements_end_date: 'End Date',
    aumico_admin_announcements_start_date_required: 'Start Date is required',
    aumico_admin_announcements_end_date_required: 'End Date is required',
    aumico_admin_announcements_update_success: 'Announcement successfully updated',
    aumico_admin_announcements_create_success: 'Announcement successfully created',
    aumico_admin_announcements_delete_success: 'Announcement successfully deleted',
    aumico_admin_success_title: 'Success',
    aumico_annual_report_complementary_reports_preview_button: 'Preview PDF',
    aumico_annual_report_complementary_reports_add_from_template: 'Add from template',
    aumico_annual_report_complementary_reports_add_blank_report: 'Add empty report',
    aumico_annual_report_complementary_reports_upload_PDF: 'Upload PDF',
    aumico_annual_report_complementary_reports_new_title: 'Add new report',
    aumico_annual_report_complementary_reports_select_template: 'Choose template',
    aumico_annual_report_complementary_reports_template_add: 'Insert',
    aumico_annual_report_complementary_reports_template_cancel: 'Cancel',
    aumico_annual_report_complementary_reports_preview_scanning_warning:
        'When printing, a blank page is inserted instead of your PDF.',
    aumico_annual_report_complementary_reports_show_page_numbers_toggle: 'Show Page Numbers',
    aumico_create_project_dialog_select_report_type: 'Select type of project',
    aumico_create_project_dialog_select_report_type_annual: 'Annual statement',
    aumico_create_project_dialog_select_report_type_quarterly: 'Quarterly interim statement',
    aumico_create_project_dialog_select_report_type_monthly: 'Monthly interim statement',
    aumico_create_project_dialog_select_report_type_custom: 'Individual interim statement',
    aumico_annual_report_general_information_ar_template: 'Report components',
    aumico_annual_report_general_information_select_ar_template: 'Select report components',
    aumico_annual_report_general_information_report_type: 'Report type',
    aumico_annual_report_general_information_select_report_type: 'Select report type',
    aumico_company_update_banner_message:
        'You have updated the company information. Do you want to apply the changes to this project?',
    aumico_company_update_banner_button: 'Yes, apply',
    aumico_annual_report_translation_gaps_title: 'Texts without a translation',
    aumico_annual_report_translation_gaps_text: 'texts have no translation in {{language}}.',
    aumico_annual_report_translation_gaps_reassurance: 'The AI translates them in the style of the translations already in this report. Afterwards the translations can be checked in the review or saved right away.',
    aumico_annual_report_translation_done_title: 'Translation complete',
    aumico_annual_report_translation_done_count: '{{count}} texts were translated into {{language}}.',
    aumico_annual_report_translation_done_question: 'Would you like to review the translation or save it right away?',
    aumico_annual_report_translation_done_legend_ai: 'Translated by the AI',
    aumico_annual_report_translation_done_legend_mapping: 'Standard translation',
    aumico_annual_report_translation_done_legend_heading: 'In review mode:',
    aumico_annual_report_translation_done_legend_unmarked: 'Unmarked texts cannot be edited.',
    aumico_annual_report_translation_legend_title: 'Legend',
    aumico_annual_report_translation_done_legend_user: 'Edited manually',
    aumico_annual_report_translation_action_review: 'Review',
    aumico_annual_report_translation_action_save_now: 'Save now',
    aumico_annual_report_translation_action_translate: 'Translate with AI',
    aumico_annual_report_translation_action_later: 'Later',
    aumico_annual_report_translation_manage_title: 'Manage translation',
    aumico_annual_report_translation_manage_text: 'You can go through the translations of this language in the review and correct them one by one.',
    aumico_annual_report_translation_manage_review: 'Review',
    aumico_annual_report_translation_manage_undo: 'Undo',
    aumico_annual_report_translation_manage_refresh: 'Check for new gaps',
    aumico_annual_report_translation_manage_no_gaps: 'No new gaps found.',
    aumico_annual_report_translation_undo_title: 'Undo translation',
    aumico_annual_report_translation_undo_text: 'All translations for this language will be deleted, including your own corrections.',
    aumico_annual_report_translation_undo_confirm: 'Delete',
    aumico_annual_report_translation_part_template: 'Balance sheet and income statement',
    aumico_annual_report_translation_part_accounts: 'Accounts',
    aumico_annual_report_translation_part_notes: 'Notes',
    aumico_annual_report_translation_part_aop: 'Appropriation of profit',
    aumico_annual_report_translation_part_ems: 'Equity movement schedule',
    aumico_annual_report_translation_part_cashflow: 'Cash flow statement',
    aumico_annual_report_translation_part_complementary: 'Complementary reports',
    aumico_annual_report_translation_running: 'Translating {{count}} texts into {{language}}.',
    aumico_annual_report_translation_running_progress: '{{translated}} of {{total}} texts translated.',
    aumico_annual_report_translation_running_hint: 'This usually takes less than a minute. Please keep the window open.',
    aumico_annual_report_translation_failed: 'The translation failed. Nothing in the report was changed.',
    aumico_annual_report_translation_save: 'Save',
    aumico_annual_report_translation_edit_title: 'Correct the translation',
    aumico_annual_report_translation_edit_source: 'Report language',
    aumico_annual_report_translation_edit_target: 'Translation',
    aumico_annual_report_translation_edit_empty: 'The field cannot be empty.',
    aumico_annual_report_translation_manage: 'Manage translation',
    aumico_annual_report_translation_sealed_tooltip: 'Unseal the report to edit the translation.',
    aumico_company_update_banner_sealed_tooltip: 'Unseal the report to apply the changes.',
    aumico_general_information_current_period: 'Current Period',
    aumico_general_information_balance_sheet: 'Balance Sheet',
    aumico_general_information_balance_sheet_date: 'Balance Sheet Date',
    aumico_general_information_income_statement: 'Income Statement',
    aumico_general_information_previous_period: 'Previous Period',
    aumico_general_information_load_previous_data_from_aumico: 'Load previous period data from aumico',
    aumico_general_information_select_report: 'Select Report',
    aumico_general_information_choose_dataset_tooltip_text: 'You can choose a dataset from an existing report',
    cpmm_projects_overview_col_report_type: 'Report Type',
    aumico_annual_report_general_information_has_previous_data: 'Has Previous Data',
    aumico_ui_no_access_title: 'Access Denied',
    aumico_ui_no_access_message:
        'You do not have access to the organization settings. Please contact your administrator.',
    aumico_ui_document_edit_form_title_add: 'Add Documentation',
    aumico_ui_document_edit_form_title_edit: 'Edit Documentation',
    aumico_ui_document_edit_form_file_existing: 'Existing file',
    aumico_ui_document_edit_form_file_upload_error_format:
        'File type not supported. Please upload a file with one of the accepted extensions.',
    aumico_ui_document_edit_form_file_required_error: 'Please select a file to upload.',
    aumico_ui_document_edit_form_link_required_error: 'Link URL is required.',
    aumico_ui_document_edit_form_link_validation_error: 'Please enter a valid HTTPS URL (e.g., https://www.aumico.io).',
    aumico_ui_document_edit_form_name_placeholder: 'Document Name',
    aumico_ui_document_edit_form_name_label: 'Set a name for your document',
    aumico_ui_document_edit_form_set_as_permanent: 'Set as permanent',
    aumico_ui_document_edit_form_set_as_permanent_tooltip:
        'You can set a file as permanent and keep for next periods or add an expiration date.',
    aumico_ui_document_edit_form_expiration_date_label: 'Expiration Date (Optional)',
    aumico_ui_document_edit_form_expiration_date_placeholder: 'Select expiration date',
    aumico_ui_document_edit_form_save_changes: 'Save Changes',
    aumico_ui_document_edit_form_cancel: 'Cancel',
    aumico_ui_document_edit_form_submit_add: 'Add Document',
    aumico_ui_document_edit_form_submit_add_link: 'Add Link',
    aumico_ui_document_edit_form_file_upload: 'Upload File',
    aumico_ui_document_edit_form_add_link: 'Add Link',
    aumico_ui_document_edit_form_add_link_label: 'Link',
    aumico_ui_document_edit_form_add_link_tooltip:
        'Add a link to an external document (e.g. SharePoint, Google Drive, Dropbox). Only HTTPS links are allowed.',
    aumico_ui_document_edit_form_add_link_placeholder: 'https://...',
    aumico_app_cpmm_documents_delete_confirmation:
        'Are you sure you want to delete the document "{{ documentName }}"? This action cannot be undone.',
    aumico_session_warning_reauth_button: 'Re-authenticate',
    aumico_session_warning_message:
        'Your session will expire in {{timeLeft}}. Please save your work and re-authenticate to continue.',
    aumico_ui_document_has_expired: 'This Document expired on: ',
    aumico_ui_document_about_to_expire: 'This Document is about to expire on: ',
    aumico_app_cpmm_documents_open_link: 'Open in Browser',
    aumico_app_cpmm_documents_is_permanent_tooltip: 'This is a permanent file.',
    aumico_companies_list_filter_mandate_manager: 'Mandate Manager',
    aumico_companies_list_filter_clerk: 'Clerk',
    aumico_projects_overview_filter_assignee_label: 'Assignee',
    aumico_tasks_overview_filter_assignee_label: 'Assignee',
    aumico_companies_bulk_changes_saved_successfully_dialog: 'Companies were successfully updated',
    aumico_company_assignee_change_dialog_title: 'Change account manager?',
    aumico_company_assignee_change_dialog_title_plural: 'Change account manager for {{ count }} companies?',
    aumico_company_clerk_change_dialog_title: 'Change clerk?',
    aumico_company_clerk_change_dialog_title_plural: 'Change clerk for {{ count }} companies?',
    aumico_company_assignee_change_dialog_select_new_assignee: 'Select new account manager',
    aumico_company_clerk_change_dialog_select_new_clerk: 'Select new clerk',
    aumico_company_assignee_change_dialog_add_assignee_for_selected_tasks: 'Choose account manager...',
    aumico_company_clerk_change_dialog_add_clerk_for_selected_tasks: 'Choose clerk...',
    aumico_company_role_change_dialog_title: 'Change role?',
    aumico_company_role_change_dialog_select_new_role: 'Select new role',
    aumico_company_role_change_dialog_add_role_for_selected_tasks: 'Choose role...',
    aumico_companies_bulk_edit_action_bar_selected_text: 'selected',
    aumico_bulk_edit_action_bar_max_selection_error: 'Maximum {{max}} selections allowed for this action',
    aumico_companies_assignee_change_action_bar: 'Change account manager',
    aumico_companies_clerk_change_action_bar: 'Change clerk',
    aumico_companies_create_next_financial_year_action_bar: 'Create next financial year',
    aumico_companies_deactivate_action_bar: 'Deactivate companies',
    aumico_companies_bulk_create_financial_year_modal_title: 'Financial Year Creation Preview',
    aumico_companies_bulk_create_financial_year_confirm: 'Create & Confirm',
    aumico_companies_bulk_create_financial_year_summary: '{{ready}} will be created, {{attention}} with special cases, {{skip}} skipped',
    aumico_companies_bulk_create_ready: 'Ready for creation',
    aumico_companies_bulk_create_attention: 'Attention: Broken fiscal years',
    aumico_companies_bulk_create_skipped: 'Skipped',
    aumico_companies_bulk_create_creating_year: 'Creating {{year}}',
    aumico_companies_bulk_create_clients: 'Clients',
    aumico_companies_bulk_create_preview_failed: 'Error loading preview',
    aumico_companies_bulk_create_success: '{{created}} financial years created successfully, {{failed}} failed',
    aumico_companies_bulk_create_failed: 'Error creating financial years',
    aumico_companies_bulk_create_job_failed: 'Bulk creation job failed. Please try again.',
    aumico_companies_bulk_create_processing: 'Processing Financial Years',
    aumico_companies_bulk_create_processing_status: 'Processing {{processed}} of {{total}} companies...',
    aumico_companies_bulk_create_success_count: 'Successful',
    aumico_companies_bulk_create_failure_count: 'Failed',
    aumico_companies_bulk_create_reason_error_calculating_preview: 'Error calculating preview. Contact support.',
    aumico_companies_bulk_create_reason_company_status_only_active:
        "Company status is '{{status}}'. Only active companies can have financial years created.",
    aumico_companies_bulk_create_reason_mandate_expired:
        'Company mandate expired on {{mandateEndDate}}. Cannot create financial year for expired mandates.',
    aumico_companies_bulk_create_reason_access_denied: 'Access denied: You do not have permission to access this company',
    aumico_companies_bulk_create_reason_error_retrieving_company_info: 'Error retrieving company information. Contact support.',
    aumico_companies_bulk_create_reason_no_previous_project: 'No previous project found',
    aumico_companies_bulk_create_reason_previous_project_no_general_info:
        'Previous project has no saved general information in its annual report',
    aumico_companies_bulk_create_reason_invalid_year_range:
        'Invalid year {{nextYear}}: must be within reasonable range ({{minYear}} to {{maxYear}})',
    aumico_companies_bulk_create_reason_invalid_date_range: 'Invalid date range: start date must be before end date',
    aumico_companies_bulk_create_reason_project_already_exists: 'Project for this period already exists',
    aumico_companies_bulk_create_reason_non_calendar_fiscal_year: 'Non-calendar fiscal year (does not start on January 1st)',
    aumico_project_overview_bulk_update_status: 'Update project status?',
    aumico_project_overview_bulk_update_status_label: 'Select project status',
    aumico_project_overview_bulk_update_status_placeholder: 'Choose new project status...',
    aumico_project_status_change_action_bar: 'Change project status',
    aumico_project_delete_action_bar: 'Delete projects',
    aumico_cpmm_project_status_bulk_update_success_title: 'Successfully updated',
    aumico_cpmm_project_status_bulk_update_success_description: 'Project status was successfully updated.',
    aumico_tasks_overview_bulk_edit_status_title: 'Update task status for the tasks?',
    aumico_tasks_overview_bulk_edit_status_title_plural: 'Update task status for {{ count }} tasks?',
    aumico_tasks_overview_bulk_edit_status_label: 'Select new task status',
    aumico_tasks_overview_bulk_edit_status_placeholder: 'Choose task status...',
    aumico_tasks_overview_bulk_edit_assignee_title: 'Change assignee for the tasks?',
    aumico_tasks_overview_bulk_edit_assignee_title_plural: 'Change assignee for {{ count }} tasks?',
    aumico_tasks_overview_bulk_edit_assignee_label: 'Select new assignee',
    aumico_tasks_overview_bulk_edit_assignee_placeholder: 'Choose assignee...',
    aumico_tasks_overview_bulk_edit_due_date_title: 'Update due date for the task?',
    aumico_tasks_overview_bulk_edit_due_date_title_plural: 'Update due date for {{ count }} tasks?',
    aumico_tasks_overview_bulk_edit_status_action_bar: 'Change task status',
    aumico_tasks_overview_bulk_edit_assignee_action_bar: 'Change assignee',
    aumico_tasks_overview_bulk_edit_due_date_action_bar: 'Change due date',
    aumico_tasks_overview_bulk_edit_delete_action_bar: 'Delete tasks',
    aumico_MMCP_overview_bulk_edit_select_all: 'Select all',
    aumico_reports_organization_settings_navigation_organization_subscription: 'Subscription',
    aumico_components_organization_settings_subscription_org_id: 'Organization ID:',
    aumico_create_project_dialog_select_report_type_description: 'Report Type',
    aumico_create_project_dialog_select_report_type_input_placeholder: 'Select a report type',
    aumico_ui_billing_downgrade_title: 'Downgrade subscription?',
    aumico_ui_billing_downgrade_confirm: 'Are you sure you want to downgrade your subscription?',
    aumico_ui_billing_downgrade_warning_features_standard:
        "You'll lose access to mandate & task management and closing process features.",
    aumico_ui_billing_downgrade_warning_features_pro: "You'll lose access to Pro features.",
    aumico_ui_billing_downgrade_warning_data_loss:
        "Any information you've added in those sections will be restorable if you reactivate.",
    aumico_ui_action_close: 'Close',
    aumico_ui_action_downgrade: 'Downgrade subscription',
    aumico_ui_billing_upgrade_title: 'Upgrade subscription?',
    aumico_ui_billing_upgrade_confirm: 'Are you sure you want to upgrade your subscription? The page will reload.',
    aumico_ui_action_upgrade: 'Upgrade subscription',
    aumico_po_report_type_filter_label: 'Report Type',
    aumico_po_report_type_annual: 'Annual statement',
    aumico_po_report_type_quarterly: 'Quarterly statement',
    aumico_po_report_type_monthly: 'Monthly statement',
    aumico_po_report_type_custom: 'Individual statement',
    aumico_app_cpmm_annotation_delete_confirmation: 'Are you sure you want to delete the comment "{{ comment }}"?',
    aumico_app_cpmm_task_delete_confirmation: 'Are you sure you want to delete the task "{{ task }}"?',
    aumico_app_cpmm_tasks_delete_confirmation: 'Are you sure you want to delete the task?',
    aumico_app_cpmm_tasks_delete_confirmation_plural: 'Are you sure you want to delete the {{ count }} tasks?',
    aumico_app_cpmm_projects_delete_confirmation: 'Are you sure you want to delete the project?',
    aumico_app_cpmm_projects_delete_confirmation_plural: 'Are you sure you want to delete the {{ count }} projects?',
    aumico_app_cpmm_companies_disable_confirmation: 'Are you sure you want to disable the company?',
    aumico_app_cpmm_companies_disable_confirmation_plural:
        'Are you sure you want to disable the {{ count }} companies?',
    aumico_orga_settings_role_change_action_bar: 'Change role',
    aumico_users_organization_users_table_delete_action_bar: 'Delete user',
    aumico_backend_errors_project_deletion_due_to_dependency:
        'This report cannot be deleted because it is used as a previous period for other reports',
    aumico_bulk_delete_dependency_warning_description:
        'The following projects are used as previous periods or copied from for other reports. Do you want to proceed and delete them anyway?',
    aumico_bulk_delete_dependency_warning_proceed: 'Yes, delete anyway',
    aumico_bulk_delete_dependency_warning_skip: 'No, skip these',
    aumico_file_export_section_title: 'Section',
    aumico_file_export_description_title: 'Task / Account',
    aumico_file_export_document_title: 'Document',
    aumico_reports_seal_unseal_cancel_action: 'No',
    aumico_cpmm_projects_bulk_delete_failure_title_due_to_dependency_en:
        'Some projects could not be deleted due to dependencies',
    aumico_backend_errors_project_deletion_due_to_dependency_multiple_en:
        'Some selected reports cannot be deleted because they are used as the previous period for other reports. Please delete these dependent reports first ->',
    aumico_organization_settings_mandate_management_configuration_mandate_and_tasks_toggle_tooltip:
        'If deactivated, then mandate management and closing workflow will be disabled',
    aumico_user_notifications_title: 'Notifications',
    aumico_user_notifications_mark_all_read: 'Mark all as read',
    aumico_user_notifications_mark_as_read: 'Mark as read',
    aumico_user_notifications_mark_as_unread: 'Mark as unread',
    aumico_user_notifications_archive: 'Archive',
    aumico_user_notifications_unarchive: 'Unarchive',
    aumico_user_notifications_filter: 'Filter notifications',
    aumico_user_notifications_clear_filter: 'Clear',
    aumico_user_notifications_empty: 'No notifications yet.',
    aumico_user_notifications_loading: 'Loading…',
    aumico_user_notifications_filter_read: 'Read',
    aumico_user_notifications_filter_unread: 'Unread',
    aumico_user_notifications_filter_archived: 'Archived',
    aumico_user_notifications_today: 'Today',
    aumico_user_notifications_last_week: 'Last Week',
    aumico_user_notifications_older: 'Older',
    aumico_user_notifications_task_fallback: 'task',
    aumico_user_notifications_role_fallback: 'role',
    aumico_user_notifications_someone_fallback: 'someone',
    aumico_user_notifications_due_date_fallback: 'due date',
    aumico_user_notifications_company_fallback: 'a company',
    aumico_user_notifications_message_task_assigned: 'New task {{taskName}} has been assigned to you.',
    aumico_user_notifications_message_company_assigned: "You've been assigned to {{companyName}} as {{role}}.",
    aumico_user_notifications_message_mention: "You've been mentioned in {{taskName}}{{companyName}} by {{user}}.",
    // REV-21374 — eine ABCP-Erwaehnung nennt die ART des Eintrags, nicht eine Aufgabe:
    // ein Abschluss-Eintrag hat keine. Der Klick fuehrt auf den Eintrag selbst.
    aumico_user_notifications_message_note_mention_comment: '{{user}} mentioned you in a comment.',
    aumico_user_notifications_message_note_mention_todo: '{{user}} mentioned you in a pendency.',
    aumico_user_notifications_message_task_ready_review: '{{taskName}} is ready for review.',
    aumico_user_notifications_message_task_rejected: '{{taskName}} was sent back for rework by {{user}}.',
    aumico_user_notifications_message_deadline_approaching: '{{companyName}}: Deadline for {{taskName}} is approaching on {{dueDate}}',
    aumico_user_notifications_message_default: 'Notification',
    aumico_reports_unsaved_changes_warning_dialog_discard_and_delete_project: 'Discard changes and delete project',
    aumico_reports_unsaved_changes_and_delete_project_warning_dialog_content:
        'You have unsaved changes in your report. Do you want to discard them and delete the project?',
    aumico_grouping_masking_bulk_action_sub_total_selected: 'Subtotals selected',
    aumico_grouping_masking_bulk_action_unhide: 'Unhide',
    aumico_grouping_masking_bulk_action_hide: 'Hide',
    cpmm_projects_overview_col_label: 'Label',
    aumico_companies_form_label_label: 'Label',
    aumico_companies_table_label_company_label: 'Label',
    aumico_grouping_masking_sort_account_btn: 'Sort Accounts',
    aumico_grouping_masking_sort_account_number_based: 'By Account Number',
    aumico_grouping_masking_sort_account_name_based: 'By Account Name',
    aumico_annual_report_mapping_page_can_not_navigate_to_grouping_and_masking_dialog_description:
        'You cannot navigate to the grouping and masking dialog because the required data is missing.',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_title:
        'Switch to Automatic Transfer of Annual Results',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_description:
        'The system can now automatically calculate your annual results. If you activate this automatic feature, your manual account will be replaced by the new system value at this point.',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_info_text:
        'Your account will not be deleted, but only removed from this financial line item.',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_confirm: 'Unmap and Activate',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_cancel: 'No, cancel',
    aumico_templates_annual_profit_account_badge_text: 'Transferred Profit',
    aumico_report_previous_annual_profit_manual_entry_title: 'Previous Annual Profit Manual Entry',
    aumico_report_previous_annual_profit_manual_entry_submit_text: 'Add Manually',
    aumico_report_previous_annual_profit_manual_entry_description:
        'The profit as of the reporting date was not found automatically – please enter it manually.',
    aumico_report_previous_annual_profit_manual_entry_balance_date: 'Balance Sheet Date',
    aumico_report_previous_annual_profit_manual_entry_missing_profit_period: 'Profit of period',
    aumico_report_previous_annual_profit_manual_entry_input_label: 'Enter profit manually',
    aumico_report_previous_annual_profit_manual_entry_input_placeholder: 'Add profit here manually',
    aumico_templates_group_account_mapping_menu_edit_profit_manually: 'Edit profit manually',
    aumico_annual_report_mapping_help_automatic_transfer_toggle_text: 'Activate Automatic Transfer of Annual Results',
    aumico_annual_report_complementary_reports_show_title_in_report_toggle: 'Display report name as title',
    aumico_annual_report_print_options_colors_accordion_title: 'Colors',
    aumico_reports_print_color_reset_to_default_button: 'Reset to default',
    aumico_projects_release_highlights_modal_title: "What's new in aumico?",
    aumico_projects_release_highlights_modal_next: 'Next',
    aumico_projects_release_highlights_modal_previous: 'Previous',
    aumico_projects_release_highlights_modal_got_it: 'Got it',

    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_confirmation_description:
        'Do you really want to switch to automatic mode? Your manual mapping for the Annual Result will be replaced.',
    aumico_templates_group_account_mapping_mapping_to_profit_fli_disabled_tooltip_text:
        'Value is automatically transferred from the P&L. It is not possible to map any other account.',
    aumico_annual_report_cash_flow_system_value_tooltip: 'System',
    aumico_pm_tasks_filter_apply: 'Apply',
    aumico_reports_error_profit_fli_not_found: 'The profit FLI could not be found. Please check your mapping settings to set it.',

    aumico_zefix_search_title: 'Search Company in Zefix',
    aumico_zefix_search_subtitle: 'Swiss Commercial Register · Automatic Data Import',
    aumico_zefix_search_placeholder: 'Enter company name or UID (e.g. aumico or CHE-108.814.245)…',
    aumico_zefix_uid_mode: 'UID Mode',
    aumico_zefix_results_count: '{{count}} result(s) in the commercial register',
    aumico_zefix_no_results_title: 'No entries found in Zefix',
    aumico_zefix_no_results_reason_1: 'Sole proprietorship without commercial register entry',
    aumico_zefix_no_results_reason_2: 'Foreign company',
    aumico_zefix_no_results_reason_3: 'Not yet registered in the commercial register',
    aumico_zefix_no_results_reason_4: 'Typo in name',
    aumico_zefix_manual_entry: 'Enter company manually',
    aumico_zefix_imported_banner: 'imported from Zefix — please review fields and save.',
    aumico_zefix_save_button: 'Review Fields & Save',
    aumico_zefix_refresh_button: 'Refresh',
    aumico_zefix_new_search: 'New Search',
    aumico_zefix_badge: '✓ Zefix',
    aumico_zefix_unavailable: 'Zefix is currently unavailable. Please enter fields manually.',
    aumico_zefix_diff_title: 'Zefix Comparison',
    aumico_zefix_diff_field: 'Field',
    aumico_zefix_diff_current: 'Current',
    aumico_zefix_diff_new: 'Zefix (new)',
    aumico_zefix_diff_no_changes: 'All data is up to date — no changes found.',
    aumico_zefix_diff_apply_all: 'Apply all',
    aumico_zefix_status_in_liquidation: 'In Liquidation',
    aumico_zefix_status_cancelled: 'Deleted',
    aumico_zefix_field_name: 'Company Name',
    aumico_zefix_field_legalform: 'Legal Form',
    aumico_zefix_field_street: 'Street',
    aumico_zefix_field_zip: 'Postal Code',
    aumico_zefix_field_city: 'City',
    aumico_zefix_field_uid: 'UID',
    // AI Fixer Panel
    aumico_ai_fixer_panel_title: 'DATEV Hirachy-Fixer',
    aumico_ai_fixer_panel_description: 'Let the AI agent analyse and fix structural issues automatically.',
    aumico_ai_fixer_panel_start_btn: 'Start AI Fix',
    aumico_ai_fixer_panel_running_title: 'AI is working…',
    aumico_ai_fixer_panel_completed_title: 'AI Fix Complete',
    aumico_ai_fixer_panel_accept_btn: 'Accept',
    aumico_ai_fixer_panel_reject_btn: 'Reject',
    aumico_ai_fixer_panel_failed_title: 'AI Fix Failed',
    aumico_ai_fixer_panel_unknown_error: 'An unknown error occurred.',
    aumico_ai_fixer_panel_retry_btn: 'Retry',
    aumico_ai_fixer_panel_cancel_btn: 'Cancel',

    // AI Fixer Progress
    aumico_ai_fixer_progress_step: 'step',
    aumico_ai_fixer_progress_steps: 'steps',

    // Taxonomy Preview Dialog
    aumico_ai_taxonomy_preview_title: 'Taxonomy Preview — AI Fix',
    aumico_ai_taxonomy_preview_no_entries: 'No entries in this section.',
    aumico_ai_taxonomy_preview_chat_placeholder: 'Ask the AI to adjust the taxonomy structure…',
    aumico_ai_taxonomy_preview_agent_working: 'Agent is working…',
    aumico_ai_taxonomy_preview_chat_you: 'You',
    aumico_ai_taxonomy_preview_chat_ai: 'AI',
    aumico_ai_taxonomy_preview_type_message: 'Type a message…',
    aumico_ai_taxonomy_preview_close: 'Close',
    aumico_ai_taxonomy_preview_send: 'Send',
    aumico_ai_taxonomy_preview_btn_preview: '🔍 Preview Structure',
    aumico_ai_taxonomy_preview_tree_updated: '✓ Tree updated',

    // Taxonomy section labels
    aumico_ai_taxonomy_section_assets: 'Balance Sheet — Assets',
    aumico_ai_taxonomy_section_liabilities: 'Balance Sheet — Liabilities',
    aumico_ai_taxonomy_section_income: 'Income Statement',

    // Node classification display names
    aumico_ai_classification_fli: 'Item',
    aumico_ai_classification_group: 'Group',
    aumico_ai_classification_hidden_group: 'Indentation',
    aumico_ai_classification_sum: 'Subtotal',
    aumico_ai_classification_of_that_item: 'Of-that Item',
    aumico_ai_classification_x_fli: 'Additional Item',
    aumico_ai_classification_sub_fli: 'Sub-item',
    aumico_ai_classification_title: 'Title',
    aumico_ai_classification_remove: 'Remove',
    aumico_ai_classification_unknown: 'Unknown',
    aumico_ai_fixed_badge: '✅ Fixed with AI',



    aumico_cover_page_draft_label: 'Draft',
    aumico_seal_banner_draft_title: 'This report is not yet sealed',
    aumico_seal_banner_draft_sub: 'All exports will include a "Draft" label until sealed',
    aumico_seal_banner_sealed_title: 'Report sealed',
    aumico_seal_banner_sealed_sub: 'Sealed on {{date}} by {{user}}',
    aumico_seal_banner_audit_log: 'Audit log',
    aumico_seal_banner_unseal: 'Unseal',
    aumico_annual_report_unseal_warning: 'Unsealing this report may lead to discrepancies if it has already been shared with stakeholders. Do you want to continue?',

    // MFA - Setup Flow
    aumico_mfa_loading: 'Loading...',
    aumico_mfa_setup_step1_title: 'Set up Two-Factor Authentication',
    aumico_mfa_setup_step1_description: 'Scan the QR code below with your authenticator app (e.g. Google Authenticator, Authy).',
    aumico_mfa_setup_step1_manual_key: 'Or enter this key manually:',
    aumico_mfa_setup_step1_countdown_label: 'New code in:',
    aumico_mfa_setup_step1_continue_button: 'Next',
    aumico_mfa_setup_step2_title: 'Verify Your Authenticator',
    aumico_mfa_setup_step2_description: 'Enter the 6-digit code from your authenticator app to confirm setup.',
    aumico_mfa_setup_step2_code_label: 'Authentication Code',
    aumico_mfa_setup_step2_code_placeholder: 'Enter 6-digit code',
    aumico_mfa_setup_step2_verify_button: 'Next',
    aumico_mfa_setup_step3_title: 'Save Your Backup Codes',
    aumico_mfa_setup_step3_description: 'Save these backup codes safely. They can be used to access your account if you lose your device.',
    aumico_mfa_setup_step3_download_button: 'Download',
    aumico_mfa_setup_step3_continue_button: 'Continue',
    aumico_mfa_setup_error_initiate: 'Failed to initialize 2FA setup. Please try again.',
    aumico_mfa_setup_error_invalid_code: 'Invalid code. Please check your authenticator app and try again.',
    aumico_mfa_setup_stepper_scan_qr: 'Scan QR',
    aumico_mfa_setup_stepper_verify: 'Verify',
    aumico_mfa_setup_stepper_backup_codes: 'Backup Codes',
    aumico_mfa_setup_step1_app_hint: 'Google Authenticator, Authy, or any TOTP-compatible app',
    aumico_mfa_setup_step2_back_button: 'Back',
    aumico_mfa_setup_step2_hint: 'Enter the 6-digit Verification Code',
    aumico_mfa_setup_footer: 'Your organization requires 2FA. This is a one-time setup.',

    // MFA - Verify Flow (Login)
    aumico_mfa_verify_title: 'Two-Factor Authentication',
    aumico_mfa_verify_description: 'Enter the 6-digit code from your authenticator app.',
    aumico_mfa_verify_code_label: 'Authentication Code',
    aumico_mfa_verify_code_placeholder: 'Enter 6-digit code',
    aumico_mfa_verify_backup_description: 'Enter one of your backup codes.',
    aumico_mfa_verify_backup_code_label: 'Backup Code',
    aumico_mfa_verify_backup_code_placeholder: 'Enter backup code',
    aumico_mfa_verify_submit_button: 'Verify',
    aumico_mfa_verify_use_backup_code: 'Use a backup code instead',
    aumico_mfa_verify_use_totp_code: 'Use authenticator app instead',
    aumico_mfa_verify_error_invalid_code: 'Invalid code. Please try again.',

    // MFA - Organization Settings
    aumico_mfa_org_toggle_title: 'Two-Factor Authentication',
    aumico_mfa_org_toggle_description: 'Once activated, all users will be prompted to set up two-factor authentication (2FA) with Google Authenticator at their next login.',
    aumico_mfa_org_toggle_description_detail: '2FA increases security by requiring both a password and a time-based verification code generated by the Google Authenticator app.',
    aumico_mfa_org_status_enabled: '2FA is enabled',
    aumico_mfa_org_status_disabled: '2FA is disabled',
    aumico_mfa_org_enable_button: 'Enable 2FA',
    aumico_mfa_org_disable_button: 'Disable 2FA',
    aumico_mfa_org_users_title: 'User MFA Status',
    aumico_mfa_org_users_col_name: 'User',
    aumico_mfa_org_users_col_email: 'Email',
    aumico_mfa_org_users_col_enabled_at: 'Enabled At',
    aumico_mfa_org_users_col_status: 'Status',
    aumico_mfa_org_users_col_actions: 'Actions',
    aumico_mfa_org_users_status_complete: 'Enabled',
    aumico_mfa_org_users_status_pending: 'Not Enabled',
    aumico_mfa_org_users_reset_button: 'Reset MFA',
    aumico_mfa_org_notification_success_title: 'Success',
    aumico_mfa_org_notification_error_title: 'Error',
    aumico_mfa_org_enable_success: '2FA has been enabled for your organization.',
    aumico_mfa_org_enable_error: 'Failed to enable 2FA. Please try again.',
    aumico_mfa_org_disable_success: '2FA has been disabled for your organization.',
    aumico_mfa_org_disable_error: 'Failed to disable 2FA. Please try again.',
    aumico_mfa_org_reset_user_success: 'MFA has been reset for the user.',
    aumico_mfa_org_reset_user_error: 'Failed to reset user MFA. Please try again.',
    aumico_mfa_org_enforce_button: 'Enforce 2 Factor Authentication',
    aumico_mfa_org_enforce_button_tooltip: 'Note: you will be logged out immediately\nto set up two-factor authentication.',
    aumico_mfa_org_disable_toggle_tooltip: 'Turning this off resets the MFA setup of all users.',

    // MFA - Navigation
    aumico_reports_organization_navigation_2fa: 'Two-Factor Auth',
    aumico_reports_organization_settings_navigation_ai_settings: 'AI Settings',
    aumico_ai_settings_loading: 'Loading AI settings...',
    aumico_ai_settings_description: 'Turn AI features on or off for your organisation.',
    aumico_ai_settings_master_title: 'Enable AI features',
    aumico_ai_settings_master_description: 'Enables all AI features for your organisation. You accept the terms first.',
    aumico_ai_settings_master_agb_empty: '(No terms text stored yet. Please contact your administrator.)',
    aumico_ai_settings_daily_usage: 'Used today',
    aumico_ai_settings_monthly_usage: 'Used this month',
    aumico_ai_settings_tokens: 'tokens',
    aumico_ai_settings_title: 'AI features',
    aumico_ai_settings_status_active: 'Active',
    aumico_ai_settings_status_inactive: 'Inactive',
    aumico_ai_settings_hero_headline: 'Intelligent help for your accounting',
    aumico_ai_settings_hero_sub: 'AI features analyse your data directly in the app. Processed securely in the EU, never used for model training.',
    aumico_ai_settings_usage_title: 'Token usage',
    aumico_ai_settings_master_short_description: 'Enables all AI features for your organisation.',
    aumico_ai_settings_agents_title: 'Available AI features',
    aumico_ai_settings_wip_label: 'In progress',
    aumico_ai_settings_wip_headline: 'We keep expanding aumico AI',
    aumico_ai_settings_wip_text: 'The infrastructure is in place. We are investing heavily in new features.',
    aumico_ai_settings_agent_available: 'Available',
    aumico_ai_settings_agent_soon: 'Coming soon',
    aumico_ai_settings_agent_more_title: 'More features coming',
    aumico_ai_settings_agent_more_text: 'New features appear here as soon as they are available. Stay tuned.',
    aumico_ai_settings_feature_closing_title: 'Closing process with AI',
    aumico_ai_settings_feature_closing_text: 'Guides you through the year-end closing: reads your documents, assigns them to the accounts and suggests reconciliations.',
    aumico_ai_settings_feature_translate_title: 'Translate report',
    aumico_ai_settings_feature_translate_text: 'Translates a report into another language.',
    aumico_ai_settings_feature_datev_title: 'Repair DATEV import',
    aumico_ai_settings_feature_datev_text: 'Repairs the account hierarchy of a DATEV import.',
    aumico_ai_settings_resets_daily: 'Resets at midnight',
    aumico_ai_settings_resets_monthly: 'Resets on the 1st of the month',
    aumico_ai_settings_info_blocked: 'When a limit is reached, further AI requests are blocked automatically.',
    aumico_ai_settings_info_agb: 'When the terms are updated, you accept them again.',
    aumico_ai_settings_load_error: 'AI settings could not be loaded.',
    aumico_ai_settings_notification_success_title: 'Setting saved',
    aumico_ai_settings_notification_enabled: 'AI features have been enabled.',
    aumico_ai_settings_notification_disabled: 'AI features have been disabled.',
    aumico_ai_settings_notification_error_title: 'Error',
    aumico_ai_settings_notification_error: 'The setting could not be saved.',
    aumico_ai_settings_notification_version_changed: 'The terms have been updated. Please read and accept the new terms.',
    aumico_ai_settings_acceptance_intro: 'Please read the following terms of use carefully before you enable the AI features:',
    aumico_ai_settings_acceptance_disclaimer: 'By clicking "Accept & enable" you confirm that you have read the terms and agree to the data processing. You can disable the AI features at any time.',
    aumico_ai_settings_acceptance_accept: 'Accept & enable',
    aumico_ai_settings_acceptance_decline: 'Decline',
    aumico_reports_main_navigation_company_integrations: 'Integrations',
    aumico_companies_integrations_section_available: 'Available',
    aumico_companies_integrations_section_coming_soon: 'Coming Soon',
    aumico_companies_integrations_btn_connecting: 'Connecting...',
    aumico_companies_integrations_status_connected: 'Connected',
    aumico_companies_integrations_status_connected_since: 'since',
    aumico_companies_integrations_btn_disconnect: 'Disconnect',
    aumico_companies_integrations_status_expired: 'Connection expired',
    aumico_companies_integrations_btn_reconnect: 'Reconnect',
    aumico_companies_integrations_btn_connect: 'Connect',
    aumico_companies_integrations_btn_sync_data: 'Sync Data',
    aumico_companies_integrations_sync_never: 'Not yet synchronized',
    aumico_companies_integrations_sync_no_matching_year: 'No matching business year found',
    aumico_companies_integrations_sync_last: 'Last synced at',
    aumico_companies_integrations_btn_submit_request: 'Submit integration request',
    aumico_companies_integrations_btn_request: 'Request',
    aumico_companies_integrations_bexio_description: 'Imports account data and journal entries directly from Bexio.',
    aumico_companies_integrations_placeholder_name: 'More coming soon',
    aumico_companies_integrations_placeholder_description: 'We are constantly working on new integrations.',
    aumico_companies_integrations_request_modal_title: 'Request Integration',
    aumico_companies_integrations_request_modal_label: 'Which software are you looking for?',
    aumico_companies_integrations_request_modal_message_label: 'Additional notes (optional)',
    aumico_companies_integrations_request_modal_message_placeholder: 'Tell us more about your needs...',
    aumico_companies_integrations_request_topal: 'Topal',
    aumico_companies_integrations_request_abacus: 'Abacus',
    aumico_companies_integrations_request_infoniqa: 'Infoniqa',
    aumico_companies_integrations_request_other: 'Other',
    aumico_companies_integrations_leaderboard_title: 'Integration Leaderboard',
    aumico_companies_integrations_leaderboard_subtitle: 'Vote for the next integration you want us to build.',
    aumico_companies_integrations_votes_label: 'votes',
    aumico_companies_integrations_btn_upvote: 'Upvote',
    aumico_companies_integrations_btn_voted: 'Voted',
    aumico_companies_integrations_name_bexio: 'Bexio',
    aumico_companies_integrations_name_topal: 'Topal',
    aumico_companies_integrations_name_abacus: 'Abacus',
    aumico_companies_integrations_name_accounto: 'Accounto',
    aumico_companies_integrations_name_infoniqa50: 'Infoniqa 50',
    aumico_companies_integrations_name_infoniqa200: 'Infoniqa 200',
    aumico_companies_integrations_name_xero: 'Xero',
    aumico_companies_integrations_name_klara: 'Klara',
    aumico_companies_integrations_name_banana: 'Banana',
    aumico_companies_integrations_name_atlanto: 'Atlanto',
    aumico_companies_integrations_name_proffix: 'PROFFIX',
    aumico_companies_integrations_name_infoniqaonestart: 'Infoniqa One Start',
    aumico_companies_integrations_name_odoo: 'Odoo',
    aumico_companies_integrations_name_dynamics365businesscentral: 'Dynamics 365 Business Central',
    aumico_companies_integrations_suggestion_cta_text: 'Your desired integration is not on the list yet? Tell us and we will add it to the leaderboard.',
    aumico_companies_integrations_suggestion_cta_button: 'Share Integration Wish',
    aumico_companies_integrations_vote_modal_title: 'Upvote Integration',
    aumico_companies_integrations_vote_modal_submit: 'Submit Vote',
    aumico_companies_integrations_vote_modal_hint: 'Before we save your vote, you can optionally share why this integration matters for your workflow. This is for internal prioritization.',
    aumico_companies_integrations_vote_modal_label: 'Optional context',
    aumico_companies_integrations_vote_modal_placeholder: 'Why is this integration important for your team? (optional)',
    aumico_companies_integrations_suggestion_modal_title: 'Suggest New Integration',
    aumico_companies_integrations_suggestion_modal_hint: 'Share your desired integration and optional context. We review these suggestions and add them to the leaderboard.',
    aumico_companies_integrations_suggestion_modal_label: 'Your integration wish',
    aumico_companies_integrations_suggestion_modal_placeholder: 'Example: Lexoffice. Optional context: used by most of our clients.',
    bexio_import_title: 'Bexio Import',
    bexio_status_connected: 'Connected',
    bexio_status_expired: 'Connection expired',
    bexio_loading_business_years: 'Loading business years...',
    bexio_import_period: 'Period',
    bexio_no_matching_year: 'No matching business year found for the balance sheet date.',
    bexio_no_business_years: 'No business years found in Bexio.',
    bexio_import_data: 'Import data',
    bexio_importing: 'Importing...',
    bexio_import_manual: 'Upload manually',
    bexio_import_success: 'Import successful',
    bexio_resync: 'Resync',
    bexio_accounts: 'accounts',
    bexio_entries: 'entries',
    bexio_import_error: 'Import failed. Please try again.',
    bexio_expired_nudge: 'The Bexio connection has expired. Please reconnect in the company profile.',
    bexio_connect_nudge: 'Tip: Connect Bexio in the company profile to import data automatically.',
    bexio_importing_title: 'Importing Data',
    bexio_importing_subtitle: "We're currently fetching your data",
    bexio_importing_hint: 'This will take a couple of seconds',
    bexio_summary_title: 'Import Summary',
    bexio_summary_overview: 'Summary',
    bexio_summary_company: 'Company',
    bexio_summary_period: 'Period',
    bexio_summary_previous_period: 'Previous Year Period',
    bexio_summary_accounts: 'Accounts',
    bexio_summary_continue: 'Continue to mapping',
    bexio_summary_discard: 'Discard',
    bexio_summary_validation_title: 'Validation',
    bexio_summary_balance_check: 'Balance Check',
    bexio_summary_current_year: 'Current Year',
    bexio_summary_previous_year: 'Previous Year',
    bexio_summary_assets: 'Assets',
    bexio_summary_liabilities: 'Liabilities',
    bexio_summary_net_income: 'Net income / loss',
    d365bc_importing_title: 'Importing data',
    d365bc_importing_subtitle: 'Pulling your accounting data from Business Central',
    d365bc_importing_hint: 'This only takes a moment',
    d365bc_summary_title: 'Import summary',
    d365bc_summary_overview: 'Overview',
    d365bc_summary_company: 'Company',
    d365bc_summary_period: 'Period',
    d365bc_summary_previous_period: 'Previous period',
    d365bc_summary_accounts: 'Accounts',
    d365bc_summary_continue: 'Continue to mapping',
    d365bc_summary_discard: 'Discard',
    d365bc_summary_validation_title: 'Validation',
    d365bc_summary_balance_check: 'Balance check',
    d365bc_summary_current_year: 'Current year',
    d365bc_summary_previous_year: 'Previous year',
    d365bc_summary_assets: 'Assets',
    d365bc_summary_liabilities: 'Liabilities',
    topal_importing_title: 'Importing data',
    topal_importing_subtitle: 'Pulling your accounting data from Topal',
    topal_importing_hint: 'This only takes a moment',
    topal_summary_title: 'Import summary',
    topal_summary_overview: 'Overview',
    topal_summary_company: 'Company',
    topal_summary_period: 'Period',
    topal_summary_previous_period: 'Previous period',
    topal_summary_accounts: 'Accounts',
    topal_summary_continue: 'Continue to mapping',
    topal_summary_discard: 'Discard',
    topal_summary_validation_title: 'Validation',
    topal_summary_balance_check: 'Balance check',
    topal_summary_current_year: 'Current year',
    topal_summary_previous_year: 'Previous year',
    topal_summary_assets: 'Assets',
    topal_summary_liabilities: 'Liabilities',
    topal_import_failed_title: 'Import failed',
    topal_import_failed_description: 'The Topal import failed. Please try again later.',
    topal_import_no_fiscal_year_description:
        'There is no Topal accounting data for the selected reporting period. Please check the reporting period and balance-sheet date of the report, then try again.',
    d365bc_summary_unmappable_accounts:
        '{{count}} account(s) could not be assigned to the balance sheet or income statement and are therefore missing from the report: {{accounts}}.<br>Set the account category on these accounts in Business Central, then sync again.',
    abacus_importing_title: 'Importing data',
    abacus_importing_subtitle: 'Pulling your accounting data from Abacus',
    abacus_importing_hint: 'This only takes a moment',
    abacus_summary_title: 'Import summary',
    abacus_summary_overview: 'Overview',
    abacus_summary_company: 'Company',
    abacus_summary_period: 'Period',
    abacus_summary_previous_period: 'Previous period',
    abacus_summary_accounts: 'Accounts',
    abacus_summary_continue: 'Continue to mapping',
    abacus_summary_discard: 'Discard',
    abacus_summary_validation_title: 'Validation',
    abacus_summary_balance_check: 'Balance check',
    abacus_summary_current_year: 'Current year',
    abacus_summary_previous_year: 'Previous year',
    abacus_summary_assets: 'Assets',
    abacus_summary_liabilities: 'Liabilities',
    abacus_summary_unmappable_accounts:
        '{{count}} account(s) could not be assigned to the balance sheet or income statement and are therefore missing from the report: {{accounts}}.<br>Set the account class on these accounts in Abacus, then sync again.',
    aumico_bexio_connect_success_title: 'Bexio connected',
    aumico_bexio_connect_success_description: 'Your Bexio account was successfully connected.',
    aumico_bexio_connect_failure_title: 'Connection failed',
    aumico_bexio_connect_failure_description: 'Could not connect your Bexio account. Please try again.',
    aumico_bexio_disconnect_success_title: 'Bexio disconnected',
    aumico_bexio_disconnect_success_description: 'Your Bexio account has been disconnected.',
    aumico_bexio_disconnect_failure_title: 'Disconnect failed',
    aumico_bexio_disconnect_failure_description: 'Could not disconnect your Bexio account. Please try again.',

    // CCR – Capital Contribution Reserves (Kapitaleinlagereserven)
    aumico_annual_report_ccr_description: 'Capital contribution reserves',
    aumico_annual_report_ccr_beginning_of_year: 'Total capital contribution reserves as of the beginning of the year',
    aumico_annual_report_ccr_end_of_year: 'Total capital contribution reserves as of the end of the year',
    aumico_annual_report_ccr_select_account: 'Select equity account',
    aumico_annual_report_ccr_add_new_item: 'Add new item',
    aumico_annual_report_ccr_enter_text: 'Enter text',
    aumico_annual_report_ccr_enter_value: 'Enter amount',
    aumico_annual_report_ccr_toggle_show: 'Show capital contribution reserves',
    aumico_annual_report_ccr_toggle_hide: 'Hide capital contribution reserves',
    aumico_annual_report_ccr_diff_prior: 'Difference prior year',
    aumico_annual_report_ccr_diff_cur: 'Open difference current year',
    aumico_annual_report_ccr_add_comment: 'Add comment',
    aumico_annual_report_ccr_remove_comment_confirm: 'Are you sure you want to remove the comment? This will delete all footnote content.',
    aumico_reports_main_navigation_company_analytics: 'Analytics',
    aumico_analytics_empty_state_title: 'No data yet',
    aumico_analytics_empty_state_subtitle: 'Create a project for this client to enable the multi-year comparison.',
    aumico_analytics_empty_state_cta: 'Create first project',
    aumico_analytics_load_failed_message: 'Data could not be loaded. Please reload the page.',
    aumico_analytics_controls_delta_pct: '% YoY',
    aumico_analytics_controls_delta_chf: 'CHF YoY',
    aumico_analytics_controls_scope_balance: 'Balance sheet',
    aumico_analytics_controls_scope_income: 'Income statement',
    aumico_analytics_controls_struct_mode: 'Common-size analysis',
    aumico_analytics_controls_struct_mode_tooltip: 'Each line as a % of the reference (operating revenue / total assets / total liabilities)',
    aumico_analytics_controls_struct_mode_no_reference_tooltip: 'No reference value defined — common-size analysis not available.',
    aumico_analytics_a11y_year_pill_toggle: 'Toggle year {{year}}',
    aumico_analytics_table_label_column: 'Designation',
    aumico_analytics_table_struct_column: '%',
    aumico_analytics_table_delta_column: 'Total Δ',
    aumico_analytics_table_empty_after_filter: 'No positions available.',
    aumico_analytics_currency_mismatch_banner: 'Note: These projects use different currencies ({{currencies}}). Values are shown without conversion.',
    aumico_pdf_my_table_delta_label: 'Total Δ',
    aumico_pdf_my_export_button: 'Export PDF',
    aumico_pdf_my_export_button_pending: 'Generating PDF …',
    aumico_pdf_my_export_failure_title: 'Export failed',
    aumico_pdf_my_export_failure_description: 'The export could not be completed. Please try again.',
    aumico_pdf_my_export_modal_title: 'Export PDF',
    aumico_pdf_my_export_modal_subtitle: 'Choose which line items should appear in the PDF.',
    aumico_pdf_my_export_modal_select_all: 'Select all',
    aumico_pdf_my_export_modal_deselect_all: 'Deselect all',
    aumico_pdf_my_export_modal_select_groups: 'All groups',
    aumico_pdf_my_export_modal_select_subtotals: 'All subtotals',
    aumico_pdf_my_language_modal_title: 'Choose language',
    aumico_pdf_my_language_modal_subtitle: 'This company has reports in multiple languages. Which language should the multi-year comparison be created in?',
    aumico_pdf_my_language_modal_cancel: 'Cancel',
    aumico_pdf_my_language_modal_confirm: 'Apply',
    aumico_pdf_my_language_modal_count_singular: 'report',
    aumico_pdf_my_language_modal_count_plural: 'reports',
    aumico_pdf_my_export_modal_cancel: 'Cancel',
    aumico_pdf_my_export_modal_confirm: 'Export',
    aumico_ai_fixer_panel_beta_label: 'Beta',
    aumico_ai_fixer_panel_bullet_analyse: 'Automatically analyses the structure of your balance sheet and P&L.',
    aumico_ai_fixer_panel_bullet_review: 'You stay in control and review the result before accepting it.',
    aumico_ai_fixer_panel_bullet_revert: 'You can discard the changes at any time.',
    aumico_ai_error_features_not_enabled: 'AI features are not activated for your organisation. Please activate them in the AI settings.',
    aumico_ai_error_daily_limit_reached: 'The daily token limit of {{limit}} has been reached. Please try again tomorrow.',
    aumico_ai_error_monthly_limit_reached: 'The monthly token limit of {{limit}} has been reached. Please try again next month.',
    aumico_ai_error_session_not_found: 'AI session not found.',
    aumico_ai_error_chat_in_progress: 'A chat turn is already in progress for this session. Please wait for it to complete.',
    aumico_ai_error_invalid_payload: 'Invalid AI agent input.',
    aumico_ai_error_agent_timeout: 'The AI agent exceeded the timeout of {{seconds}} seconds.',
    aumico_ai_error_chat_processing: 'An error occurred while processing your message. Please try again.',
    aumico_ai_error_unknown: 'Unknown error during AI processing.',
    // Flat key because the backend sends it flat (`orchestrator.handler.ts:parse()`): a refused run
    // has to SAY which field does not fit, or all that is left is "unknown error".
    abcp_error_invalid_run_payload:
        'The run was refused: the request does not match the closing agent contract. Fields concerned: {{fields}}.',
    aumico_ai_progress_section_processing: 'Analysing section "{{sectionKey}}"…',
    aumico_ai_progress_section_already_valid: 'Section "{{sectionKey}}" is already valid.',
    aumico_ai_progress_section_fixed: 'Section "{{sectionKey}}" fixed successfully.',
    aumico_ai_progress_section_with_errors: 'Section "{{sectionKey}}" completed with {{errorCount}} remaining error(s).',
    aumico_ai_progress_section_timeout: 'Section "{{sectionKey}}" timed out after {{seconds}}s.',
    aumico_ai_progress_chat_started: 'Processing your message across {{count}} section(s)…',
    aumico_ai_progress_chat_section_start: 'Analysing section "{{sectionKey}}"…',
    aumico_ai_progress_chat_section_complete: 'Section "{{sectionKey}}": {{toolCallCount}} action(s), {{remainingErrors}} remaining error(s).',
    aumico_ai_progress_chat_section_no_changes: 'Section "{{sectionKey}}": no changes needed.',
    aumico_ai_progress_chat_section_timeout: 'Section "{{sectionKey}}" timed out after {{seconds}}s.',
    aumico_ai_progress_tool_call: '[{{sectionKey}}] {{toolName}}',
    aumico_ai_progress_tool_call_with_errors: '[{{sectionKey}}] {{toolName}} → {{remainingErrors}} error(s) left',
    aumico_ai_chat_reply_no_output: 'No output available to modify. Please run the AI fix first.',
    aumico_ai_chat_reply_default: 'I processed your request. Please review the updated structure.',
    aumico_integrations_page_title: 'Integrations',
    aumico_integrations_section_available: 'Available Integrations',
    aumico_reports_organization_settings_navigation_integrations: 'Integrations',
    aumico_integration_card_btn_connect: 'Connect',
    aumico_integration_card_btn_disconnect: 'Disconnect',
    aumico_integration_card_btn_test: 'Test',
    aumico_integration_card_status_connected: 'Connected',
    aumico_integration_card_status_error: 'Error',
    aumico_integration_card_status_expired: 'Expired',
    aumico_integration_card_status_disconnected: 'Not connected',
    aumico_integration_card_status_connecting: 'Connecting ...',
    aumico_integration_card_btn_reconnect: 'Reconnect',
    aumico_integration_d365bc_displayname: 'Dynamics 365 Business Central',
    aumico_integration_d365bc_description: 'Imports account data and journal entries directly from Business Central.',
    aumico_d365bc_connect_modal_title: 'Connect Dynamics 365 Business Central',
    aumico_d365bc_step_welcome_intro: 'You will be redirected to Microsoft to grant aumico access to your Business Central.',
    aumico_d365bc_step_welcome_signin_button: 'Sign in with Microsoft',
    aumico_d365bc_step_setup_title: 'Final step — set up in your BC',
    aumico_d365bc_step_setup_tenant_connected: 'Connected with Microsoft',
    aumico_d365bc_step_setup_step1: 'Open the Business Central web client',
    aumico_d365bc_step_setup_step2: 'Search for "Microsoft Entra applications"',
    aumico_d365bc_step_setup_step3_clientid: 'Enter the Client ID',
    aumico_d365bc_step_setup_step4_state: 'Set State = Enabled',
    aumico_d365bc_step_setup_step5_permission: 'Assign Permission Set "D365 READ"',
    aumico_d365bc_step_config_environment_label: 'BC Environment Name',
    aumico_d365bc_step_config_environment_help: 'Usually "production". Change only if your BC is named differently.',
    aumico_d365bc_step_config_displayname_help: 'Required. Helps you tell multiple BC tenants apart in the overview.',
    aumico_d365bc_status_awaiting_consent: 'Waiting for Microsoft sign-in ...',
    aumico_d365bc_status_creating: 'Creating connection ...',
    aumico_d365bc_status_success: 'Connection established',
    aumico_d365bc_status_success_next_mapping: 'Next, you\'ll map your companies.',
    aumico_mapping_modal_title: 'Map companies',
    aumico_mapping_currently_mapped_to: 'Currently mapped to:',
    aumico_mapping_aumico_company_label: 'aumico company',
    aumico_button_change: 'Change',
    aumico_mapping_loading: 'Loading suggestions ...',
    aumico_mapping_vendor_company_label: 'BC Company',
    aumico_mapping_search_placeholder: 'Enter company name ...',
    aumico_mapping_or: 'or',
    aumico_mapping_search_hint_min_chars: 'Type at least 3 characters ...',
    aumico_mapping_search_loading: 'Loading companies ...',
    aumico_mapping_search_results_count: '{{count}} matches',
    aumico_mapping_search_no_results: 'No matching aumico Company found.',
    aumico_mapping_search_error: 'Could not load aumico Companies.',
    aumico_mapping_summary_title: 'Mapping complete',
    aumico_mapping_summary_matched: '{{count}} companies mapped',
    aumico_mapping_summary_skipped: '{{count}} skipped',
    aumico_mapping_summary_created: '{{count}} new companies created',
    aumico_mapping_summary_later_hint: 'You can map skipped companies later anytime.',
    aumico_mapping_btn_finish: 'Finish',
    aumico_button_retry: 'Retry',
    aumico_integration_card_btn_manage: 'Manage',
    aumico_integration_card_tenants_count: '{{count}} tenants connected',
    aumico_integration_card_tenants_reauth: '{{count}} need to sign in again',
    aumico_d365bc_manage_modal_title: 'Connected tenants',
    aumico_d365bc_manage_back_to_list: 'Back to tenants',
    aumico_d365bc_manage_add_tenant: 'Connect new tenant',
    aumico_d365bc_manage_tenant_label: 'Tenant',
    aumico_d365bc_manage_status_reauth: 'Sign in expired',
    aumico_d365bc_manage_companies_count: '{{count}} companies',
    aumico_d365bc_manage_no_mapping: '(not mapped)',
    aumico_d365bc_manage_loading_companies: 'Loading companies ...',
    aumico_d365bc_manage_company_column_bc: 'BC Company',
    aumico_d365bc_manage_search_empty: 'No company matches.',
    aumico_d365bc_manage_btn_disconnect: 'Disconnect tenant',
    aumico_d365bc_manage_btn_unlink: 'Unlink',
    aumico_d365bc_automatch_running: 'Detecting mappings automatically ...',
    aumico_d365bc_automatch_success: '{{autoMatched}} matched automatically · {{notMapped}} unmapped',
    aumico_d365bc_automatch_partial_errors: '({{errors}} errors)',
    aumico_d365bc_automatch_failed: 'Auto Match failed. Please map companies manually.',
    aumico_d365bc_manage_disconnect_confirm_title: 'Really disconnect this tenant?',
    aumico_d365bc_manage_disconnect_confirm_text: 'All mappings and cached data for this tenant will be removed.',
    aumico_d365bc_manage_empty: 'No tenants connected yet.',
    aumico_integration_topal_displayname: 'Topal',
    aumico_integration_topal_description: 'Imports accounting data directly from Topal.',
    aumico_topal_connect_modal_title: 'Connect Topal',
    aumico_topal_step_welcome_intro: 'Enter your Topal server URL plus username and password. aumico connects directly to your Topal.',
    aumico_topal_step_config_displayname_help: 'Required. Helps you tell multiple Topal servers apart in the overview.',
    aumico_topal_step_config_serverurl_label: 'Server URL',
    aumico_topal_step_config_serverurl_help: 'Your Topal server URL incl. port, e.g. https://topal.example.ch:9001',
    aumico_topal_step_config_username_label: 'Username',
    aumico_topal_step_config_password_label: 'Password',
    aumico_topal_step_config_password_help: 'The password is stored encrypted and never shown again.',
    aumico_topal_step_config_password_show: 'Show',
    aumico_topal_step_config_password_hide: 'Hide',
    aumico_topal_manage_modal_title: 'Connected Topal servers',
    aumico_topal_manage_empty: 'No Topal servers connected yet.',
    aumico_topal_manage_add_server: 'Connect a new server',
    aumico_topal_manage_back_to_list: 'Back to servers',
    aumico_topal_manage_status_reauth: 'Sign-in expired',
    aumico_topal_manage_loading_companies: 'Loading companies ...',
    aumico_topal_manage_companies_count: '{{count}} companies',
    aumico_topal_manage_no_mapping: '(not linked)',
    aumico_topal_manage_company_column_topal: 'Topal company',
    aumico_topal_manage_search_empty: 'No company found.',
    aumico_topal_manage_btn_unlink: 'Unlink',
    aumico_topal_manage_btn_disconnect: 'Disconnect server',
    aumico_topal_manage_disconnect_confirm_title: 'Really disconnect this server?',
    aumico_topal_manage_disconnect_confirm_text: 'All mappings and cached data for this server will be removed.',
    aumico_topal_automatch_running: 'Detecting links automatically ...',
    aumico_topal_automatch_success: '{{autoMatched}} auto-detected · {{notMapped}} not linked',
    aumico_topal_automatch_partial_errors: '({{errors}} errors)',
    aumico_topal_automatch_failed: 'Auto-match failed. Please link companies manually.',
    // ── Accounto (REV-21119) ──
    aumico_integration_accounto_displayname: 'Accounto',
    aumico_integration_accounto_description: 'Imports accounting data directly from Accounto.',
    aumico_accounto_connect_modal_title: 'Connect Accounto',
    aumico_accounto_step_welcome_intro:
        'Create an API key in Accounto and paste it here. A fiduciary key connects all your clients, an SME key your own company. aumico only reads accounting data and never writes to your Accounto.',
    aumico_accounto_step_config_displayname_help:
        'Required. Helps you tell several Accounto connections apart in the overview.',
    aumico_accounto_step_config_apikey_label: 'API key',
    aumico_accounto_step_config_apikey_help:
        'Stored encrypted and never shown again. The key has an expiry date; aumico warns you 30 days ahead.',
    aumico_accounto_step_config_apikey_show: 'Show',
    aumico_accounto_step_config_apikey_hide: 'Hide',
    aumico_accounto_validation_apikey_invalid:
        'This is not an Accounto API key. Copy the whole key from Accounto: three parts separated by dots.',
    aumico_accounto_validation_missing_fields: 'Still to fill in:',
    aumico_accounto_manage_modal_title: 'Connected Accounto access',
    aumico_accounto_manage_empty: 'No Accounto access connected yet.',
    aumico_accounto_manage_add_server: 'Connect a new API key',
    aumico_accounto_manage_back_to_list: 'Back to the connections',
    aumico_accounto_manage_status_reauth: 'Sign-in failed',
    aumico_accounto_manage_key_advisor: 'Fiduciary key · tenant {{tenantId}}',
    aumico_accounto_manage_key_client: 'SME key · tenant {{tenantId}}',
    aumico_accounto_key_valid_until: 'API key valid until {{date}}',
    aumico_accounto_key_expiring: 'API key expires on {{date}}. Create a new key in Accounto.',
    aumico_accounto_key_expired: 'API key expired on {{date}}. Create a new key in Accounto.',
    aumico_accounto_card_key_expiring: 'Key expires soon',
    aumico_accounto_card_key_expired: 'Key expired',
    aumico_accounto_manage_loading_companies: 'Loading tenants ...',
    aumico_accounto_manage_companies_count: '{{count}} tenants',
    aumico_accounto_manage_no_mapping: '(not linked)',
    aumico_accounto_manage_company_column_accounto: 'Accounto tenant',
    aumico_accounto_manage_search_empty: 'No tenant found.',
    aumico_accounto_manage_btn_unlink: 'Unlink',
    aumico_accounto_manage_btn_disconnect: 'Disconnect',
    aumico_accounto_manage_disconnect_confirm_title: 'Really disconnect this access?',
    aumico_accounto_manage_disconnect_confirm_text: 'All mappings and cached data for this access will be removed.',
    aumico_accounto_automatch_running: 'Detecting links automatically ...',
    aumico_accounto_automatch_success: '{{autoMatched}} detected automatically · {{notMapped}} not linked',
    aumico_accounto_automatch_partial_errors: '({{errors}} errors)',
    aumico_accounto_automatch_failed: 'Auto-match failed. Please link companies manually.',
    accounto_importing_title: 'Importing data',
    accounto_importing_subtitle: 'Fetching your accounting data from Accounto',
    accounto_importing_hint: 'This only takes a moment',
    accounto_summary_title: 'Import summary',
    accounto_summary_overview: 'Overview',
    accounto_summary_company: 'Company',
    accounto_summary_period: 'Period',
    accounto_summary_previous_period: 'Previous period',
    accounto_summary_accounts: 'Accounts',
    accounto_summary_continue: 'Continue to mapping',
    accounto_summary_discard: 'Discard',
    accounto_summary_validation_title: 'Validation',
    accounto_summary_balance_check: 'Balance check',
    accounto_summary_current_year: 'Current year',
    accounto_summary_previous_year: 'Previous year',
    accounto_summary_assets: 'Assets',
    accounto_summary_liabilities: 'Liabilities',
    accounto_import_failed_title: 'Import failed',
    accounto_import_failed_description: 'The Accounto import failed. Please try again later.',
    accounto_import_key_expired_description: 'The Accounto API key has expired. Create a new key in Accounto.',
    accounto_import_invalid_key_description:
        'The Accounto API key is invalid or has expired. Create a new key in Accounto and replace it under Organization settings → Integrations.',
    accounto_import_connection_error_description:
        'The connection to Accounto is broken. Test it under Organization settings → Integrations or replace the API key there.',
    accounto_import_tenant_not_allowed_description:
        'An SME key imports only its own company. Choose this key’s tenant or connect a fiduciary key.',
    accounto_import_vendor_mismatch_description:
        'The selected connection is not an Accounto connection. Choose this company’s Accounto connection.',
    accounto_import_tenant_not_mapped_description:
        'This Accounto tenant is not assigned to this company. Check the assignment under Integrations.',
    accounto_import_mapping_not_active_description:
        'The assignment to this Accounto tenant is not active. Activate it under Integrations and try again.',
    accounto_import_unbalanced_booking_description:
        'A booking in Accounto is not balanced: debit and credit do not match. Correct it in Accounto and import again.',
    accounto_import_unknown_accounting_type_description:
        'An account with bookings in Accounto has an unknown account type. Check the account type in Accounto and import again.',
    // ── Proffix (REV-22536) ──
    aumico_integration_proffix_displayname: 'PROFFIX',
    aumico_integration_proffix_description: 'Imports accounting data directly from PROFFIX.',
    aumico_proffix_connect_modal_title: 'Connect PROFFIX',
    aumico_proffix_step_welcome_intro:
        'Enter the address of your PROFFIX PxRestAPI, the REST API password and your PROFFIX username and password. The PxRestAPI must be reachable over HTTPS (e.g. through a reverse proxy). aumico only reads accounting data and never writes to your PROFFIX.',
    aumico_proffix_step_config_displayname_help: 'Required. Helps you tell multiple PROFFIX servers apart in the overview.',
    aumico_proffix_step_config_serverurl_label: 'Server URL',
    aumico_proffix_step_config_serverurl_help:
        'Your PxRestAPI address incl. port, e.g. https://proffix.example.ch:11011 or https://proffix.example.ch:11011/pxapi/V4',
    aumico_proffix_step_config_restapikey_label: 'REST API password',
    aumico_proffix_step_config_restapikey_help:
        'The PxRestAPI password (not your user password). It is stored encrypted and never shown again.',
    aumico_proffix_step_config_username_label: 'Username',
    aumico_proffix_step_config_password_label: 'Password',
    aumico_proffix_step_config_password_help: 'The password of your PROFFIX user. It is stored encrypted and never shown again.',
    aumico_proffix_step_config_password_show: 'Show',
    aumico_proffix_step_config_password_hide: 'Hide',
    aumico_proffix_validation_serverurl_invalid:
        'Enter only the server address with port, optionally with /pxapi/V4, but no further path such as /PRO/Info. It starts with https://.',
    aumico_proffix_validation_missing_fields: 'Still to fill in:',
    aumico_proffix_manage_modal_title: 'Connected PROFFIX servers',
    aumico_proffix_manage_empty: 'No PROFFIX servers connected yet.',
    aumico_proffix_manage_add_server: 'Connect a new server',
    aumico_proffix_manage_back_to_list: 'Back to servers',
    aumico_proffix_manage_status_reauth: 'Sign-in failed',
    aumico_proffix_manage_loading_companies: 'Loading databases ...',
    aumico_proffix_manage_companies_count: '{{count}} databases',
    aumico_proffix_manage_no_mapping: '(not linked)',
    aumico_proffix_manage_company_column_proffix: 'PROFFIX database',
    aumico_proffix_manage_search_empty: 'No database found.',
    aumico_proffix_manage_btn_unlink: 'Unlink',
    aumico_proffix_manage_btn_disconnect: 'Disconnect server',
    aumico_proffix_manage_disconnect_confirm_title: 'Really disconnect this server?',
    aumico_proffix_manage_disconnect_confirm_text: 'All mappings and cached data for this server will be removed.',
    aumico_proffix_automatch_running: 'Detecting links automatically ...',
    aumico_proffix_automatch_success: '{{autoMatched}} auto-detected · {{notMapped}} not linked',
    aumico_proffix_automatch_partial_errors: '({{errors}} errors)',
    aumico_proffix_automatch_failed: 'Auto-match failed. Please link companies manually.',
    proffix_importing_title: 'Importing data',
    proffix_importing_subtitle: 'Pulling your accounting data from PROFFIX',
    proffix_importing_hint: 'This only takes a moment',
    proffix_summary_title: 'Import summary',
    proffix_summary_overview: 'Overview',
    proffix_summary_company: 'Company',
    proffix_summary_period: 'Period',
    proffix_summary_previous_period: 'Previous period',
    proffix_summary_accounts: 'Accounts',
    proffix_summary_continue: 'Continue to mapping',
    proffix_summary_discard: 'Discard',
    proffix_summary_validation_title: 'Validation',
    proffix_summary_balance_check: 'Balance check',
    proffix_summary_current_year: 'Current year',
    proffix_summary_previous_year: 'Previous year',
    proffix_summary_assets: 'Assets',
    proffix_summary_liabilities: 'Liabilities',
    proffix_import_failed_title: 'Import failed',
    proffix_import_failed_description: 'The PROFFIX import failed. Please try again later.',
    aumico_integration_abacus_displayname: 'Abacus',
    aumico_integration_abacus_description: 'Imports accounting data via AbaReport directly from Abacus.',
    aumico_abacus_connect_modal_title: 'Connect Abacus',
    aumico_abacus_step_welcome_intro: 'Enter your Abacus server URL and OAuth2 credentials. aumico connects directly to your Abacus via AbaReport.',
    aumico_abacus_step_config_displayname_help: 'Required. Helps you distinguish multiple Abacus servers in the overview.',
    aumico_abacus_step_config_serverurl_label: 'Server URL',
    aumico_abacus_step_config_serverurl_help: 'Your Abacus server URL, e.g. https://abaweb.example.ch',
    aumico_abacus_step_config_clientid_label: 'Client ID',
    aumico_abacus_step_config_clientsecret_label: 'Client Secret',
    aumico_abacus_step_config_clientsecret_help: 'The secret is stored encrypted and will not be shown again.',
    aumico_abacus_step_config_clientsecret_show: 'Show',
    aumico_abacus_step_config_clientsecret_hide: 'Hide',
    aumico_abacus_manage_modal_title: 'Connected Abacus Servers',
    aumico_abacus_manage_empty: 'No Abacus servers connected yet.',
    aumico_abacus_manage_add_server: 'Connect new server',
    aumico_abacus_manage_add_mapping: 'Add mapping',
    aumico_abacus_manage_back_to_list: 'Back to list',
    aumico_abacus_manage_companies_section_title: 'Mapped companies',
    aumico_abacus_manage_companies_empty: 'No companies mapped yet.',
    aumico_abacus_manage_status_reauth: 'Credentials invalid',
    aumico_abacus_manage_btn_disconnect: 'Disconnect server',
    aumico_abacus_manage_disconnect_confirm_title: 'Really disconnect this server?',
    aumico_abacus_manage_disconnect_confirm_text: 'All mappings and cached data for this server will be removed.',
    aumico_abacus_mapping_add_title: 'Assign Mandant ID',
    aumico_abacus_mapping_edit_title: 'Edit Mandant ID',
    aumico_abacus_mapping_mandanten_id_placeholder: 'e.g. 1001',
    aumico_abacus_mapping_mandanten_id_help: 'The numeric Mandant ID in Abacus.',
    aumico_integration_setup_displayname_label: 'Display name',
    aumico_integration_setup_displayname_placeholder: 'e.g. Trust Co. X',
    aumico_integration_search_company_placeholder: 'Search company ...',
    aumico_integration_status_error_title: 'Connection failed',
    aumico_integration_status_testing: 'Testing connection ...',
    aumico_integration_status_connected: 'Connected',
    aumico_integration_connect_button: 'Establish connection',
    aumico_integration_connect_already_exists_title: 'Server already connected',
    aumico_integration_connect_already_exists_description: 'This server is already connected in your organization. You can find it in the overview.',
    aumico_integration_aumico_company_label: 'aumico Company',
    aumico_abacus_mandanten_id_label: 'Mandant ID',
    aumico_button_ok: 'OK',
    aumico_integration_card_btn_info: 'Info',
    aumico_integration_card_status_action_required: 'Action required',
    aumico_integration_card_beta: 'BETA',
    aumico_integration_card_beta_tooltip:
        'Beta: we are still validating this integration with early customers. You can already use it – your feedback helps us improve it.',
    aumico_company_integrations_section_connected: 'Connected',
    aumico_company_integration_redirect_tenant_label: 'Tenant',
    aumico_company_integration_redirect_environment_label: 'Environment',
    aumico_company_integration_redirect_external_company_label: 'Linked company',
    aumico_company_integration_redirect_broken: 'The linked connection is no longer available. Please check it in the organization settings.',
    aumico_company_integration_redirect_managed_in_org: 'This integration is managed in the organization settings.',
    aumico_integration_managed_in_org_ask_admin: 'Please ask an admin to set this integration up in the organization settings.',
    aumico_company_integration_redirect_goto_org_settings: 'Go to organization settings',
    aumico_company_integration_bexio_modal_connected: 'Bexio is connected to this company. You can disconnect it here.',
    aumico_company_integration_bexio_modal_disconnected: 'Connect Bexio to this company to import account data and journal entries directly.',
    aumico_org_integration_redirect_managed_in_company: 'Bexio is managed per company. Please connect it directly in the individual company.',
    aumico_editable_account_unlock_prior_year_tooltip: 'Unlock prior-year value',
    aumico_grouping_masking_reclass_legacy_banner: 'Reclassifications for this report are managed in the existing tab. The new feature is disabled here.',
    // ── REV-21964 · SharePoint sync report + upstream states ─────────────────────────────
    abcp_sync_run_status_pending: 'Waiting',
    abcp_sync_run_status_running: 'Running',
    abcp_sync_run_status_completed: 'Completed',
    abcp_sync_run_status_failed: 'Failed',
    abcp_sync_refused_closing_sealed: 'This closing is sealed. No further documents are accepted.',
    abcp_sync_refused_already_running: 'A synchronisation is already running.',
    abcp_sync_refused_no_bound_folders: 'No folder has been connected yet.',
    abcp_sync_started: 'Synchronisation started. You can carry on working.',
    abcp_sync_new_documents: '{{count}} new document',
    abcp_sync_new_documents_plural: '{{count}} new documents',
    abcp_sync_new_documents_none: 'No new documents',
    abcp_sync_problem_files: '{{count}} file not imported',
    abcp_sync_problem_files_plural: '{{count}} files not imported',
    abcp_sync_failed_folders: '{{count}} folder not readable',
    abcp_sync_failed_folders_plural: '{{count}} folders not readable',
    abcp_sync_skips_truncated: 'Further files are not listed here individually. The number of new documents is complete.',
    abcp_sync_folder_failed: 'Folder could not be read: {{folderPath}}',
    abcp_sync_never_run: 'This closing has never been synchronised.',
    abcp_sync_skip_unsupported_type: 'File type is not imported (only PDF, Excel and Word)',
    abcp_sync_skip_already_imported: 'Already in the closing, unchanged',
    abcp_sync_skip_download_failed: 'File could not be downloaded',
    abcp_sync_skip_rejected_by_ingest: 'Rejected on upload',
    abcp_sync_skip_listing_capped: 'The folder has more files than one run reads',
    abcp_sync_skip_too_large: 'File is larger than 32 MB',
    abcp_sync_skip_duplicate_content: 'Same content as an existing document. The name is noted there.',
    abcp_upstream_state_deleted: 'Deleted in SharePoint',
    abcp_upstream_state_moved_out: 'Moved out of the connected folder',
    abcp_upstream_state_replaced: 'Replaced by a newer version',
    abcp_upstream_notice_assigned: 'This document backs an account and is no longer in place in SharePoint. It stays in the closing — please check.',
    abcp_upstream_notice_unassigned: 'No longer in place in SharePoint.',
    abcp_upstream_notice_replaced_assigned: 'SharePoint has a newer version of this file. This document backs an account and stays in the closing unchanged — the new version is in the inbox and needs to be assigned by you.',
    abcp_upstream_notice_replaced_unassigned: 'SharePoint has a newer version of this file. It is in the inbox.',
    abcp_upstream_action_not_relevant: 'Mark as not relevant',
    abcp_upstream_alias_names: 'Other names in SharePoint: {{names}}',
    abcp_upstream_changed_at: 'Noticed on {{date}}',
    abcp_accounts_status_open: 'Open',
    abcp_accounts_status_difference: 'Difference',
    abcp_accounts_status_reconciled: 'Reconciled',
    // What started a reconciliation run, as its first trail line names it.
    abcp_trail_trigger_document_assigned: 'document assigned',
    abcp_trail_trigger_document_unassigned: 'assignment removed',
    abcp_trail_trigger_document_removed: 'document removed',
    abcp_trail_trigger_erp_sync: 'accounting synchronised',
    abcp_accounts_col_number: 'No.',
    abcp_accounts_col_label: 'Description',
    abcp_accounts_col_status: 'Status',
    abcp_accounts_error: 'The account overview could not be loaded.',
    abcp_accounts_empty: 'No accounts available.',
    abcp_accounts_group_reconciled_tooltip: 'All accounts in this group are reconciled',
    abcp_accounts_group_status_tooltip: '{{reconciled}} reconciled, {{difference}} with a difference, {{open}} open',
    abcp_accounts_marked_tooltip: 'Marked',
    abcp_ledger_col_date: 'Date',
    abcp_ledger_col_text: 'Description',
    abcp_ledger_col_account: 'Offset acct.',
    abcp_ledger_col_account_label: 'Offset account name',
    abcp_ledger_col_vat: 'VAT',
    abcp_ledger_col_debit: 'Debit',
    abcp_ledger_col_credit: 'Credit',
    abcp_ledger_col_balance: 'Balance',
    abcp_ledger_row_opening: 'Opening balance',
    abcp_ledger_row_closing: 'Closing balance',
    abcp_ledger_empty: 'No entries available.',
    abcp_ledger_error: 'The entries could not be loaded.',
    abcp_ledger_foreign_rate: 'Rate',
    abcp_ledger_foreign_unavailable: 'not available',
    abcp_ledger_load_more: 'Load more',
    abcp_ledger_mark_comment: 'Comment',
    abcp_ledger_mark_todo: 'Add open item',
    abcp_ledger_line_missing_title: 'Entry not found',
    abcp_ledger_line_missing_body: 'The entry is no longer in the account ledger. It was changed or deleted in the ERP.',
    abcp_settings_open: 'Settings',
    abcp_closing_currency_missing: 'This closing has no currency yet. Set it in the settings and the amounts will be shown.',
    abcp_settings_title: 'Annual closing settings',
    abcp_settings_loading: 'Loading settings …',
    abcp_settings_year: 'Current financial year',
    abcp_settings_period_start: 'Start',
    abcp_settings_period_end: 'End',
    abcp_settings_currency: 'Currency',
    abcp_settings_save: 'Save',
    abcp_settings_cancel: 'Cancel',
    abcp_settings_reason_order: 'The start must be before the end.',
    abcp_settings_load_failed: 'The settings could not be loaded.',
    abcp_settings_save_failed: 'The settings could not be saved.',

    // REV-21370 / REV-21364 / REV-21375 — Korrekturbuchungen (ADR-0015).
    //
    // FLAT keys, like `abcp_ledger_*` above: these are FE-owned and carry no dots. The nested
    // `abcp.*` form is for the DOTTED keys the backend supplies, which i18next can only resolve
    // out of an object (ADR-0015 §12).
    abcp_adjustments_filter_all: 'All',
    abcp_adjustments_filter_released: 'Released',
    abcp_adjustments_filter_transferred: 'Transferred',
    abcp_adjustments_filter_booked: 'Booked',
        abcp_adjustments_filter_discarded: 'Discarded',
        abcp_adjustments_restore: 'Release again',
        abcp_adjustments_restore_hint: 'The discarded correction is released again and reappears in the working lists.',
        abcp_adjustments_discarded: 'Discarded',
        abcp_adjustments_discarded_hint: 'Withdrawn — not deleted. Kept for traceability.',
        abcp_adjustments_edit_start: 'Edit',
        abcp_adjustments_edit_save: 'Save',
        abcp_adjustments_edit_cancel: 'Cancel',
    abcp_adjustments_fiscal_year: 'Fiscal year',
    abcp_adjustments_fiscal_year_short: 'FY',
    abcp_adjustments_fiscal_year_current: 'current',
    abcp_adjustments_new: 'New entry',
    abcp_adjustments_transfer: 'Transfer',
    abcp_adjustments_row_actions: 'Actions',
    abcp_adjustments_edit: 'Edit',
    abcp_adjustments_discard: 'Discard',
    abcp_adjustments_retry: 'Try again',
    abcp_adjustments_col_state: 'Status',
    abcp_adjustments_col_text: 'Description',
    abcp_adjustments_col_debit: 'Debit',
    abcp_adjustments_col_credit: 'Credit',
    abcp_adjustments_col_amount: 'Amount',
    abcp_adjustments_col_pnl: 'P&L',
    abcp_adjustments_effect_increase: 'Increases profit',
    abcp_adjustments_effect_decrease: 'Reduces profit',
    abcp_adjustments_effect_none: 'No effect',
    abcp_adjustments_col_source: 'Source',
    abcp_adjustments_col_date: 'Date',
    abcp_adjustments_state_released: 'Released',
        abcp_adjustments_state_proposed: 'Proposed',
        abcp_adjustments_state_proposed_hint: 'Proposed by an agent — not yet released.',
        abcp_adjustments_not_found: 'Not found',
        abcp_adjustments_not_found_hint: 'Not found in the ERP´s imported journal. Not an error — the posting may still follow.',
        abcp_adjustments_result_excluded: 'Unclassified',
        abcp_adjustments_result_excluded_hint: 'One account of this booking is missing from the chart of accounts. The booking is excluded from the result.',
        abcp_adjustments_field_date: 'Booking date',
        abcp_adjustments_field_date_hint: 'Defaults to the balance sheet date. Can be moved within the fiscal year.',
        abcp_adjustments_error_date_invalid: 'Please enter a valid date.',
        abcp_adjustments_error_date_outside_year: 'The booking date must lie within the closing´s fiscal year.',
        abcp_adjustments_transfer_all_released: 'Transfer all released',
    abcp_adjustments_state_released_hint: 'Entered and released — not yet transferred to the ERP.',
    abcp_adjustments_state_transferred: 'Transferred',
    abcp_adjustments_state_transferred_hint: 'Transferred to the ERP — not yet confirmed in the booking journal.',
    abcp_adjustments_state_booked: 'Booked',
    abcp_adjustments_state_booked_hint: 'Found again in the imported journal of the ERP.',
    abcp_adjustments_source_user: 'User',
    abcp_adjustments_source_agent: 'Agent',
    abcp_adjustments_source_prior_year: 'PY',
    abcp_adjustments_ambiguous: 'Ambiguous',
    abcp_adjustments_ambiguous_hint: 'Several journal lines match — nothing is guessed. Please pick the right one on the detail view.',
    abcp_adjustments_ambiguity_title: 'Ambiguous journal match',
    abcp_adjustments_ambiguity_hint: 'Several journal lines agree on debit, credit, amount and fiscal year. Pick the line that proves this correction — nothing is guessed.',
    abcp_adjustments_ambiguity_confirm: 'Use this line as proof',
    abcp_adjustments_transfer_erp: 'Send directly to the ERP',
    abcp_adjustments_transfer_erp_hint: 'The accounting system has a write interface',
    abcp_adjustments_transfer_manual: 'Mark as booked manually',
    abcp_adjustments_transfer_manual_hint: 'Already entered directly in the ERP',
    abcp_adjustments_transfer_reason_no_write_api: 'The connected accounting system has no write interface. Use the CSV export.',
    abcp_adjustments_transfer_reason_not_connected: 'No accounting system is connected for this mandate. Use the CSV export.',
    abcp_adjustments_transfer_reason_reauth: 'The connection to the accounting system has to be renewed.',
    abcp_adjustments_transfer_reason_unavailable: 'The accounting system is currently unreachable.',
    abcp_adjustments_transfer_reason_no_caller_context: 'Transferring to the ERP is not possible on this path. Use the CSV export.',
    abcp_adjustments_transfer_reason_vendor_rejected: 'The accounting system rejected this entry.',
    abcp_adjustments_result_provisional: 'Provisional result for the year',
    abcp_adjustments_result_provisional_hint: '· before correction entries',
    abcp_adjustments_result_after: 'Result for the year after correction entries',
    abcp_adjustments_result_impact: 'Effect of result-relevant corrections',
    abcp_adjustments_total: 'Total correction entries',
    abcp_adjustments_total_year: 'Total FY {{year}}',
    abcp_adjustments_unclassified_note: '{{count}} correction entr(ies) affect an account that is not assigned to a position yet — they count towards the total but not towards the result effect.',
    abcp_adjustments_empty: 'No correction entries available.',
    abcp_adjustments_empty_year: 'No correction entries in FY {{year}}.',
    abcp_adjustments_no_hits: 'No correction entry matches “{{term}}”.',
    abcp_adjustments_error: 'The correction entries could not be loaded.',
    abcp_adjustments_search_hits: '{{count}} match(es) for “{{term}}”',
    abcp_adjustments_search_reset: 'Reset search',
    abcp_adjustments_modal_create_title: 'New correction entry',
    abcp_adjustments_modal_edit_title: 'Edit correction entry',
    abcp_adjustments_modal_account: 'Account',
    abcp_adjustments_modal_submit: 'Create entry',
    abcp_adjustments_modal_save: 'Save',
    abcp_adjustments_modal_cancel: 'Cancel',
    abcp_adjustments_modal_no_accounts: 'This closing has no chart of accounts yet. Refresh the accounting data first.',
    abcp_adjustments_field_text: 'Description',
    abcp_adjustments_field_text_placeholder: 'e.g. bank charges Q4',
    abcp_adjustments_field_debit: 'Debit account',
    abcp_adjustments_field_credit: 'Credit account',
    abcp_adjustments_field_amount: 'Amount',
    abcp_adjustments_field_owner: 'Assignment (account)',
    abcp_adjustments_field_owner_auto: 'Automatic (debit)',
    abcp_adjustments_field_choose: 'Choose',
    abcp_adjustments_field_remark: 'Remarks',
    abcp_adjustments_field_remark_placeholder: 'Optional remark on the correction entry.',
    abcp_adjustments_field_vat: 'VAT',
    abcp_adjustments_preview: 'Entry',
    abcp_adjustments_preview_against: 'to',
    abcp_adjustments_detail_back: 'Back',
    abcp_adjustments_transfer_progress_title: 'ERP transfer',
    abcp_adjustments_transfer_progress_connection: 'Connection to the ERP',
    abcp_adjustments_transfer_progress_sending: 'Transferring {{count}} correction(s)',
    abcp_adjustments_proof_pending: 'Proof of posting follows with “Refresh ERP”.',
    abcp_adjustments_open_count: '{{count}} open',
    abcp_adjustments_account_empty: 'No correction entries for FY {{year}}.',
    abcp_adjustments_error_same_accounts: 'The debit and credit account must not be identical.',
    abcp_adjustments_error_not_open: 'Only open correction entries can be edited or discarded.',
    abcp_adjustments_error_not_found: 'This correction entry is not available.',
    abcp_adjustments_error_discarded: 'This correction entry has been discarded.',
    abcp_adjustments_error_not_ambiguous: 'There is no outstanding choice for this correction entry.',
    abcp_adjustments_error_candidate_unknown: 'This journal line is not among the candidates that were found.',
    abcp_adjustments_error_proof_taken: 'This journal line already proves another correction entry.',
    abcp_adjustments_error_prior_year: 'This fiscal year cannot be edited.',
    abcp_adjustments_error_accounts_equal: 'The debit and credit account must not be identical.',
    abcp_adjustments_error_account_unknown: 'This account is not part of the closing’s chart of accounts.',
    abcp_adjustments_error_amount: 'The amount must be greater than zero.',
    abcp_adjustments_error_text: 'The description must not be empty.',
    abcp_adjustments_error_no_connection: 'No accounting system is connected for this mandate. Use the CSV export.',
    abcp_adjustments_error_connection_ambiguous: 'Several accounting systems are connected for this mandate, so a direct transfer is not possible.',
    // REV-21367 — ABCP document hub (abcp-documents-hub). Must mirror de-CH key for key:
    // `fallbackLng` is de-CH, so a missing key here pulls German prose into the English UI.
    abcp_documents_filter_inbox: 'Inbox',
    abcp_documents_filter_assigned: 'Filed',
    abcp_documents_filter_not_relevant: 'Not relevant',
    abcp_documents_col_filename: 'Document name',
    abcp_documents_col_account: 'Account',
    abcp_documents_col_confidence: 'Document type',
    abcp_documents_col_confidence_hint: 'The document type detected by the AI – not a judgement on the account choice.',
    abcp_documents_col_date: 'Date',
    abcp_documents_col_source: 'Source',
    abcp_documents_col_status: 'Status',
    abcp_documents_status_open: 'Open',
    abcp_documents_status_proposed: 'Proposal',
    abcp_documents_status_assigned: 'Assigned',
    abcp_documents_source_upload: 'Upload',
    abcp_documents_source_sharepoint: 'Sharepoint',
    abcp_documents_source_email: 'E-mail',
    abcp_documents_search_placeholder: 'Search all documents…',
    abcp_documents_upload: 'Upload',
    abcp_documents_sync_now: 'Sync now',
    abcp_documents_sync_settings: 'Settings',
    // REV-21376 — the modal shell only; the REV-21057 container inside it is unchanged.
    abcp_documents_sharepoint_modal_title: 'SharePoint folders',
    abcp_documents_sharepoint_modal_close: 'Close',
    abcp_documents_sync_disconnected: 'Not connected',
    abcp_documents_account_select: 'Select account',
    abcp_documents_project_file: 'Project file',
    abcp_documents_picker_search_placeholder: 'Account no. or name…',
    abcp_documents_picker_project_file: 'General · Project file',
    abcp_documents_picker_project_file_hint: 'AGM minutes, letter of completeness, contracts',
    abcp_documents_picker_empty: 'No account found',
    abcp_documents_picker_assignment: 'Assignment',
    abcp_documents_picker_back: 'Back',
    abcp_documents_validity_closing: 'This annual closing only',
    abcp_documents_validity_closing_hint: 'The document concerns the current financial year only',
    abcp_documents_validity_long_term_hint: 'Contracts, leases, loans — stays current across several years',
    abcp_documents_validity_long_term_option: 'Valid long term',
    abcp_documents_proposal_accept: 'Confirm',
    abcp_documents_proposal_reject: 'Reject',
    abcp_documents_not_relevant_mark: 'Not relevant for this closing — the document is kept',
    abcp_documents_not_relevant_restore: 'Mark as relevant for this closing again',
    abcp_documents_drop_title: 'Drop documents here',
    abcp_documents_drop_hint: 'PDF only · multiple files supported',
    abcp_documents_validity_long_term: 'Permanent file — valid long term',
    abcp_documents_empty: 'No documents in this filter.',
    abcp_documents_uploading: 'Uploading …',
    abcp_documents_error: 'Documents could not be loaded.',
    abcp_documents_agent_notice_title: 'Automatically assigned.',
    abcp_documents_agent_filter: 'Automatically assigned in this view',
    abcp_documents_proposal_error: 'That failed — please try again.',
    abcp_documents_proposal_pending: 'Processing…',
    // REV-22302 — what the AI is doing with a document: the working indicator and its steps, the two
    // findings with their reasons, the picker action beside them, and the recognised Belegart.
    abcp_documents_ai_working: 'AI is reading the document …',
    abcp_documents_ai_step_reading: 'Reading the text',
    abcp_documents_ai_step_kind: 'Detecting the document type',
    abcp_documents_ai_step_scan: 'Checking the file',
    abcp_documents_ai_step_value: 'Reading the balance',
    abcp_documents_proposal_source_content: 'Proposed from the content',
    abcp_documents_proposal_source_balance: 'Proposed from the balance',
    abcp_documents_proposal_source_both: 'Content and balance agree',
    abcp_documents_proposal_balance_matches: 'Balance matches',
    abcp_documents_proposal_balance_differs: 'Balance does not match',
    abcp_documents_proposal_balance_not_checked: 'Balance not checked',
    abcp_documents_no_proposal: 'No suggestion',
    abcp_documents_not_readable: 'Not readable',
    abcp_documents_account_choose: 'Choose account',
    abcp_documents_refusal_no_bound_account: 'No account in the chart of accounts is linked to this document type.',
    abcp_documents_refusal_accounts_unclassified: 'The matching accounts are not classified yet.',
    abcp_documents_refusal_ambiguous: 'Several accounts could match – please choose one.',
    abcp_documents_refusal_no_candidate: 'No account matches the name on the document – please choose one.',
    abcp_documents_refusal_name_out_of_cut: 'The name on the document points to an account outside the matching ones – please choose one.',
    abcp_documents_refusal_name_unavailable: 'The name comparison could not be run – please choose one.',
    abcp_documents_refusal_unclassified: 'The AI could not detect the document type.',
    abcp_documents_refusal_no_text: 'No readable text was found in the document.',
    abcp_documents_refusal_model_unparseable: 'The AI’s answer could not be evaluated.',
    abcp_documents_refusal_integrity_fail: 'The document could not be read without errors.',
    abcp_documents_refusal_not_extracted: 'The document had not been read yet when the AI looked for an account.',
    abcp_documents_refusal_unknown: 'The AI did not suggest an account.',
    abcp_documents_refusal_rejected: 'The AI’s suggestion was rejected.',
    abcp_documents_kind_bank_statement: 'Bank statement',
    abcp_documents_kind_securities_depot_statement: 'Securities depot statement',
    abcp_documents_kind_open_items_list: 'Open items list',
    // Kinds the classifier no longer returns keep their labels above, unused.
    abcp_documents_kind_bank_interest_capital_statement: 'Interest / capital statement',
    abcp_documents_kind_bank_confirmation: 'Bank confirmation',
    abcp_documents_kind_bank_other: 'Other bank document',
    abcp_documents_kind_cash_closing: 'Cash closing',
    abcp_documents_kind_cash_in_transit_other: 'Cash-in-transit document',
    abcp_documents_kind_securities_other: 'Other securities document',
    abcp_documents_kind_customer_balance_confirmation: 'Customer balance confirmation',
    abcp_documents_kind_receivables_other: 'Other receivables document',
    abcp_documents_kind_allowance_calculation: 'Allowance calculation',
    abcp_documents_date_warning: 'Note: document as of {{balanceDate}}, closing as of {{balanceSheetDate}}',
    // REV-21368 — ABCP-Einzeldokument (abcp-document-detail). Flache Keys wie beim
    // Schwester-Pure-View abcp_documents_*. Bewusst EIGENE Keys statt Wiederverwendung, wo der
    // Prototyp der Einzelseite anders beschriftet als der Hub: 'Akzeptieren' statt 'Bestätigen',
    // 'Klasse' statt 'Kl.', 'Nur dieser Abschluss' statt 'Nur dieser Jahresabschluss'.
    // Umkehrbar geteilt bleiben abcp_documents_not_relevant_mark/_restore und _proposal_reject.
    abcp_document_detail_close: 'Back',
    abcp_document_detail_splitter: 'Resize document and sidebar',
    abcp_document_detail_not_relevant_mark: 'Not relevant',
    abcp_document_detail_not_relevant_restore: 'Mark as relevant',
    abcp_document_detail_not_relevant_title: 'This document is not relevant.',
    abcp_document_detail_not_relevant_body: 'Mark it as relevant so you can assign it to an account.',
    abcp_document_detail_write_error: 'That did not work. Try again.',
    abcp_documents_dialog_close: 'Close',
    abcp_document_detail_proposal_title: 'Agent proposal',
    abcp_document_detail_proposal_accept: 'Accept',
    abcp_document_detail_assigned_title: 'Assigned',
    abcp_document_detail_assigned_remove: 'Remove assignment',
    abcp_document_detail_picker_title: 'Assign account',
    abcp_document_detail_picker_counter: '{{matched}} of {{total}}',
    abcp_document_detail_picker_search_placeholder: 'Account no., name or account group…',
    abcp_document_detail_picker_empty: 'No accounts found.',
    abcp_document_detail_project_file: 'Project file',
    abcp_document_detail_project_file_hint: 'General project documents',
    abcp_document_detail_validity_title: 'Validity',
    abcp_document_detail_validity_closing: 'This closing only',
    abcp_document_detail_validity_long_term: 'Long term',
    abcp_document_detail_interpretation_title: 'Document value',
    abcp_document_interpretation_reason_quote_not_in_document: 'The quoted line was not found in the document.',
    abcp_document_quote: '“{{quote}}”',
    abcp_document_quote_line: 'page {{page}}, line {{line}}',
    abcp_document_detail_interpretation_sentence: '{{amount}} as of {{asOfDate}} — derived from the {{asOfDate}} row',
    abcp_document_detail_interpretation_sentence_neutral: '{{amount}} as of {{asOfDate}}',
    abcp_document_detail_interpretation_interpreting: 'Interpretation in progress',
    abcp_document_detail_interpretation_no_value: 'Interpreted, no amount',
    abcp_document_detail_interpretation_none: 'Not interpreted',
    abcp_document_detail_interpretation_disabled: 'Interpretation disabled for this organisation',
    abcp_document_detail_value_balance: 'Balance',
    abcp_document_detail_value_market_value: 'Market value',
    abcp_document_detail_value_cost: 'Cost',
    abcp_document_detail_value_as_of: 'as of {{date}}',
    abcp_document_detail_document_date: 'Document date: {{date}}',
    // REV-22010 — the AI pipeline's document feedback: reading state, interpretation reason, proposal refusal, hub banner.
    abcp_document_reading_title: 'AI reading',
    abcp_document_reading_read: 'Read by the AI',
    abcp_document_reading_state_pending: 'Not yet read by the AI',
    abcp_document_reading_state_reading: 'Being read by the AI',
    abcp_document_reading_state_deferred_daily_cap: 'Daily limit reached – will be read tomorrow',
    abcp_document_reading_state_failed: 'The AI could not read this document',
    abcp_document_reading_state_not_supported: 'Format not read by the AI (PDF only)',
    abcp_document_reading_quality_structure_fail: 'Page structure not captured completely',
    abcp_document_reading_quality_findings: '{{count}} finding(s) while reading',
    abcp_document_detail_interpretation_limit_reached: 'Interpretation paused',
    abcp_document_interpretation_reason_not_enabled: 'Document interpretation is not enabled in the AI settings.',
    abcp_document_interpretation_reason_limit_reached: 'The organisation\'s AI token limit has been reached.',
    abcp_document_interpretation_reason_closing_has_no_balance_sheet_date: 'The closing has no balance sheet date yet.',
    abcp_document_interpretation_reason_reading_unusable: 'The read version of the document is incomplete.',
    abcp_document_interpretation_reason_model_answer_unusable: 'The AI\'s answer did not pass the checks.',
    abcp_document_interpretation_reason_kind_not_supported: 'There is no interpretation rule for this document type.',
    abcp_document_interpretation_reason_no_booking_owner: 'The document is not assigned to an account.',
    abcp_document_interpretation_reason_statement_dates_unreadable: 'The statement dates (opening/closing balance) cannot be read.',
    abcp_document_interpretation_reason_statement_ends_before_balance_sheet_date: 'The statement ends before the balance sheet date.',
    abcp_document_interpretation_reason_amount_unreadable: 'The amount or currency cannot be read unambiguously.',
    abcp_document_proposal_refusal_title: 'No account suggestion',
    abcp_document_proposal_refusal_no_account_for_kind: 'No account in the chart of accounts is linked to this document type.',
    abcp_document_proposal_refusal_accounts_not_classified: 'The matching accounts are not classified yet.',
    abcp_document_proposal_refusal_several_accounts_match: 'Several accounts could match – please choose one.',
    abcp_documents_ai_disabled_mapping: 'AI document mapping is not enabled for your organisation. Documents get no account suggestion.',
    abcp_documents_ai_disabled_interpretation: 'AI document interpretation is not enabled for your organisation. Documents get no document value.',
    abcp_documents_ai_disabled_both: 'AI document mapping and interpretation are not enabled for your organisation.',
    abcp_documents_ai_disabled_action: 'Open AI settings',
    abcp_documents_ai_disabled_contact_admin: 'Your administrator can switch the AI on in the organisation settings.',
    abcp_document_preview_unsupported: 'There is no preview for this file format.',
    abcp_document_preview_unsupported_hint: 'The document is filed in the closing unchanged.',
    abcp_document_preview_missing: 'Preview not available yet.',
    abcp_document_preview_missing_hint: 'The document is being checked and will appear here afterwards.',
    abcp_document_detail_error: 'Document could not be loaded.',    // REV-21361 — account detail shell (abcp-account-workspace)
    // REV-21363 — geteilte Vorschau (abcp-document-preview), Konto-Dokumentbereich
    // (abcp-account-documents) und geteiltes Upload-Modal (abcp-upload-modal). Flache Keys wie bei
    // den Schwester-Pure-Views. Der Augen-Tooltip des Konto-Bereichs ist bewusst KEIN eigener Key:
    // er teilt sich abcp_documents_not_relevant_mark mit Hub und Einzelseite — gleiche Handlung,
    // gleicher Satz. ⚠️ Die Modal-Copy sagt PDF, nicht "PDF oder Bild": der Ingest ist PDF-only
    // (ADR-0009 §12), der Prototyp ist an dieser Stelle überholt.
    abcp_document_preview_error: 'The preview could not be loaded.',
    // REV-21369 — the document viewer (ADR-0021).
    abcp_pdf_viewer_loading: 'Loading document …',
    abcp_pdf_viewer_error: 'The document could not be displayed.',
    abcp_pdf_viewer_page_of: 'Page {{page}} of {{total}}',
    abcp_pdf_viewer_prev_page: 'Previous page',
    abcp_pdf_viewer_next_page: 'Next page',
    abcp_pdf_viewer_zoom_in: 'Zoom in',
    abcp_pdf_viewer_zoom_out: 'Zoom out',
    abcp_pdf_viewer_fit_width: 'Fit width',
    abcp_pdf_viewer_mode: 'Highlight',
    abcp_pdf_viewer_mode_text: 'Text',
    abcp_pdf_viewer_mode_area: 'Area',
    abcp_pdf_viewer_download: 'Download',
    abcp_pdf_viewer_mark_action: 'Comment',
    abcp_pdf_viewer_highlight: 'Open highlight',
    abcp_pdf_viewer_highlight_ai: 'Open AI highlight',
    abcp_pdf_viewer_notes_title: 'Comments on this document',
    abcp_pdf_viewer_area_selection: 'Highlighted area · page {{page}}',
    abcp_pdf_viewer_content_error: 'The document could not be loaded.',
    abcp_account_documents_error: 'The documents could not be loaded.',
    abcp_account_documents_upload: 'Upload document',
    abcp_account_documents_dropzone_title: 'Drag files here',
    abcp_account_documents_dropzone_or: 'or',
    abcp_account_documents_dropzone_pick: 'Select files',
    abcp_upload_modal_title: 'Upload documents',
    abcp_upload_modal_close: 'Close',
    abcp_upload_modal_dropzone: 'Drag files here',
    abcp_upload_modal_hint: 'PDF only · max. {{max}}',
    abcp_upload_modal_pick: 'Select files',
    abcp_upload_modal_selected: 'Selected files',
    abcp_upload_modal_remove: 'Remove from selection',
    abcp_upload_modal_rejected_type: 'Not a PDF — will not be uploaded.',
    abcp_upload_modal_rejected_size: 'Too large (max. {{max}}) — will not be uploaded.',
    abcp_upload_modal_failures: 'Not uploaded',
    abcp_upload_modal_progress: 'Uploading documents…',
    abcp_upload_modal_cancel: 'Cancel',
    abcp_upload_modal_submit: 'Upload documents',
    abcp_workspace_pane_kind_ledger: 'Account ledger',
    abcp_workspace_pane_kind_documents: 'Documents',
    abcp_workspace_pane_kind_comments: 'Comments',
    abcp_workspace_pane_kind_todos: 'Open items',
    abcp_workspace_pane_kind_adjustments: 'Adjusting entries',
    abcp_workspace_pane_kind_activity_log: 'Activity log',
    abcp_workspace_document_balance: 'Document',
    abcp_workspace_ai_as_of: 'as of {{date}}',
    abcp_workspace_ai_refused: 'No value read',
    abcp_workspace_ai_open: 'No value yet',
    abcp_workspace_ai_reconciling: 'Reconciling …',
    abcp_workspace_ai_reconciling_step: 'The closing run checks the account',
    abcp_workspace_ai_not_used: 'Document read, but not used for the closing',
    abcp_workspace_ai_open_missing: 'Document missing: {{kind}}',
    abcp_workspace_ai_open_date_mismatch: 'Document date does not match: {{kind}}',
    abcp_workspace_ai_open_value_pending: 'Value not read yet: {{kind}}',
    // The line under the status chip on the account card.
    abcp_workspace_reason_document_missing: 'Document missing: {{kind}}',
    abcp_workspace_reason_document_being_read: 'Reading the document …',
    abcp_workspace_reason_document_unreadable: 'The value could not be read, please enter it by hand',
    abcp_workspace_reason_document_date_mismatch: 'Document date does not match: {{date}} instead of {{balanceSheetDate}} (document {{amount}})',
    abcp_workspace_reason_proofs_contradict: 'Documents contradict each other: {{list}}',
    abcp_workspace_reason_transit_not_balanced: 'Cash in transit not balanced: {{amount}}',
    abcp_workspace_reason_reconciled_with_document: 'Reconciled with {{kind}} as of {{date}}',
    abcp_workspace_reason_reconciled_with_document_market_value: 'Reconciled with {{kind}} as of {{date}} (market value)',
    abcp_workspace_reason_reconciled_with_document_cost: 'Reconciled with {{kind}} as of {{date}} (cost)',
    // REV-22005 — the hand-entered document balance and the account-state write refusals. TOP-level
    // on purpose: the account page translates the backend messageKey with a bare `t(key)`.
    abcp_workspace_document_balance_manual: 'entered manually',
    abcp_error_review_flag_invalid: 'Please enter a reason (at most 500 characters).',
    abcp_error_document_balance_invalid: 'The document balance is invalid.',
    abcp_error_document_balance_currency_mismatch: 'The document balance must be in the currency of the closing.',
    abcp_error_closing_currency_missing: 'This closing has no currency. Set it in the settings first.',
    abcp_error_account_state_unknown_account: 'This account is not part of this closing.',
    abcp_error_account_state_write_failed: 'The change could not be saved. Please try again later.',
    abcp_workspace_pane_add: 'Add pane',
    abcp_workspace_pane_empty: 'There is no content for this pane yet.',
    abcp_workspace_review_mark: 'Mark for review',
    abcp_workspace_review_marked: 'Marked for review',
    abcp_workspace_back: 'Back',
    abcp_workspace_amount: 'Amount',
    abcp_workspace_reference: 'Reference',
    abcp_workspace_confirm: 'Confirm',
    abcp_workspace_cancel: 'Cancel',
    abcp_workspace_error: 'The account details could not be loaded.',
    abcp_workspace_error_not_found: 'Account not found.',
    abcp_workspace_review_dialog_title: 'Mark for review',
    abcp_workspace_review_dialog_account: 'Account {{number}} · {{name}}',
    abcp_workspace_review_dialog_question: 'What should the reviewer check?',
    abcp_workspace_review_dialog_placeholder:
        'e.g. document missing — request it externally or is it acceptable? Please countersign the position.',
    abcp_workspace_review_dialog_hint:
        'The comment appears directly on the account for the reviewer. The processing status stays unchanged.',
    abcp_workspace_review_dialog_confirm: 'Mark',
    // REV-21366 — ABCP activity log (pure view)
    abcp_activity_count: 'Activity',
    abcp_activity_count_plural: 'Activities',
    abcp_activity_actor_unknown: 'Unknown',
    // REV-21869 (#165, Runde 7) — the author of a TRAIL line. The wire carries no actor field,
    // but the author is known: the run. Deliberately not "AI agent" — deterministic tools write
    // trail lines just as GenAI steps do (B2-8), and the line does not know which it was.
    abcp_activity_actor_agent: 'Automated run',
    abcp_activity_load_more: 'Load more',
    abcp_activity_empty: 'No activities available.',
    abcp_activity_error: 'Activities could not be loaded.',
    // REV-21365 — account pane "Kommentare" (abcp-account-notes, ADR-0019).
    // ⚠️ German UI labels stay German on purpose: Intern, Abschlussbesprechung, Mandant and
    // Pendenz are what the screen actually says, and a test asserting on them has to match.
    aumico_abcp_notes_count: 'comment',
    aumico_abcp_notes_count_plural: 'comments',
    aumico_abcp_notes_empty: 'No comments yet.',
    aumico_abcp_notes_error: 'Comments could not be loaded.',
    aumico_abcp_notes_author_unknown: 'Unbekannt',
    aumico_abcp_notes_actions: 'Actions',
    // Die beiden Beschriftungen des Erledigt-Knopfes in der Detailansicht. Sie sagen, was
    // der Klick TUT, nicht wie der Zustand heißt — „Erledigt“ an einer offenen Pendenz liest
    // sich wie eine Behauptung ueber den Zustand statt wie eine Handlung.
    aumico_abcp_notes_done: 'Mark as done',
    aumico_abcp_notes_reopen: 'Reopen',
    aumico_abcp_notes_edit: 'Edit',
    aumico_abcp_notes_delete: 'Delete',
    aumico_abcp_notes_delete_confirm: 'Really delete this comment?',
    aumico_abcp_notes_save: 'Save',
    aumico_abcp_notes_cancel: 'Cancel',
    aumico_abcp_notes_send: 'Send',
    aumico_abcp_notes_compose: 'New entry',
    aumico_abcp_notes_tag_internal: 'Intern',
    aumico_abcp_notes_tag_internal_hint: 'Internal note — visible to all staff',
    aumico_abcp_notes_tag_closingmeeting: 'Abschlussbesprechung',
    aumico_abcp_notes_tag_todo: 'To-Do',
    aumico_abcp_notes_tag_reviewer: 'Reviewer',
    aumico_abcp_notes_tag_client: 'Mandant',
    aumico_abcp_notes_source_account: 'Account',
    aumico_abcp_notes_source_document: 'Document',
    aumico_abcp_notes_source_mandate: 'Client',
    aumico_abcp_notes_source_agent: 'Agent',
    aumico_abcp_notes_replies: 'reply',
    aumico_abcp_notes_replies_plural: 'replies',
    aumico_abcp_notes_reply_placeholder: 'Reply…',
    aumico_abcp_notes_reply_open: 'Reply',
    aumico_abcp_notes_placeholder_comment: 'Write a comment…',
    aumico_abcp_notes_account_todos_empty_open: 'No open items on this account.',
    aumico_abcp_notes_account_todos_empty_done: 'No completed open items on this account.',
    aumico_abcp_notes_anchor_open: 'Show the highlighted spot',
    aumico_abcp_notes_mention_hint: '@ to mention',
    // REV-21369 — area highlight in a document: no quote, so the page.
    aumico_abcp_notes_anchor_area: 'Highlighted area · page {{page}}',
    // REV-21372/21373 — the two overviews and the detail view.
    // ⚠️ German UI labels stay German on purpose where the screen says them.
    aumico_abcp_notes_overview_comments: 'comment',
    aumico_abcp_notes_overview_comments_plural: 'comments',
    aumico_abcp_notes_overview_todos: 'pendency',
    aumico_abcp_notes_overview_todos_plural: 'pendencies',
    aumico_abcp_notes_export: 'Export',
    aumico_abcp_notes_retry: 'Try again',
    aumico_abcp_notes_filter_all: 'Alle',
    aumico_abcp_notes_filter_open: 'Offen',
    aumico_abcp_notes_filter_done: 'Erledigt',
    aumico_abcp_notes_filter_remove: 'Remove filter',
    aumico_abcp_notes_filters_reset: 'Zurücksetzen',
    aumico_abcp_notes_search_hits: 'hit',
    aumico_abcp_notes_search_hits_plural: 'hits',
    aumico_abcp_notes_search_reset: 'Back to the full list',
    aumico_abcp_notes_done_toggle: 'Mark as done',
    aumico_abcp_notes_col_comment: 'Kommentar',
    aumico_abcp_notes_col_todo: 'Pendenz',
    aumico_abcp_notes_col_classification: 'Klassifizierung',
    aumico_abcp_notes_col_audience: 'Zielgruppe',
    aumico_abcp_notes_col_account: 'Konto',
    aumico_abcp_notes_col_author: 'Von',
    aumico_abcp_notes_col_created: 'Erstellt',
    aumico_abcp_notes_col_due: 'Fällig',
    aumico_abcp_notes_overview_empty_comments: 'There are no comments for this closing yet.',
    aumico_abcp_notes_overview_empty_todos: 'There are no pendencies for this closing yet.',
    aumico_abcp_notes_overview_no_match: 'No entries match this selection.',
    aumico_abcp_notes_overview_error: 'The list could not be loaded.',
    aumico_abcp_notes_detail_back: 'Zurück',
    aumico_abcp_notes_detail_missing: 'This entry does not exist (any more).',
    aumico_abcp_notes_detail_error: 'The entry could not be loaded.',
    aumico_abcp_notes_detail_field_description: 'Description',
    aumico_abcp_notes_detail_field_text: 'Text',
    aumico_abcp_notes_detail_field_tags: 'Klassifizierung',
    aumico_abcp_notes_detail_field_due: 'Fällig',
    aumico_abcp_notes_detail_field_assignee: 'Zugewiesen an',
    aumico_abcp_notes_detail_field_status: 'Status',
    // REV-21372/21373 — prototype alignment.
    aumico_abcp_notes_new_todo: 'Pendenz',
    aumico_abcp_notes_todo_save_failed: 'The Pendenz could not be saved.',
    aumico_abcp_notes_export_current: 'Export current view',
    aumico_abcp_notes_export_print: 'Print view',
    // REV-21372 — export menu and create form.
    aumico_abcp_notes_export_positions: 'position.',
    aumico_abcp_notes_export_positions_plural: 'positions.',
    aumico_abcp_notes_export_print_hint: 'The print view is not part of this increment.',
    aumico_abcp_notes_field_account: 'Konto (optional)',
    aumico_abcp_notes_field_due_optional: 'Fällig (optional)',
    aumico_abcp_notes_field_assignee_optional: 'Zugewiesen an (optional)',
    aumico_abcp_notes_overdue: 'overdue',
    aumico_abcp_notes_done_notice: 'Done — the entry now sits under "Erledigt".',
    aumico_abcp_notes_detail_history: 'History',
    aumico_abcp_notes_detail_no_replies: 'No replies yet.',
    aumico_abcp_notes_search_hits_comments: '{{count}} comment for "{{term}}"',
    aumico_abcp_notes_search_hits_comments_plural: '{{count}} comments for "{{term}}"',
    aumico_abcp_notes_search_hits_todos: '{{count}} pendency for "{{term}}"',
    aumico_abcp_notes_search_hits_todos_plural: '{{count}} pendencies for "{{term}}"',
    aumico_abcp_notes_audience_todo: 'Sachbearbeiter',
    aumico_abcp_notes_audience_reviewer: 'Reviewer',
    aumico_abcp_notes_audience_client: 'Mandant',
    abcp_activity_planned: 'Run planned, not yet executed.',
    // REV-21360 — ABCP closing workspace header (pure view)
    aumico_abcp_header_erp_never: 'never synchronised',
    aumico_abcp_header_erp_refresh: 'Refresh ERP',
    aumico_abcp_header_tab_accounts: 'Accounts',
    aumico_abcp_header_tab_documents: 'Documents',
    aumico_abcp_header_tab_adjustments: 'Adjusting entries',
    aumico_abcp_header_tab_open_items: 'Open items',
    aumico_abcp_header_tab_comments: 'Comments',
    aumico_abcp_header_crumb_account: 'Account {{number}}',
    aumico_abcp_header_search_accounts: 'Search all accounts…',
    aumico_abcp_header_search_documents: 'Search all documents…',
    aumico_abcp_header_search_adjustments: 'Search all entries…',
    aumico_abcp_header_search_open_items: 'Search all open items…',
    aumico_abcp_header_search_comments: 'Search all comments…',
    aumico_abcp_header_error: 'The closing data could not be loaded.',    // REV-21057 — SharePoint "Ordner hinzufügen" (aumico-integration-sharepoint-folders)
    aumico_integration_sharepoint_title: 'Add folder',
    aumico_integration_sharepoint_description:
        'Connect your Microsoft 365 account to select folders from SharePoint or OneDrive for the closing. aumico gets read-only access.',
    aumico_integration_sharepoint_connect: 'Connect with Microsoft 365',
    aumico_integration_sharepoint_connecting: 'Connecting …',
    aumico_integration_sharepoint_connected_banner: 'Connected',
    aumico_integration_sharepoint_read_only: 'read-only access',
    aumico_integration_sharepoint_include_subfolders: 'incl. subfolders',
    aumico_integration_sharepoint_add_folder: 'Add folder',
    aumico_integration_sharepoint_add_folder_hint: 'Add the folder that holds the documents for this closing.',
    aumico_integration_sharepoint_remove: 'Remove',
    aumico_integration_sharepoint_error: 'Connecting to Microsoft 365 failed. Please try again.',
    aumico_integration_sharepoint_no_site: 'No SharePoint was found for this Microsoft account. Check that the account has a SharePoint licence, or connect a different account.',
    aumico_integration_sharepoint_expired: 'The Microsoft 365 connection has expired. Please sign in again.',
    aumico_integration_sharepoint_provider_sharepoint_label: 'SharePoint',
    aumico_integration_sharepoint_provider_sharepoint_desc: 'Folders from SharePoint / OneDrive',
    aumico_integration_sharepoint_provider_google_drive_label: 'Google Drive',
    aumico_integration_sharepoint_provider_google_drive_desc: 'Folders from Google Drive',
    aumico_integration_sharepoint_provider_manual_upload_label: 'Manual upload',
    aumico_integration_sharepoint_provider_manual_upload_desc: 'Upload files directly',
    // REV-21057 — in-app pre-consent card (aumico-rendered, shown before the Microsoft popup)
    aumico_integration_sharepoint_consent_heading: 'aumico would like to access Microsoft 365',
    aumico_integration_sharepoint_consent_permissions_label: 'Requested permission',
    aumico_integration_sharepoint_consent_permission_files_read: 'Read files',
    aumico_integration_sharepoint_consent_permission_files_read_desc:
        'aumico only reads. Nothing is ever written back to Microsoft 365, changed or deleted.',
    aumico_integration_sharepoint_consent_permission_sites_read: 'Read SharePoint sites and folders',
    aumico_integration_sharepoint_consent_footnote:
        'You will sign in to Microsoft in the next step. Only folders your account is already allowed to see will be visible.',
    aumico_integration_sharepoint_consent_allow: 'Allow access',
    aumico_integration_sharepoint_consent_cancel: 'Cancel',
    // REV-21860 — SharePoint as an integration card in Org Settings -> Integrations.
    aumico_integration_sharepoint_displayname: 'SharePoint',
    aumico_integration_sharepoint_card_description: 'Use documents from SharePoint and OneDrive in your closings.',
    aumico_integration_sharepoint_displayname_help: 'Optional. Left blank, aumico names the connection after the Microsoft tenant.',
    aumico_integration_sharepoint_connect_modal_title: 'Connect SharePoint',
    aumico_integration_sharepoint_connect_intro: 'Sign in with a Microsoft work account to give aumico read access to SharePoint and OneDrive.',
    aumico_integration_sharepoint_connect_button: 'Connect with Microsoft 365',
    aumico_integration_sharepoint_awaiting_consent: 'Waiting for confirmation in the Microsoft window …',
    aumico_integration_sharepoint_manage_modal_title: 'SharePoint connections',
    aumico_integration_sharepoint_manage_empty: 'No SharePoint connection yet.',
    aumico_integration_sharepoint_manage_add_button: 'Add another connection',
    aumico_integration_sharepoint_manage_disconnect_button: 'Disconnect',
    aumico_integration_sharepoint_manage_connected_at: 'Connected since',
    aumico_integration_sharepoint_manage_disconnect_confirm_title: 'Really disconnect SharePoint?',
    aumico_integration_sharepoint_manage_disconnect_confirm_text: 'The connection is deleted. Closings whose folders point at this connection can no longer sync documents.',

    /**
     * REV-21960 / REV-21357 — the ABCP keys, NESTED. See the German file for WHY nested.
     *
     * Present in full rather than left to the fallback: `fallbackLng` is `de-CH`, so a missing key
     * here would pull German prose into an English UI.
     */
    abcp: {
        // Structure rows of the balance sheet and income statement: group headings, totals, subtotals.
        statementLayout: {
            section: '{{heading}} in {{currency}}',
            incomeStatement: 'Income statement',
            incomeStatementSection: 'Income statement in {{currency}}',
            assets: 'Assets',
            assetsTotal: 'Total assets',
            currentAssetsTotal: 'Total current assets',
            nonCurrentAssetsTotal: 'Total non-current assets',
            liabilitiesAndEquity: 'Liabilities and equity',
            liabilitiesAndEquityTotal: 'Total liabilities and equity',
            liabilitiesTotal: 'Total liabilities',
            currentLiabilitiesTotal: 'Total current liabilities',
            nonCurrentLiabilitiesTotal: 'Total non-current liabilities',
            equityTotal: 'Total equity',
            operatingRevenueTotal: 'Total operating revenue',
            materialExpenseTotal: 'Total cost of materials and goods',
            grossProfit: 'Gross profit',
            personnelExpenseTotal: 'Total personnel expenses',
            otherOperatingExpenseTotal: 'Total other operating expenses',
            ebitda: 'Operating result before depreciation, financial result and taxes (EBITDA)',
            ebit: 'Operating result before financial result and taxes (EBIT)',
            financialResultTotal: 'Total financial result',
            ancillaryResultTotal: 'Total ancillary operating result',
            operatingResult: 'Operating result',
            nonOperatingResultTotal: 'Total non-operating and extraordinary result',
            resultBeforeTaxes: 'Result before taxes',
            result: 'Result for the year',
        },
        // REV-21354 — the Setup-Wizard. `wizardStep` are its SCREENS, `import` the banner that follows.
        setup: {
            alreadyRunning: 'A setup is already running for this closing. Wait until it has finished.',
            review: {
                restartWarning: 'This closing has already been set up. If you changed the accounting or document source, the setup runs again from the start — a review already in progress is discarded and restarted.',
            },
            hero: {
                title: 'Start the year-end closing',
                featureAccounts: 'Reconcile accounts',
                featureDocuments: 'Assign documents',
                featureCompliance: 'CO compliance',
                // REV-22096 — the prototype's start page: first-time CTA, the «Setup anpassen» gear and the meta line.
                cta: 'Set up & start the closing',
                settings: 'Adjust setup',
                button: 'Set up & start the closing',
            },
            cancel: 'Cancel',
            back: 'Back',
            next: 'Next',
            accounting: {
                title: 'Accounting data',
                apiTitle: 'API connection',
                fileTitle: 'Excel file (.xlsx)',
                fileDesc: 'Upload the trial balance as an Excel file.',
                // REV-22007 — the file route (ADR-0020): upload panel, preview and refusal.
                filePick: 'Choose file',
                fileReplace: 'Choose another file',
                fileTemplate: 'Download template',
                fileUploading: 'Checking file …',
                fileAccounts: '{{count}} accounts',
                fileDifference: 'Difference CHF {{difference}}',
                fileWarnings: 'Notes',
                fileRefused: 'The file was not accepted.',
                // The accounting step: the company's ERP, read-only, and the two years the start loads.
                noErp: 'No ERP is connected for this company.',
                connectedBadge: 'Connected',
                managedInOrg: 'Managed in the organisation settings',
                managedInCompany: 'Managed in the company details',
                setupInSettings: 'Set up in the settings',
                soon: 'Coming soon',
                yearsTitle: 'Loaded',
                yearPeriod: '{{start}} - {{end}}',
                currencyTitle: 'Currency of the closing',
                currencyPlaceholder: 'Choose a currency',
            },
            documents: {
                title: 'Connect closing folders',
                lead: 'Where are the receipts, contracts and bank statements for this closing? You can connect several folders — the system pulls files from all of them.',
                manualTitle: 'Manual upload',
                manualDesc: 'Documents are uploaded during the closing.',
                // i18next 19: the singular is the bare key, the plural `_plural`.
                fileCount: '{{count}} file',
                fileCount_plural: '{{count}} files',
                withSubfolders: 'incl. subfolders',
            },
            start: {
                button: 'Start',
            },
            // REV-22527 — the import after the start, as a banner over the overview.
            import: {
                title: 'Your year-end closing is being prepared',
                doneTitle: 'All set',
                failedTitle: 'The import did not finish',
                retry: 'Try again',
                rowAccounting: 'Accounting data',
                rowDocuments: 'Documents from SharePoint',
                accountingDone: '{{year}} and {{prior}} loaded',
                accountingDoneOne: '{{year}} loaded',
                interrupted: 'The import was interrupted. Start it again.',
                locked: 'Waiting for the accounting data',
            },
            wizardStep: {
                ACCOUNTING: 'Accounting',
                DOCUMENTS: 'Documents',
            },
        },
        // REV-22007 — the trial-balance file import (ADR-0020): refusals, scan states and the re-import dialog.
        fileImport: {
            notAWorkbook: 'The file is not a readable Excel workbook.',
            tooLargeUnzipped: 'The file is too large when unpacked.',
            missingColumn: 'The required column “{{column}}” is missing.',
            invalidAccountNumber: 'Account number “{{account}}” is invalid.',
            duplicateAccount: 'Account number {{account}} appears twice.',
            missingName: 'Name is missing.',
            nameTooLong: 'Name longer than {{max}} characters.',
            invalidAmount: 'Amount in column “{{column}}” is not a number.',
            tooManyAccounts: 'More than {{max}} accounts.',
            noAccounts: 'The file contains no accounts.',
            unbalanced: 'The trial balance does not balance: difference CHF {{- difference}}.',
            openingUnbalanced: 'Opening balances do not balance: difference CHF {{- difference}}.',
            rowWithoutAccount: 'Row without account number skipped (subtotal or total).',
            row: 'Row {{row}}: {{- message}}',
            refusedRows: 'The file contains {{count}} invalid rows:',
            tooLarge: 'The file is larger than 5 MB.',
            wrongType: 'Only Excel files (.xlsx) are accepted.',
            uploadFailed: 'The file could not be uploaded. Please try again.',
            fileNotFound: 'The accounting file was not found.',
            scanPending: 'The file is still being virus-scanned.',
            quarantined: 'The file was blocked by the virus scanner.',
            scanFailed: 'The virus scan of the file failed.',
            storeFailed: 'The file could not be stored.',
            scanTimeout: 'The virus scan took too long. Please retry.',
            dialog: {
                title: 'Update trial balance',
                lead: 'Upload the updated trial balance.',
                period: 'Period: {{period}}',
                replaceNote: 'Importing replaces this closing’s balances with the file’s.',
                cancel: 'Cancel',
                confirm: 'Import',
            },
        },
        // REV-22476 — the annual closing overview.
        overview: {
            title: 'Annual closing {{year}}',
            subtitle: 'What is to do in this closing — from the accounts in the journal, step by step.',
            soon: 'Coming soon',
            open: 'Open',
            or: 'or',
            accounts: '{{count}} account',
            accounts_plural: '{{count}} accounts',
            masterData: {
                title: 'Check master data',
                text: 'Chart of accounts and client context apply to the company — captured once, confirmed every fiscal year.',
                complete: 'Every account has a position',
                withoutPosition: '{{count}} account without a position',
                withoutPosition_plural: '{{count}} accounts without a position',
                withoutFunction: '{{count}} account without a function:',
                withoutFunction_plural: '{{count}} accounts without a function:',
                mandateContext: 'Client context',
                mandateContextText: 'What the agents need to know about the company',
            },
            opening: {
                title: 'Opening analysis',
                text: 'The agents first check whether the bookkeeping is a sound basis.',
                openingBalance: 'Opening balance matches the prior year',
                vatRates: 'VAT rates',
                bookingPlausibility: 'Plausibility of bookings',
                profitAllocation: "Prior year's profit allocation booked",
            },
            documents: {
                title: 'Assign documents',
                text: 'The agent checks every document, assigns it to the accounts and shows which proofs are still missing for the closing.',
                open: 'Open document inbox',
                missing: '{{kinds}} missing',
                none: 'No account is missing a proof.',
                waiting: 'Waiting for the chart of accounts.',
            },
            balanceSheet: {
                title: 'Reconcile balance sheet accounts',
                text: 'Every position of the balance sheet is reconciled against its proofs.',
                open: 'Open balance sheet reconciliation',
                position: 'Position',
                balance: 'Balance',
                reconciled: 'Reconciled',
                none: 'No balance sheet accounts yet.',
            },
            incomeStatement: {
                title: 'Check the income statement',
                text: 'Explain key figures and changes against the prior year before the closing is reviewed.',
                open: 'Open income statement',
            },
            closing: {
                title: 'Closing',
            },
        },
        // REV-22479 — the chart of accounts.
        chartOfAccounts: {
            title: 'Chart of accounts',
            intro: 'Every account needs a position. Once all of them have one, the annual closing opens.',
            columnNumber: 'No.',
            columnName: 'Name',
            columnPosition: 'Position',
            columnFunction: 'Function',
            pickPosition: 'Choose a position',
            pickFunction: 'Choose a function',
            search: 'Search …',
            change: 'Change',
            cancel: 'Back without a change',
            saveError: 'Not saved — please choose again.',
            loadError: 'The accounts could not be loaded.',
            empty: 'This closing has no accounts yet. They arrive with the ERP sync.',
            aiWorkingNotice: 'AI is assigning the accounts …',
            aiWorkingPosition: 'AI is assigning the position …',
            aiWorkingFunction: 'AI is determining the function …',
            aiWorkingCount: '{{count}} assignments in progress',
            locked: 'Available once every account in the chart of accounts has a position.',
            function: {
                BANK: 'Bank',
                CASH: 'Cash',
                CASH_IN_TRANSIT: 'Cash in transit',
                SHORT_TERM_SECURITIES: 'Securities',
                TRADE_RECEIVABLES: 'Trade receivables',
                ALLOWANCE_TRADE_RECEIVABLES: 'Allowance for doubtful accounts',
                // Posting targets of the parked booking proposals — labelled so no raw key ever shows.
                FX_RESULT: 'Exchange differences',
                SHORT_TERM_DEBT: 'Short-term financial liabilities',
                ADVANCE_PAYMENTS_RECEIVED: 'Advance payments received',
                ACCRUED_INCOME: 'Prepaid expenses and accrued income',
                DEFERRED_INCOME: 'Accrued expenses and deferred income',
                BAD_DEBT_EXPENSE: 'Bad debt expense',
                CASH_DIFFERENCE: 'Cash differences',
                INTEREST_INCOME: 'Interest income',
                INTEREST_EXPENSE: 'Interest expense',
                BANK_CHARGE_EXPENSE: 'Bank charges',
            },
        },
        accountSurface: {
            position: {
                CURRENT_ASSETS_LIQUID: 'Cash and cash equivalents',
                CURRENT_ASSETS_MARKETABLE_SECURITIES: 'Marketable securities (short-term)',
                CURRENT_ASSETS_RECEIVABLES: 'Trade receivables',
                CURRENT_ASSETS_OTHER_RECEIVABLES: 'Other short-term receivables',
                CURRENT_ASSETS_INVENTORIES: 'Inventories and unbilled services',
                CURRENT_ASSETS_PREPAID_EXPENSES: 'Prepaid expenses and accrued income',
                NON_CURRENT_ASSETS_FINANCIAL: 'Financial assets',
                NON_CURRENT_ASSETS_INVESTMENTS: 'Investments',
                NON_CURRENT_ASSETS_TANGIBLE: 'Tangible fixed assets',
                NON_CURRENT_ASSETS_INTANGIBLE: 'Intangible assets',
                NON_CURRENT_ASSETS_UNPAID_CAPITAL: 'Unpaid capital',
                CURRENT_LIABILITIES_TRADE_PAYABLES: 'Trade payables',
                CURRENT_LIABILITIES_INTEREST_BEARING: 'Short-term interest-bearing liabilities',
                CURRENT_LIABILITIES_OTHER: 'Other short-term liabilities',
                CURRENT_LIABILITIES_ACCRUED: 'Accrued liabilities and deferred income',
                NON_CURRENT_LIABILITIES: 'Long-term liabilities',
                NON_CURRENT_LIABILITIES_PROVISIONS: 'Provisions',
                EQUITY_SHARE_CAPITAL: 'Share, partner or foundation capital',
                EQUITY_LEGAL_CAPITAL_RESERVE: 'Statutory capital reserve',
                EQUITY_LEGAL_RETAINED_RESERVE: 'Statutory retained-earnings reserve',
                EQUITY_VOLUNTARY_RETAINED_RESERVE: 'Voluntary retained-earnings reserves',
                EQUITY_RESULT_FOR_THE_YEAR: 'Profit or loss for the year',
                EQUITY_TREASURY_SHARES: 'Treasury shares',
                // The finer income-statement positions (KMU-Kontenrahmen).
                INCOME_STATEMENT_PRODUCTION_REVENUE: 'Revenue from production',
                INCOME_STATEMENT_TRADE_REVENUE: 'Revenue from trading goods',
                INCOME_STATEMENT_SERVICE_REVENUE: 'Revenue from services',
                INCOME_STATEMENT_OTHER_REVENUE: 'Other revenue from sales and services',
                INCOME_STATEMENT_OWN_WORK_CAPITALISED: 'Own work and own consumption',
                INCOME_STATEMENT_REVENUE_DEDUCTIONS: 'Revenue deductions',
                INCOME_STATEMENT_INVENTORY_CHANGES: 'Changes in inventories of unfinished and finished products and of unbilled services',
                INCOME_STATEMENT_MATERIAL_EXPENSE: 'Cost of materials',
                INCOME_STATEMENT_GOODS_EXPENSE: 'Cost of trading goods',
                INCOME_STATEMENT_THIRD_PARTY_SERVICES: 'Cost of purchased services',
                INCOME_STATEMENT_PRODUCTION_ENERGY: 'Energy costs of production',
                INCOME_STATEMENT_PURCHASE_DEDUCTIONS: 'Purchase deductions',
                INCOME_STATEMENT_WAGES: 'Wages and salaries',
                INCOME_STATEMENT_SOCIAL_SECURITY: 'Social security costs',
                INCOME_STATEMENT_OTHER_PERSONNEL: 'Other personnel expenses',
                INCOME_STATEMENT_TEMPORARY_STAFF: 'Work performed by third parties',
                INCOME_STATEMENT_PREMISES: 'Premises expenses',
                INCOME_STATEMENT_MAINTENANCE: 'Maintenance, repairs, replacements and leasing of movable fixed assets',
                INCOME_STATEMENT_VEHICLES: 'Vehicle and transport expenses',
                INCOME_STATEMENT_INSURANCE_FEES: 'Property insurance, duties, fees and permits',
                INCOME_STATEMENT_ENERGY_DISPOSAL: 'Energy and waste disposal expenses',
                INCOME_STATEMENT_ADMINISTRATION: 'Administrative expenses',
                INCOME_STATEMENT_IT: 'IT expenses',
                INCOME_STATEMENT_ADVERTISING: 'Advertising expenses',
                INCOME_STATEMENT_OTHER_OPERATING: 'Miscellaneous operating expenses',
                INCOME_STATEMENT_DEPRECIATION: 'Depreciation, amortisation and value adjustments on non-current assets',
                INCOME_STATEMENT_FINANCIAL_EXPENSE: 'Financial expenses',
                INCOME_STATEMENT_FINANCIAL_INCOME: 'Financial income',
                INCOME_STATEMENT_ANCILLARY_OPERATIONS: 'Result from ancillary operations',
                INCOME_STATEMENT_OPERATING_PROPERTY: 'Result from operating property',
                INCOME_STATEMENT_NON_OPERATING: 'Non-operating expenses and income',
                INCOME_STATEMENT_EXTRAORDINARY: 'Extraordinary, non-recurring or prior-period expenses and income',
                INCOME_STATEMENT_DIRECT_TAXES: 'Direct taxes',
                // Old class keys, still sent by a backend without the finer positions.
                INCOME_STATEMENT_OPERATING_REVENUE: 'Operating revenue',
                INCOME_STATEMENT_COST_OF_MATERIALS: 'Cost of materials and goods',
                INCOME_STATEMENT_PERSONNEL_EXPENSE: 'Personnel expense',
                INCOME_STATEMENT_OTHER_OPERATING_EXPENSE: 'Other operating expense',
                INCOME_STATEMENT_ANCILLARY_RESULT: 'Result of ancillary operations',
                INCOME_STATEMENT_NON_OPERATING_AND_TAX: 'Non-operating, extraordinary result and taxes',
                INCOME_STATEMENT_CLOSING: 'Closing accounts',
            },
            navBalanceSheet: 'Reconcile balance sheet accounts',
            navIncomeStatement: 'Check the income statement',
            syncCompaniesNotLoaded: 'The company data has not loaded yet. Please wait a moment and try again.',
            syncNoConnection: 'This client has no active ERP connection.',
            syncNoContext: 'No client or no project in context — the ERP pull cannot start.',
            PROJECT_PERIOD_MISSING: 'The project has neither a period nor a balance-sheet date to derive one from.',
            PROJECT_NOT_FOUND: 'This project could not be found.',
            CONNECTION_REQUIRED: 'This vendor needs a connection and a vendor-side client.',
            VENDOR_PERIOD_NOT_FOUND: 'The vendor has no fiscal year matching this period.',
            erpRightsMissing: 'The ERP refuses access to currency or VAT data. Please check the read permissions of the aumico app in the ERP — the ERP connection itself stays active.',
            abcp_error_mandate_data_unavailable: 'The request failed. Please try again later.',
            abcp_error_account_binding_invalid: 'The assignment was refused.',
            abcp_error_mandate_not_found: 'This closing could not be found.',
            columnPercent: '%',
            columnDeltaAbsolute: 'Δ absolute',
            chip: {
                zeroAccounts: 'Zero accounts',
                all: 'All',
                open: 'Open',
                marked: 'Flagged',
                reconciled: 'Reconciled',
                difference: 'Difference',
            },
            columnCurrentPlain: 'Balance',
            columnPriorPlain: 'Prior year',
            syncRunningTitle: 'Fetching data',
            syncRunningSubtitle: 'Postings and accounts are being loaded from the ERP.',
            syncRunningHint: 'With several periods this can take a moment. Please keep this window open.',
            syncDoneTitle: 'Sync complete',
            syncDoneAll: 'Done — every requested period was fetched.',
            syncDonePartly: 'Done, but one comparison period could not be fetched.',
            syncDoneClose: 'Close',
            syncDonePeriod: 'Period',
            syncDoneAccounts: 'Accounts in the ERP',
            syncDoneJournalOnly: 'Journal only',
            syncDoneStatesCreated: 'Newly created',
            syncDoneVatUnreadable: 'The VAT code is missing for {{count}} document(s): the ERP did not hand them over (deleted, or not readable for the aumico app). All other data is loaded.',
            syncDoneComparisons: 'Comparison periods',
            syncTitle: 'ERP sync',
            syncIntro: 'Fetches this closing\'s postings from the ERP.',
            syncOwnHeading: 'Current period',
            syncOwnPeriod: 'This fiscal year: {{range}}',
            syncHeldHeading: 'Already stored',
            syncHeldHint:
                'These periods are already stored and are not fetched again — they may belong to a closing that is finished.',
            syncFetchHeading: 'Load prior years',
            syncTagWillFetch: 'will be updated',
            syncTagHeld: 'stored',
            syncMaxPeriodsReached:
                'Five periods are stored — the income statement shows no more. There is nothing left to fetch.',
            syncNothingHeldYet:
                'The first sync fetches only the current period. Comparison periods can be added afterwards.',
            syncNoRowsChosen: 'No comparison period chosen.',
            syncFrom: 'From',
            syncTo: 'To',
            syncAddPeriod: 'Add period',
            syncMaxRowsReached: 'At most five fiscal years are possible, including this one.',
            syncRemovePeriod: 'Remove',
            syncIncompleteRow: 'Please give both From and To for every period.',
            syncStart: 'Start sync',
            syncCancel: 'Cancel',
            syncOutcome: {
                FILLED: 'fetched',
                ALREADY_PRESENT: 'already present',
                FAILED: 'failed',
            },
            comparisonYears: 'Further years:',
            comparisonPeriodMissing:
                'No journal exists for {{periods}} yet. Run the ERP sync to fetch that period.',
            unpositionedNotice:
                'These accounts have no position yet and are not shown: {{accounts}}. Assign them in the chart of accounts to show them.',
            zeroAccountsLocked: 'Assign the {{n}} zero accounts in the chart of accounts first.',
            toggle: {
                percentOfRevenue: '% of operating revenue',
                priorYearComparison: 'Prior-year comparison',
            },
            unassignedGroup: 'Without a position',
            unassignedBanner: '{{count}} accounts have no position',
            classificationRunning: "The AI is assigning this closing's accounts — {{open}} of {{total}} still open",
            classificationOverdue:
                'The assignment has been outstanding for over ten minutes. Please run the ERP sync again.',
            classificationDone: 'Assignment complete — every account is assigned to a position',
            unassignedBannerAction: 'Assign now',
            assignTitle: 'Assign account',
            assignPositionLabel: 'Position',
            assignPositionPlaceholder: 'Choose a position',
            assignSkip: 'Skip',
            assignSave: 'Save',
            assignProgress: 'Account {{index}} of {{total}}',
            assignDone: 'Every account has a position.',
            columnCurrent: 'Balance {{year}}',
            columnPrior: 'Balance {{year}}',
            columnDelta: 'Δ%',
        },
        /**
         * REV-21378 — the HUMAN half of the activity log (`abcp_closing_activity`).
         *
         * Its own namespace beside `trail:`, not an addition to it: the trail carries the keys the RUN
         * sends, this block the ones an `aumico-be` write path sends. Two sources, two vocabularies.
         *
         * ⚠️ These must stay in step with `de-CH.ts`: `fallbackLng` is `de-CH`, so a key missing here
         * pulls German prose into an English UI.
         */
        activity: {
            // REV-22005 — review flag and hand-entered document balance (N-2.2, N-3.5).
            reviewFlagged: 'Marked for review',
            reviewUnflagged: 'Review mark removed',
            documentBalanceEntered: 'Document balance entered manually',
            documentBalanceCleared: 'Document balance removed',
            documentBalanceConflict: 'Manually entered document balance kept – the AI run did not overwrite it',
            evidenceAssigned: '{{count}} document(s) assigned',
            evidenceAssignedDetail: 'Assigned by a person',
            evidenceUnassigned: 'Assignment removed',
            classificationChanged: 'Account classification changed',
            classificationChangedDetail: 'New group: {{group}}',
            statusChanged: 'Status changed',
            statusChangedDetail: 'New status: {{to}}',
            erpSynced: 'ERP sync touched this account',
            // REV-21375/REV-21378 — die Korrekturbuchung, auf beiden berührten Konten.
            adjustmentBooked: 'Correction booking entered',
            adjustmentDiscarded: 'Correction booking discarded',
            adjustmentTransferred: 'Correction booking transferred to the ERP',
            adjustmentEdited: 'Correction booking changed',
            orComplianceChecked: 'OR compliance checked',
            // REV-21374 — comments and pendencies in the activity log. See the German file for
            // why the entry's own text is deliberately absent.
            // ⚠️ The excerpt is privileged client content — see the German file and SRR F3.
            // The delete lines carry none, on purpose.
            commentFiled: 'Comment added: “{{excerpt}}”',
            commentEdited: 'Comment edited: “{{excerpt}}”',
            commentDeleted: 'Comment deleted',
            commentReplied: 'Replied to a comment: “{{excerpt}}”',
            todoFiled: 'Pendency added: “{{excerpt}}”',
            todoEdited: 'Pendency edited: “{{excerpt}}”',
            todoDeleted: 'Pendency deleted',
            todoReplied: 'Replied to a pendency: “{{excerpt}}”',
            todoCompleted: 'Pendency completed: “{{excerpt}}”',
            todoReopened: 'Pendency reopened: “{{excerpt}}”',
        },
        trail: {
            // The lines a per-account run writes.
            runStarted: 'Reconciliation started: {{trigger}}',
            documentRead: '{{kind}} read: {{amount}} as of {{date}}',
            documentUnreadable: '{{kind}}: the value could not be read',
            compared: 'Compared with the accounting: {{outcome}}',
            runFailed: 'Reconciliation failed, nothing was changed',
            // REV-22005 — a run found hand-entered document balances and kept them (N-3.5).
            manualDocumentBalanceKept: '{{count}} manually entered document balance(s) kept',
            runPlanned: '{{units}} work units planned across {{positions}} position(s)',
            unitBlocked: 'Step blocked: {{code}}',
            fixtureMode: 'WARNING fixture mode ({{mode}}): this run computes on invented test data, not on mandate data',
            positionStarted: 'Position {{positionId}} started (rule pack {{rulePackId}} {{version}})',
            journalAnalysed: 'Ledger analysed: {{accounts}} accounts read',
            evidenceAssigned: '{{documents}} documents assigned ({{perAccount}} per account)',
            engineDispatched: 'Engine {{entry}} dispatched',
            differenceDetected: 'Difference found on {{accountName}}',
            findingIdentified: 'Cause classified on {{accountName}}',
            proposalsGenerated: '{{proposals}} booking proposal(s) created for {{accountName}}',
            previewStatus: 'Preview for {{accountName}}',
            reconciled: 'Document reconciled against balance: {{accountName}}',
            baseCurrencyDefaulted: 'Base currency defaulted ({{currency}})',
            accountStateWriteFailed: 'Account state could not be written back',
            // REV-21869 (#165, Runde 3 / SRR F4) — `position.executor.ts:120,166,197`, no account.
            runAborted: 'Run aborted: {{reason}}',
            // REV-21378 — the three steps the action catalogue names that no executor emits YET
            // (`ACTIVITY_ACTIONS.pendingWritePath`). Translated ahead of the write path on purpose: a
            // key that arrives before its text renders as itself, on screen, and the run that first
            // emits it is not the place to discover that.
            trusteeAsked: 'Query raised with the trustee',
            orComplianceChecked: 'OR compliance checked',
            statusChanged: 'Status changed: {{status}}',
            // REV-21869 (#165, Runde 3 / SRR F4) — `position.executor.ts:144`, no account.
            positionNotImplemented: 'There is no rule pack yet for position {{positionId}}',
            // REV-21869 (#165, Runde 7) — the mark a REFUSED trail entry leaves in its place
            // (`orchestrator/run-trail.writer.ts:172`). Its only param, `codes`, holds the names
            // of the violated write rules and is deliberately NOT interpolated: those are source
            // identifiers, not an answer for a trustee.
            entryRefused: 'A log entry could not be saved at this point',
            detail: {
                unbookedBankCharges: 'Unbooked bank charges',
            },
        },
        block: {
            unresolvedAccountGroup: 'No account resolves for position {{positionId}} — the ABCP account surface does not exist yet',
            fixtureRunBlocked: 'The fixture run was blocked ({{code}})',
            noFixturePosition: 'There is no fixture set for position {{positionId}}',
        },
        catalog: {
            engineReconciliation: 'Reconciliation',
            engineValuation: 'Valuation',
            toolBalanceAggregation: 'Balance aggregation',
            toolOpenItemMatching: 'Open-item matching',
            toolMateriality: 'Materiality',
            toolFxBazg: 'FX rates (BAZG)',
            toolAgingBuckets: 'Ageing buckets',
            toolDerivationBuilder: 'Derivation',
            toolBookingProposalBuilder: 'Booking proposal',
            genaiAccountGroupClassifier: 'Account-group classification',
            genaiRootCauseAnalysis: 'Root-cause analysis',
            gateFinal: 'Final check',
        },
    },

    // Outbound Partner-API clients (REV-21638)
    aumico_outbound_api_section_title: 'Outbound API Integration',
    aumico_outbound_api_section_description: 'Create credentials that let external tools pull data from aumico. The secret is shown only once — store it safely.',
    aumico_outbound_api_create_button: 'Create new credentials',
    aumico_outbound_api_status_revoked: 'Revoked',
    aumico_outbound_api_scopes_label_long: 'Permissions (scopes)',
    aumico_outbound_api_scope_read_organization: 'Read organisation and users',
    aumico_outbound_api_scope_read_companies: 'Read companies',
    aumico_outbound_api_scope_read_financials: 'Read balance sheets and income statements',
    aumico_outbound_api_scope_write_mappings: 'Write mandate mappings',
    aumico_outbound_api_create_modal_title: 'New API credentials',
    aumico_outbound_api_name_label: 'Name',
    aumico_outbound_api_name_placeholder: 'e.g. PowerBI export',
    aumico_outbound_api_create_submit: 'Create',
    aumico_outbound_api_secret_modal_title: 'Your credentials',
    aumico_outbound_api_secret_warning: 'The client secret is shown only now and cannot be retrieved later. Copy it and store it safely.',
    aumico_outbound_api_client_id_label: 'Client ID',
    aumico_outbound_api_client_secret_label: 'Client secret',
    aumico_outbound_api_copy: 'Copy',
    aumico_outbound_api_copied: 'Copied',
    aumico_outbound_api_done: 'Done',
    aumico_outbound_api_created_label: 'Created on',
    aumico_outbound_api_rotated_label: 'Secret last rotated',
    aumico_outbound_api_rotate_button: 'Rotate secret',
    aumico_outbound_api_revoke_button: 'Revoke',
    aumico_outbound_api_revoke_confirm_title: 'Revoke credentials?',
    aumico_outbound_api_revoke_confirm_text: 'Access ends immediately: every token issued with these credentials becomes invalid. This cannot be undone.',
    aumico_outbound_api_revoke_confirm_button: 'Revoke permanently',
    aumico_outbound_api_error_generic: 'That did not work. Please try again.',
    aumico_partner_connect_section_title: 'Partner apps',
    aumico_partner_connect_section_description:
        'Connect aumico with partner apps. The connection applies to your whole organisation and can be severed here at any time.',
    aumico_partner_connect_status_connected: 'Connected',
    aumico_partner_connect_status_not_connected: 'Not connected',
    aumico_partner_connect_connect_button: 'Connect {{partner}}',
    aumico_partner_connect_disconnect_button: 'Disconnect',
    aumico_partner_connect_disconnect_confirm_text:
        'Access ends immediately: every token of this connection becomes invalid. Existing mandate mappings are kept.',
    aumico_partner_connect_disconnect_confirm_button: 'Disconnect permanently',
    aumico_oauth_authorize_loading: 'Checking the request …',
    aumico_oauth_authorize_redirecting: 'Redirecting …',
    aumico_oauth_authorize_consent_title: 'Connect {{clientName}}',
    aumico_oauth_authorize_consent_extension_title: '{{clientName}} needs additional permissions',
    aumico_oauth_authorize_consent_text: '{{clientName}} will get access for your whole organisation to:',
    aumico_oauth_authorize_approve_button: 'Allow',
    aumico_oauth_authorize_deny_button: 'Deny',
    aumico_oauth_authorize_not_admin_title: 'Administrator rights required',
    aumico_oauth_authorize_not_admin_text:
        'Only an administrator of your organisation can connect {{clientName}}. Ask your administrator to set up the connection.',
    aumico_oauth_authorize_error_title: 'Connection not possible',
    aumico_oauth_authorize_error_invalid_request: 'The request is incomplete or invalid. Restart the connection from the partner app.',
    aumico_oauth_authorize_error_unknown_client: 'aumico does not know this app. No connection was made.',
    aumico_oauth_authorize_error_redirect_uri: "The app's return address is not registered. No connection was made.",
    aumico_oauth_authorize_error_invalid_scope: 'The app requests permissions it is not entitled to. No connection was made.',
    aumico_oauth_authorize_error_generic: 'Something went wrong. Restart the connection from the partner app.',
    aumico_oauth_authorize_footnote: 'After confirming you will be taken back to the partner app. The connection can be severed anytime under Organisation settings → Integrations.',
    aumico_partner_connect_card_description: 'Partner app with organisation-wide access via the aumico Partner API.',
    aumico_partner_connect_card_description_aprivo:
        'Aprivo keeps mandates in sync with aumico and reads balance sheets and income statements straight from your annual reports.',
    aumico_partner_connect_modal_status_label: 'Status',
    aumico_partner_connect_modal_text:
        '{{partner}} gets access to your organisation via the Partner API — within the scope of the permissions below. The connection can be severed here at any time.',
    aumico_partner_connect_modal_text_aprivo:
        'Aprivo gets access to your organisation to keep mandates in sync with aumico and to read balance sheets and income statements straight from your annual reports — within the scope of the permissions below. The connection can be severed here at any time.',
    aumico_partner_connect_disconnect_confirm_title: 'Sever connection?',
    aumico_outbound_api_card_description: 'API credentials an external tool uses to read data from aumico.',
};
